// Operations pages (Business plane) i18n dictionary — STATIC UI CHROME ONLY.
// Split-out module merged into the flat per-language lookup in translations.js (same t() semantics,
// English default + fallback). Covers: Staff Management, Tickets Manager, Escalation Manager,
// Manage Operators, and the Ticket Management page header. Keys are identical across all 10
// languages. Never used for dynamic/backend/user content. {placeholders} are interpolated by t().

const opsTranslations = {
  en: {
    "ops.common.missingInformation": "Missing Information",
    "ops.common.fillAllRequired": "Please fill in all required fields",
    "ops.common.tryAgain": "Try Again",
    "ops.common.customer": "Customer",
    "ops.common.unassigned": "Unassigned",
    "ops.common.aiAgent": "AI Agent",
    "ops.common.status": "Status",
    "ops.common.priority": "Priority",
    "ops.common.assignedTo": "Assigned To",
    "ops.common.pending": "Pending",
    "ops.common.resolved": "Resolved",
    "ops.common.resolve": "Resolve",
    "ops.common.assign": "Assign",
    "ops.common.view": "View",
    "ops.common.inProgress": "In Progress",
    "ops.common.you": "You",
    "ops.common.system": "System",
    "ops.common.agent": "Agent",
    "ops.common.cannotCall": "Cannot Call",
    "ops.common.callInitiated": "Call Initiated",
    "ops.common.callLogged": "Call Logged",
    "ops.common.calling": "Calling",
    "ops.common.callRecordedFor": "Call recorded for",
    "ops.common.callFailed": "Call Failed",
    "ops.common.callNow": "Call Now",
    "ops.common.startingCall": "Starting Call…",
    "ops.esc.noConvForCallback": "No conversation available for this callback",
    "ops.esc.cbDueSoon": "Due Soon",
    "ops.esc.cbOverdue": "Overdue",
    "ops.esc.cbScheduled": "Scheduled",
    "ops.esc.cbCompleted": "Completed",
    "ops.esc.cbCancelled": "Cancelled",
    "ops.esc.cbReminderTitle": "Callback reminder",
    "ops.esc.cbDueSoonMsg": "Callback due soon",
    "ops.common.describeResolution": "Describe how this issue was resolved...",
    "ops.common.selectOperator": "Select operator…",
    "ops.common.nameLabel": "Name:",
    "ops.common.emailLabel": "Email:",
    "ops.staff.subscriptionPlan": "Subscription Plan",
    "ops.staff.seatAllocation": "seat allocation",
    "ops.staff.inviteStaffMembers": "Invite Staff Members",
    "ops.staff.inviteDescPre": "Invite staff members by email — each person receives a branded invitation with your Brand ID",
    "ops.staff.inviteDescMid": "and a link to complete self-registration at",
    "ops.staff.inviteExpire": "Invitations expire after 7 days.",
    "ops.staff.emailAddresses": "Email Addresses",
    "ops.staff.emailsPlaceholder": "Enter email addresses separated by commas, semicolons, or new lines:",
    "ops.staff.validEmailsDetected": "{count} valid email(s) detected",
    "ops.staff.defaultRole": "Default Role",
    "ops.staff.defaultRoleHelp": "All invited staff will be assigned this role by default",
    "ops.staff.invitationPreview": "Invitation Preview",
    "ops.staff.operatorDefault": "Operator (Default)",
    "ops.staff.sendingInvitations": "Sending Invitations…",
    "ops.staff.sendInvitations": "Send {count} Invitation(s)",
    "ops.staff.operatorFirstNotice": "New team members join as Operators. An Administrator or Manager can assign another role after onboarding. Any role in an imported file is ignored.",
    "ops.staff.importCsv": "Import CSV",
    "ops.staff.previewInvites": "Preview",
    "ops.staff.previewing": "Previewing…",
    "ops.staff.csvFormatHelp": "CSV columns: name, email (a role column, if present, is ignored). The first row may be a header.",
    "ops.staff.csvRoleIgnoredNotice": "A role column was found in your file and was ignored — everyone joins as an Operator.",
    "ops.staff.csvNoValidRows": "No valid rows",
    "ops.staff.csvNoValidRowsDesc": "The file contained no valid email addresses.",
    "ops.staff.csvReadFailed": "Could not read the selected file.",
    "ops.staff.previewFailed": "Could not preview invitations. Please try again.",
    "ops.staff.previewResults": "Preview — {count} row(s)",
    "ops.staff.previewNonMutating": "Preview only — no invitations are created until you send.",
    "ops.staff.colName": "Name",
    "ops.staff.colEmail": "Email",
    "ops.staff.colJoinsAs": "Joins as",
    "ops.staff.colOutcome": "Outcome",
    "ops.staff.outcomeEligible": "Will invite",
    "ops.staff.outcomeAlreadyStaff": "Already staff",
    "ops.staff.outcomePending": "Invite pending",
    "ops.staff.outcomeDuplicate": "Duplicate in file",
    "ops.staff.outcomeInvalidEmail": "Invalid email",
    "ops.staff.outcomeInvalidRole": "Not allowed",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "{count} Team Members",
    "ops.staff.totalStaff": "Total Staff",
    "ops.staff.administrators": "Administrators",
    "ops.staff.operators": "Operators",
    "ops.staff.otherRoles": "Other Roles",
    "ops.staff.teamMembers": "Team Members",
    "ops.staff.membersCount": "{count} members",
    "ops.staff.noTeamMembers": "No Team Members",
    "ops.staff.noTeamMembersHelp": "Invite staff members to join your business team",
    "ops.staff.inviteFirst": "Invite First Staff Member",
    "ops.staff.changeRole": "Change Role",
    "ops.staff.removeStaff": "Remove Staff",
    "ops.staff.regInstructions": "Staff Registration Instructions",
    "ops.staff.forNewStaff": "For new staff members:",
    "ops.staff.shareBrandId": "Share your Brand ID:",
    "ops.staff.directToReg": "Direct them to the Staff Registration page",
    "ops.staff.assignedOperatorDefault": "They will be assigned \"Operator\" role by default",
    "ops.staff.updateRoleDropdown": "You can update their role using the dropdown above",
    "ops.staff.registrationLink": "Registration Link:",
    "ops.staff.changeRoleDesc": "Update the role for {name}.",
    "ops.staff.thisStaffMember": "this staff member",
    "ops.staff.saving": "Saving…",
    "ops.staff.saveRole": "Save Role",
    "ops.staff.removeStaffMember": "Remove Staff Member",
    "ops.staff.removeWarning": "This will immediately revoke all business access for this staff member.",
    "ops.staff.securityImpact": "Security Impact:",
    "ops.staff.impact1": "will lose ALL business access immediately",
    "ops.staff.impact2a": "Their staff account will be",
    "ops.staff.impact2b": "deactivated",
    "ops.staff.impact2c": "and their phone released from this business",
    "ops.staff.impact3": "All previous business conversations will be secured and inaccessible",
    "ops.staff.impact4": "They cannot access any staff profiles or business data",
    "ops.staff.staffDetails": "Staff Details:",
    "ops.staff.currentRole": "Current Role:",
    "ops.staff.joinDate": "Join Date:",
    "ops.staff.noteLabel": "Note:",
    "ops.staff.removeNote": "This action cannot be undone. If you want to re-add this person later, they will need a new invitation and role assignment.",
    "ops.staff.removeRevoke": "Remove & Revoke Access",
    "ops.staff.descAdmin": "Full access to all features and staff management",
    "ops.staff.descOperator": "Customer service, ticket management, communications",
    "ops.staff.descManager": "Team oversight, reporting, SolutionBank management",
    "ops.staff.descAnalyst": "Data analysis, reporting, performance metrics",
    "ops.staff.descDirector": "Strategic planning, high-level analytics",
    "ops.staff.descExecutive": "Business oversight, executive dashboards",
    "ops.staff.descIt": "Technical management, system configuration",
    "ops.staff.enterOneEmail": "Please enter at least one email address",
    "ops.staff.invalidEmailFormat": "Invalid Email Format",
    "ops.staff.enterValidEmails": "Please enter valid email addresses",
    "ops.staff.invitationsSent": "Invitations Sent",
    "ops.staff.invitesSentDesc": "{sent} of {total} invitation email(s) sent successfully.",
    "ops.staff.invitesFailedSuffix": " {failed} failed — check addresses.",
    "ops.staff.noInvitationsSent": "No Invitations Sent",
    "ops.staff.allInvitesFailed": "All invites failed.",
    "ops.staff.failedToSendInvitations": "Failed to send invitations",
    "ops.staff.roleNotAvailable": "Role not available on your plan",
    "ops.staff.roleNotAvailableDesc": "{role} requires a higher subscription tier. Upgrade to access this role.",
    "ops.staff.roleUpdated": "Role Updated",
    "ops.staff.roleUpdatedDesc": "Staff member role has been updated to {role}",
    "ops.staff.roleUpdateFailed": "Role Update Failed",
    "ops.staff.roleUpdateFailedDesc": "Could not update the role. Please try again.",
    "ops.staff.accessRevoked": "Staff Access Revoked",
    "ops.staff.accessRevokedDesc": "{name} has been removed from the roster",
    "ops.staff.removalFailed": "Removal Failed",
    "ops.staff.removalFailedDesc": "Could not remove staff member. Please try again.",
    "ops.tickets.loadingBusinessData": "Loading Business Data",
    "ops.tickets.loadingBusinessInfo": "Please wait while we load your business information.",
    "ops.tickets.createNewTicket": "Create New Ticket",
    "ops.tickets.createTicketDesc": "Create a new support ticket for a customer",
    "ops.tickets.titleLabel": "Title *",
    "ops.tickets.titlePlaceholder": "Enter ticket title",
    "ops.tickets.customerLabel": "Customer *",
    "ops.tickets.customerPlaceholder": "Customer name or email",
    "ops.tickets.category": "Category",
    "ops.tickets.selectCategory": "Select category",
    "ops.tickets.catTechnical": "Technical Support",
    "ops.tickets.catBilling": "Billing",
    "ops.tickets.catGeneral": "General Inquiry",
    "ops.tickets.catFeature": "Feature Request",
    "ops.tickets.catBug": "Bug Report",
    "ops.tickets.selectPriority": "Select priority",
    "ops.tickets.prioLow": "Low",
    "ops.tickets.prioMedium": "Medium",
    "ops.tickets.prioHigh": "High",
    "ops.tickets.prioUrgent": "Urgent",
    "ops.tickets.prioCritical": "Critical",
    "ops.tickets.descriptionLabel": "Description *",
    "ops.tickets.descriptionPlaceholder": "Describe the issue or request",
    "ops.tickets.createTicket": "Create Ticket",
    "ops.tickets.filterTickets": "Filter Tickets",
    "ops.tickets.filterTicketsDesc": "Apply filters to find specific tickets",
    "ops.tickets.selectStatus": "Select status",
    "ops.tickets.allStatus": "All Status",
    "ops.tickets.statusOpen": "Open",
    "ops.tickets.statusInProgress": "In Progress",
    "ops.tickets.statusResolved": "Resolved",
    "ops.tickets.statusClosed": "Closed",
    "ops.tickets.allPriorities": "All Priorities",
    "ops.tickets.applyFilters": "Apply Filters",
    "ops.tickets.respondToTicket": "Respond to Ticket",
    "ops.tickets.respondDesc": "Send a response to {customer}",
    "ops.tickets.theCustomer": "the customer",
    "ops.tickets.responseMessage": "Response Message",
    "ops.tickets.responsePlaceholder": "Type your response here...",
    "ops.tickets.sendResponse": "Send Response",
    "ops.tickets.escalateTicket": "Escalate Ticket",
    "ops.tickets.escalateDesc": "Escalate ticket #{id} to senior support",
    "ops.tickets.escalationReason": "Escalation Reason",
    "ops.tickets.escalationReasonPlaceholder": "Explain why this ticket needs escalation...",
    "ops.tickets.searchTickets": "Search tickets...",
    "ops.tickets.tabAll": "All",
    "ops.tickets.tabActive": "Active",
    "ops.tickets.tabPending": "Pending",
    "ops.tickets.tabResolved": "Resolved",
    "ops.tickets.showingMyQueue": "Showing My Queue",
    "ops.tickets.myQueue": "My Queue",
    "ops.tickets.loadingTickets": "Loading tickets...",
    "ops.tickets.noTicketsFound": "No tickets found",
    "ops.tickets.adjustSearch": "Try adjusting your search or filters",
    "ops.tickets.newTicketsAppear": "New tickets will appear here",
    "ops.tickets.phone": "Phone",
    "ops.tickets.assignedBy": "Assigned By",
    "ops.tickets.created": "Created:",
    "ops.tickets.updated": "Updated:",
    "ops.tickets.acceptedBy": "Accepted by:",
    "ops.tickets.resolvedBy": "Resolved by:",
    "ops.tickets.reassignedBy": "Reassigned by:",
    "ops.tickets.assignedAt": "Assigned at:",
    "ops.tickets.loadingConversation": "Loading conversation...",
    "ops.tickets.noMessages": "No messages",
    "ops.tickets.noConvHistory": "No conversation history found for this ticket.",
    "ops.tickets.selectTicket": "Select a ticket",
    "ops.tickets.clickTicketLoad": "Click a ticket to load its conversation history.",
    "ops.tickets.respond": "Respond",
    "ops.tickets.message": "Message",
    "ops.tickets.escalate": "Escalate",
    "ops.tickets.markResolved": "Mark Resolved",
    "ops.tickets.accept": "Accept",
    "ops.tickets.reassign": "Reassign",
    "ops.tickets.deleteGuest": "Delete Guest",
    "ops.tickets.chooseTicketRespond": "Choose a ticket from the list to view details and respond",
    "ops.tickets.reassignTicket": "Reassign Ticket",
    "ops.tickets.reassignDesc": "{id} — Transfer this ticket to another active operator.",
    "ops.tickets.reassignTo": "Reassign To",
    "ops.tickets.reasonOptional": "Reason (optional)",
    "ops.tickets.reassignReasonPlaceholder": "Why are you reassigning this ticket?",
    "ops.tickets.assignTicket": "Assign Ticket",
    "ops.tickets.assignDesc": "{id} — Select an operator to assign this ticket to.",
    "ops.tickets.assignToLabel": "Assign To",
    "ops.tickets.noOperatorsTenant": "No operators found in this tenant",
    "ops.tickets.noTicketId": "No Ticket ID",
    "ops.tickets.noTicketIdCreate": "This conversation does not have a persisted ticket. Create a ticket first via New Ticket.",
    "ops.tickets.noTicketAccept": "Cannot accept — no persisted ticket linked to this conversation.",
    "ops.tickets.noTicketDelete": "Cannot delete — no persisted ticket linked to this conversation.",
    "ops.tickets.noTicketLinked": "No persisted ticket linked to this conversation.",
    "ops.tickets.selectAnOperator": "Select an operator",
    "ops.tickets.chooseStaffAssign": "Choose a staff member to assign this ticket to.",
    "ops.tickets.ticketAssigned": "Ticket Assigned",
    "ops.tickets.ticketAssignedDesc": "Ticket has been assigned.",
    "ops.tickets.assignFailed": "Assign Failed",
    "ops.tickets.ticketAccepted": "Ticket Accepted",
    "ops.tickets.ticketAcceptedDesc": "Status updated to In Progress.",
    "ops.tickets.acceptFailed": "Accept Failed",
    "ops.tickets.deleteConfirm": "Delete invalid guest ticket {tid}? The linked conversation history is preserved.",
    "ops.tickets.ticketDeleted": "Ticket Deleted",
    "ops.tickets.ticketDeletedDesc": "Ticket {tid} removed.",
    "ops.tickets.deleteFailed": "Delete Failed",
    "ops.tickets.selectOperatorTitle": "Select Operator",
    "ops.tickets.chooseOperatorReassign": "Choose an operator to reassign this ticket to.",
    "ops.tickets.ticketReassigned": "Ticket Reassigned",
    "ops.tickets.ticketReassignedDesc": "Ticket has been reassigned.",
    "ops.tickets.reassignFailed": "Reassign Failed",
    "ops.tickets.ticketCreated": "Ticket Created",
    "ops.tickets.ticketCreatedDesc": "Support ticket created successfully",
    "ops.tickets.failedCreate": "Failed to create ticket",
    "ops.tickets.emptyMessage": "Empty Message",
    "ops.tickets.enterResponse": "Please enter a response message",
    "ops.tickets.responseSent": "Response Sent",
    "ops.tickets.messageSentSuccess": "Message sent successfully",
    "ops.tickets.failedSendResponse": "Failed to send response",
    "ops.tickets.reasonRequired": "Reason Required",
    "ops.tickets.provideEscReason": "Please provide an escalation reason",
    "ops.tickets.ticketEscalated": "Ticket Escalated",
    "ops.tickets.ticketEscalatedDesc": "Ticket escalated to senior support",
    "ops.tickets.failedEscalate": "Failed to escalate ticket",
    "ops.tickets.ticketResolved": "Ticket Resolved",
    "ops.tickets.ticketResolvedDesc": "Ticket marked as resolved",
    "ops.tickets.failedResolve": "Failed to resolve ticket",
    "ops.tickets.failedLoadTickets": "Failed to load tickets. Please try again.",
    "ops.tickets.noConvLinked": "No conversation linked to this ticket.",
    "ops.tickets.emailResolved": "Email Resolved",
    "ops.tickets.composingTo": "Composing message to {email}",
    "ops.esc.pendingBadge": "{count} pending",
    "ops.esc.escalationDetail": "Escalation Detail",
    "ops.esc.intent": "Intent",
    "ops.esc.escalationReason": "Escalation Reason",
    "ops.esc.contextSummary": "Context Summary",
    "ops.esc.aiContextSummary": "AI Context Summary",
    "ops.esc.noContextSummary": "No context summary available.",
    "ops.esc.convTicketId": "Conversation / Ticket ID",
    "ops.esc.notAvailable": "Not available",
    "ops.esc.escalationId": "Escalation ID",
    "ops.esc.reference": "Reference",
    "ops.esc.referenceUnavailable": "Reference unavailable",
    "ops.esc.callbackDue": "Callback Due",
    "ops.esc.voiceTranscript": "Voice Transcript",
    "ops.esc.loadingTranscript": "Loading transcript…",
    "ops.esc.noTranscript": "No transcript available for this session.",
    "ops.esc.call": "Call",
    "ops.esc.callHint": "Initiates Twilio call and logs call event in conversation",
    "ops.esc.conversationThread": "Conversation Thread",
    "ops.esc.loadingMessages": "Loading messages…",
    "ops.esc.noMessagesYet": "No messages yet. Send the first message below.",
    "ops.esc.typeMessageCustomer": "Type a message to the customer…",
    "ops.esc.assignedToMe": "Assigned to Me",
    "ops.esc.callbacks": "Callbacks",
    "ops.esc.badgeOperator": "Operator",
    "ops.esc.badgeManager": "Manager",
    "ops.esc.badgeAdmin": "Admin",
    "ops.esc.noSummaryAvailable": "No summary available",
    "ops.esc.acceptHandle": "Accept & Handle",
    "ops.esc.viewDetails": "View Details",
    "ops.esc.teamQueue": "Team Queue",
    "ops.esc.unassignedQueue": "Unassigned",
    "ops.esc.loadingQueue": "Loading queue…",
    "ops.esc.noTeamEsc": "No team escalations right now.",
    "ops.esc.noUnassigned": "No unassigned escalations right now.",
    "ops.esc.assignedLabel": "Assigned",
    "ops.esc.unassigned": "Unassigned",
    "ops.esc.reassign": "Reassign",
    "ops.esc.close": "Close",
    "ops.esc.escReassigned": "Escalation reassigned.",
    "ops.esc.escClosed": "Escalation closed.",
    "ops.esc.failedLoadTeam": "Couldn't load the team queue. Please refresh.",
    "ops.esc.failedReassign": "Couldn't reassign this escalation.",
    "ops.esc.failedClose": "Couldn't close this escalation.",
    "ops.esc.reassignNotAllowed": "You're not authorized to reassign this escalation.",
    "ops.esc.closeNotAllowed": "You're not authorized to close this escalation.",
    "ops.esc.mustResolveBeforeClose": "Resolve this escalation before it can be closed.",
    "ops.esc.escStateChanged": "This escalation just changed — the queue was refreshed.",
    "ops.esc.selectOperatorAssign": "Select operator to assign…",
    "ops.esc.noStaffAvailable": "No staff available",
    "ops.esc.noPendingEsc": "No pending escalations",
    "ops.esc.allHandledEfficiently": "All conversations are being handled efficiently!",
    "ops.esc.noEscAssigned": "No escalations assigned to you",
    "ops.esc.noEscAssignedHelp": "Escalations assigned to you will appear here once an admin assigns them",
    "ops.esc.messageCustomer": "Message Customer",
    "ops.esc.typeMessageEnter": "Type a message to the customer… (Enter to send)",
    "ops.esc.noPendingCallbacks": "No pending callbacks",
    "ops.esc.overdue": "OVERDUE",
    "ops.esc.due": "Due",
    "ops.esc.claimCallback": "Claim Callback",
    "ops.esc.noResolvedYet": "No resolved escalations yet",
    "ops.esc.completedAppearHere": "Completed escalations will appear here",
    "ops.esc.loadingEscalations": "Loading escalations...",
    "ops.esc.resolveEscalation": "Resolve Escalation",
    "ops.esc.resolveEscDesc": "Document the resolution. Optionally submit to Solution Bank for manager review — approved solutions train the AI assistant.",
    "ops.esc.resolutionNotes": "Resolution Notes *",
    "ops.esc.submitToSolutionBank": "Submit resolution to Solution Bank for review",
    "ops.esc.approveBeforeAi": "A manager or admin must approve before the AI can use this resolution. Unapproved submissions are never used by AI Chat or AI Voice.",
    "ops.esc.submitForReviewSuffix": " & Submit for Review",
    "ops.esc.failedLoadEsc": "Failed to load escalations",
    "ops.esc.checkConnection": "Check your connection and try again.",
    "ops.esc.noConvLinkedTitle": "No conversation linked",
    "ops.esc.noConvLinkedDesc": "This escalation has no linked conversation. Cannot send message.",
    "ops.esc.messageSent": "Message sent",
    "ops.esc.messageSentPush": "Customer will receive your message via push notification.",
    "ops.esc.sendFailed": "Send failed",
    "ops.esc.failedSendMessage": "Failed to send message",
    "ops.esc.noLinkedConvEsc": "No linked conversation for this escalation.",
    "ops.esc.cannotResolveEscId": "Cannot resolve escalation ID",
    "ops.esc.cannotSelfAssign": "Cannot self-assign",
    "ops.esc.cannotSelfAssignDesc": "Your staff profile could not be found. Ask an admin to assign this escalation.",
    "ops.esc.escAccepted": "Escalation accepted",
    "ops.esc.statusReceivingAttention": "Status: Receiving Attention",
    "ops.esc.failedAcceptEsc": "Failed to accept escalation",
    "ops.esc.escResolved": "Escalation resolved",
    "ops.esc.resolutionSubmitted": "Resolution submitted to Solution Bank for manager review.",
    "ops.esc.statusResolved": "Status: Resolved",
    "ops.esc.failedResolveEsc": "Failed to resolve escalation",
    "ops.esc.escAssigned": "Escalation assigned",
    "ops.esc.failedAssignEsc": "Failed to assign escalation",
    "ops.esc.noEscId": "No escalation ID",
    "ops.esc.noEscIdDesc": "This record does not have a valid ID.",
    "ops.ops.manageOperators": "Manage Operators",
    "ops.ops.subtitle": "Real-time monitoring and performance management",
    "ops.ops.dashboard": "Dashboard",
    "ops.ops.realtime": "Real-time",
    "ops.ops.historical": "Historical",
    "ops.ops.scheduleShifts": "Schedule Shifts",
    "ops.ops.shiftNotAvailable": "Shift scheduling is not available in this release.",
    "ops.ops.shiftCreated": "Shift created",
    "ops.ops.operator": "Operator",
    "ops.ops.certifications": "Certifications",
    "ops.ops.languages": "Languages",
    "ops.ops.coachingNotes": "Coaching notes",
    "ops.ops.coachingPurpose": "Purpose",
    "ops.ops.coachingSaved": "Coaching session saved",
    "ops.ops.historicalMode": "Historical mode",
    "ops.ops.noActivity": "No activity",
    "ops.ops.noCoaching": "No coaching sessions",
    "ops.ops.noShifts": "No shifts scheduled",
    "ops.ops.skillsSaved": "Skills saved",
    "ops.ops.queueSettings": "Queue Settings",
    "ops.ops.queueNotAvailable": "Queue configuration is not available in this release.",
    "ops.ops.maxWaitTime": "Maximum wait time (s)",
    "ops.ops.maxConcurrent": "Maximum concurrent assignments",
    "ops.ops.escalationTime": "Escalation time (s)",
    "ops.ops.priorityRouting": "Priority-based routing",
    "ops.ops.skillRouting": "Skill-based routing",
    "ops.ops.autoAssign": "Automatic assignment",
    "ops.ops.queueSaved": "Queue settings saved",
    "ops.ops.queueSettingsDesc": "Configure how calls and tickets are routed and escalated for this tenant.",
    "ops.ops.scheduleShiftsDesc": "Create, list and remove operator work shifts.",
    "ops.ops.coachingDesc": "Schedule a coaching session or performance review for this operator.",
    "ops.ops.onlineOperators": "Online Operators",
    "ops.ops.callsToday": "Calls Today",
    "ops.ops.ticketsResolved": "Tickets Resolved",
    "ops.ops.activeTickets": "Active Tickets",
    "ops.ops.avgAht": "Avg AHT",
    "ops.ops.realtimeModeActive": "Real-time mode active — escalation alerts will appear here",
    "ops.ops.activeOperators": "Active Operators",
    "ops.ops.noOperators": "No operators in this business yet.",
    "ops.ops.loadingMetrics": "Loading operator metrics…",
    "ops.ops.calls": "Calls",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "Select an Operator",
    "ops.ops.chooseOperator": "Choose an operator from the list to view detailed performance metrics and real-time monitoring",
    "ops.ops.kpis": "Key Performance Indicators",
    "ops.ops.avgHandleTime": "Average Handle Time",
    "ops.ops.firstCallResolution": "First Call Resolution",
    "ops.ops.customerSatisfaction": "Customer Satisfaction",
    "ops.ops.callbackCompliance": "Callback Compliance",
    "ops.ops.todaysStats": "Today's Statistics",
    "ops.ops.callsHandled": "Calls Handled",
    "ops.ops.avgHandleTimeShort": "Avg Handle Time",
    "ops.ops.performance": "Performance",
    "ops.ops.liveActivity": "Live Activity",
    "ops.ops.presence": "Presence",
    "ops.ops.onCall": "On call",
    "ops.ops.currentConversation": "Current conversation",
    "ops.ops.lastActivity": "Last activity",
    "ops.ops.skills": "Skills",
    "ops.ops.coaching": "Coaching",
    "ops.ops.liveActivityNA": "Live activity monitoring is not available yet",
    "ops.ops.liveActivityNADesc": "Real-time call / activity feed ships in Revision 2 (OPEN_REVISION_2).",
    "ops.ops.skillsCerts": "Skills & Certifications",
    "ops.ops.skillsNA": "Skills & certifications are not tracked yet",
    "ops.ops.skillsNADesc": "Operator skills / languages / certifications arrive in Revision 2 (OPEN_REVISION_2).",
    "ops.ops.coachingDev": "Coaching & Development",
    "ops.ops.coachingNA": "Coaching & development tools are not available yet — they ship in Revision 2 (OPEN_REVISION_2).",
    "ops.ops.scheduleCoaching": "Schedule Coaching",
    "ops.ops.performanceReview": "Performance Review",
    "ops.ops.whisper": "Whisper",
    "ops.ops.joinCall": "Join Call",
    "ops.ops.supervisionConnectingNotice": "Connecting supervision…",
    "ops.ops.whisperActiveNotice": "Whisper active — coaching the operator (audio verified at release).",
    "ops.ops.listeningNotice": "Listening to the call (audio verified at release).",
    "ops.ops.stopSupervision": "Stop supervision",
    "ops.ops.whisperHint": "Whisper privately to the operator",
    "ops.ops.joinHint": "Join the call as a full participant",
    "ops.ops.noActiveCall": "Operator has no active call",
    "ops.ops.featureWhisper": "Whisper supervision (M11)",
    "ops.ops.featureBarge": "Barge-in / join call (M11)",
    "ops.ops.notAvailableYet": "— not available yet",
    "ops.ops.rev2Saved": "Ships in Revision 2 (OPEN_REVISION_2). Nothing was saved.",
    "ops.tm.subtitle": "Omnichannel ticketing with SLA management and automation",
  },
  es: {
    "ops.common.missingInformation": "Falta información",
    "ops.common.fillAllRequired": "Complete todos los campos obligatorios",
    "ops.common.tryAgain": "Intentar de nuevo",
    "ops.common.customer": "Cliente",
    "ops.common.unassigned": "Sin asignar",
    "ops.common.aiAgent": "Agente de AI",
    "ops.common.status": "Estado",
    "ops.common.priority": "Prioridad",
    "ops.common.assignedTo": "Asignado a",
    "ops.common.pending": "Pendiente",
    "ops.common.resolved": "Resuelto",
    "ops.common.resolve": "Resolver",
    "ops.common.assign": "Asignar",
    "ops.common.view": "Ver",
    "ops.common.inProgress": "En curso",
    "ops.common.you": "Usted",
    "ops.common.system": "Sistema",
    "ops.common.agent": "Agente",
    "ops.common.cannotCall": "No se puede llamar",
    "ops.common.callInitiated": "Llamada iniciada",
    "ops.common.callLogged": "Llamada registrada",
    "ops.common.calling": "Llamando",
    "ops.common.callRecordedFor": "Llamada registrada para",
    "ops.common.callFailed": "Llamada fallida",
    "ops.common.callNow": "Llamar ahora",
    "ops.common.startingCall": "Iniciando llamada…",
    "ops.esc.noConvForCallback": "No hay conversación disponible para esta devolución de llamada",
    "ops.esc.cbDueSoon": "Pronto",
    "ops.esc.cbOverdue": "Vencida",
    "ops.esc.cbScheduled": "Programada",
    "ops.esc.cbCompleted": "Completada",
    "ops.esc.cbCancelled": "Cancelada",
    "ops.esc.cbReminderTitle": "Recordatorio de devolución",
    "ops.esc.cbDueSoonMsg": "Devolución de llamada pronto",
    "ops.common.describeResolution": "Describa cómo se resolvió este problema…",
    "ops.common.selectOperator": "Seleccionar operador…",
    "ops.common.nameLabel": "Nombre:",
    "ops.common.emailLabel": "Correo electrónico:",
    "ops.staff.subscriptionPlan": "Plan de suscripción",
    "ops.staff.seatAllocation": "asignación de plazas",
    "ops.staff.inviteStaffMembers": "Invitar a miembros del personal",
    "ops.staff.inviteDescPre": "Invite a miembros del personal por correo electrónico: cada persona recibe una invitación con su marca con su Brand ID",
    "ops.staff.inviteDescMid": "y un enlace para completar el autorregistro en",
    "ops.staff.inviteExpire": "Las invitaciones caducan a los 7 días.",
    "ops.staff.emailAddresses": "Direcciones de correo electrónico",
    "ops.staff.emailsPlaceholder": "Introduzca direcciones de correo electrónico separadas por comas, punto y coma o saltos de línea:",
    "ops.staff.validEmailsDetected": "{count} correo(s) electrónico(s) válido(s) detectado(s)",
    "ops.staff.defaultRole": "Rol predeterminado",
    "ops.staff.defaultRoleHelp": "A todo el personal invitado se le asignará este rol de forma predeterminada",
    "ops.staff.invitationPreview": "Vista previa de la invitación",
    "ops.staff.operatorDefault": "Operador (predeterminado)",
    "ops.staff.sendingInvitations": "Enviando invitaciones…",
    "ops.staff.sendInvitations": "Enviar {count} invitación(es)",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "{count} miembros del equipo",
    "ops.staff.totalStaff": "Personal total",
    "ops.staff.administrators": "Administradores",
    "ops.staff.operators": "Operadores",
    "ops.staff.otherRoles": "Otros roles",
    "ops.staff.teamMembers": "Miembros del equipo",
    "ops.staff.membersCount": "{count} miembros",
    "ops.staff.noTeamMembers": "Sin miembros del equipo",
    "ops.staff.noTeamMembersHelp": "Invite a miembros del personal a unirse al equipo de su negocio",
    "ops.staff.inviteFirst": "Invitar al primer miembro del personal",
    "ops.staff.changeRole": "Cambiar rol",
    "ops.staff.removeStaff": "Eliminar personal",
    "ops.staff.regInstructions": "Instrucciones de registro del personal",
    "ops.staff.forNewStaff": "Para nuevos miembros del personal:",
    "ops.staff.shareBrandId": "Comparta su Brand ID:",
    "ops.staff.directToReg": "Indíqueles la página de registro del personal",
    "ops.staff.assignedOperatorDefault": "Se les asignará el rol de «Operador» de forma predeterminada",
    "ops.staff.updateRoleDropdown": "Puede actualizar su rol mediante el menú desplegable de arriba",
    "ops.staff.registrationLink": "Enlace de registro:",
    "ops.staff.changeRoleDesc": "Actualice el rol de {name}.",
    "ops.staff.thisStaffMember": "este miembro del personal",
    "ops.staff.saving": "Guardando…",
    "ops.staff.saveRole": "Guardar rol",
    "ops.staff.removeStaffMember": "Eliminar miembro del personal",
    "ops.staff.removeWarning": "Esto revocará de inmediato todo el acceso al negocio para este miembro del personal.",
    "ops.staff.securityImpact": "Impacto en la seguridad:",
    "ops.staff.impact1": "perderá TODO el acceso al negocio de inmediato",
    "ops.staff.impact2a": "Su cuenta de personal será",
    "ops.staff.impact2b": "desactivada",
    "ops.staff.impact2c": "y su teléfono liberado de este negocio",
    "ops.staff.impact3": "Todas las conversaciones anteriores del negocio quedarán protegidas e inaccesibles",
    "ops.staff.impact4": "No podrá acceder a ningún perfil del personal ni a los datos del negocio",
    "ops.staff.staffDetails": "Detalles del personal:",
    "ops.staff.currentRole": "Rol actual:",
    "ops.staff.joinDate": "Fecha de incorporación:",
    "ops.staff.noteLabel": "Nota:",
    "ops.staff.removeNote": "Esta acción no se puede deshacer. Si desea volver a añadir a esta persona más adelante, necesitará una nueva invitación y asignación de rol.",
    "ops.staff.removeRevoke": "Eliminar y revocar acceso",
    "ops.staff.descAdmin": "Acceso completo a todas las funciones y a la gestión del personal",
    "ops.staff.descOperator": "Atención al cliente, gestión de tickets, comunicaciones",
    "ops.staff.descManager": "Supervisión del equipo, informes, gestión de SolutionBank",
    "ops.staff.descAnalyst": "Análisis de datos, informes, métricas de rendimiento",
    "ops.staff.descDirector": "Planificación estratégica, análisis de alto nivel",
    "ops.staff.descExecutive": "Supervisión del negocio, paneles ejecutivos",
    "ops.staff.descIt": "Gestión técnica, configuración del sistema",
    "ops.staff.enterOneEmail": "Introduzca al menos una dirección de correo electrónico",
    "ops.staff.invalidEmailFormat": "Formato de correo electrónico no válido",
    "ops.staff.enterValidEmails": "Introduzca direcciones de correo electrónico válidas",
    "ops.staff.invitationsSent": "Invitaciones enviadas",
    "ops.staff.invitesSentDesc": "{sent} de {total} correo(s) de invitación enviado(s) correctamente.",
    "ops.staff.invitesFailedSuffix": " {failed} fallaron: verifique las direcciones.",
    "ops.staff.noInvitationsSent": "No se enviaron invitaciones",
    "ops.staff.allInvitesFailed": "Todas las invitaciones fallaron.",
    "ops.staff.failedToSendInvitations": "No se pudieron enviar las invitaciones",
    "ops.staff.roleNotAvailable": "Rol no disponible en su plan",
    "ops.staff.roleNotAvailableDesc": "{role} requiere un nivel de suscripción superior. Actualice para acceder a este rol.",
    "ops.staff.roleUpdated": "Rol actualizado",
    "ops.staff.roleUpdatedDesc": "El rol del miembro del personal se ha actualizado a {role}",
    "ops.staff.roleUpdateFailed": "Error al actualizar el rol",
    "ops.staff.roleUpdateFailedDesc": "No se pudo actualizar el rol. Inténtelo de nuevo.",
    "ops.staff.accessRevoked": "Acceso del personal revocado",
    "ops.staff.accessRevokedDesc": "{name} ha sido eliminado de la lista",
    "ops.staff.removalFailed": "Error al eliminar",
    "ops.staff.removalFailedDesc": "No se pudo eliminar al miembro del personal. Inténtelo de nuevo.",
    "ops.tickets.loadingBusinessData": "Cargando datos del negocio",
    "ops.tickets.loadingBusinessInfo": "Espere mientras cargamos la información de su negocio.",
    "ops.tickets.createNewTicket": "Crear nuevo ticket",
    "ops.tickets.createTicketDesc": "Cree un nuevo ticket de soporte para un cliente",
    "ops.tickets.titleLabel": "Título *",
    "ops.tickets.titlePlaceholder": "Introduzca el título del ticket",
    "ops.tickets.customerLabel": "Cliente *",
    "ops.tickets.customerPlaceholder": "Nombre o correo electrónico del cliente",
    "ops.tickets.category": "Categoría",
    "ops.tickets.selectCategory": "Seleccionar categoría",
    "ops.tickets.catTechnical": "Soporte técnico",
    "ops.tickets.catBilling": "Facturación",
    "ops.tickets.catGeneral": "Consulta general",
    "ops.tickets.catFeature": "Solicitud de función",
    "ops.tickets.catBug": "Informe de error",
    "ops.tickets.selectPriority": "Seleccionar prioridad",
    "ops.tickets.prioLow": "Baja",
    "ops.tickets.prioMedium": "Media",
    "ops.tickets.prioHigh": "Alta",
    "ops.tickets.prioUrgent": "Urgente",
    "ops.tickets.prioCritical": "Crítica",
    "ops.tickets.descriptionLabel": "Descripción *",
    "ops.tickets.descriptionPlaceholder": "Describa el problema o la solicitud",
    "ops.tickets.createTicket": "Crear ticket",
    "ops.tickets.filterTickets": "Filtrar tickets",
    "ops.tickets.filterTicketsDesc": "Aplique filtros para encontrar tickets específicos",
    "ops.tickets.selectStatus": "Seleccionar estado",
    "ops.tickets.allStatus": "Todos los estados",
    "ops.tickets.statusOpen": "Abierto",
    "ops.tickets.statusInProgress": "En curso",
    "ops.tickets.statusResolved": "Resuelto",
    "ops.tickets.statusClosed": "Cerrado",
    "ops.tickets.allPriorities": "Todas las prioridades",
    "ops.tickets.applyFilters": "Aplicar filtros",
    "ops.tickets.respondToTicket": "Responder al ticket",
    "ops.tickets.respondDesc": "Enviar una respuesta a {customer}",
    "ops.tickets.theCustomer": "el cliente",
    "ops.tickets.responseMessage": "Mensaje de respuesta",
    "ops.tickets.responsePlaceholder": "Escriba su respuesta aquí…",
    "ops.tickets.sendResponse": "Enviar respuesta",
    "ops.tickets.escalateTicket": "Escalar ticket",
    "ops.tickets.escalateDesc": "Escalar el ticket #{id} al soporte de nivel superior",
    "ops.tickets.escalationReason": "Motivo de la escalación",
    "ops.tickets.escalationReasonPlaceholder": "Explique por qué este ticket necesita escalación…",
    "ops.tickets.searchTickets": "Buscar tickets…",
    "ops.tickets.tabAll": "Todos",
    "ops.tickets.tabActive": "Activos",
    "ops.tickets.tabPending": "Pendientes",
    "ops.tickets.tabResolved": "Resueltos",
    "ops.tickets.showingMyQueue": "Mostrando mi cola",
    "ops.tickets.myQueue": "Mi cola",
    "ops.tickets.loadingTickets": "Cargando tickets…",
    "ops.tickets.noTicketsFound": "No se encontraron tickets",
    "ops.tickets.adjustSearch": "Pruebe a ajustar la búsqueda o los filtros",
    "ops.tickets.newTicketsAppear": "Los nuevos tickets aparecerán aquí",
    "ops.tickets.phone": "Teléfono",
    "ops.tickets.assignedBy": "Asignado por",
    "ops.tickets.created": "Creado:",
    "ops.tickets.updated": "Actualizado:",
    "ops.tickets.acceptedBy": "Aceptado por:",
    "ops.tickets.resolvedBy": "Resuelto por:",
    "ops.tickets.reassignedBy": "Reasignado por:",
    "ops.tickets.assignedAt": "Asignado el:",
    "ops.tickets.loadingConversation": "Cargando conversación…",
    "ops.tickets.noMessages": "Sin mensajes",
    "ops.tickets.noConvHistory": "No se encontró historial de conversación para este ticket.",
    "ops.tickets.selectTicket": "Seleccione un ticket",
    "ops.tickets.clickTicketLoad": "Haga clic en un ticket para cargar su historial de conversación.",
    "ops.tickets.respond": "Responder",
    "ops.tickets.escalate": "Escalar",
    "ops.tickets.markResolved": "Marcar como resuelto",
    "ops.tickets.accept": "Aceptar",
    "ops.tickets.reassign": "Reasignar",
    "ops.tickets.deleteGuest": "Eliminar invitado",
    "ops.tickets.chooseTicketRespond": "Elija un ticket de la lista para ver los detalles y responder",
    "ops.tickets.reassignTicket": "Reasignar ticket",
    "ops.tickets.reassignDesc": "{id} — Transfiera este ticket a otro operador activo.",
    "ops.tickets.reassignTo": "Reasignar a",
    "ops.tickets.reasonOptional": "Motivo (opcional)",
    "ops.tickets.reassignReasonPlaceholder": "¿Por qué está reasignando este ticket?",
    "ops.tickets.assignTicket": "Asignar ticket",
    "ops.tickets.assignDesc": "{id} — Seleccione un operador al que asignar este ticket.",
    "ops.tickets.assignToLabel": "Asignar a",
    "ops.tickets.noOperatorsTenant": "No se encontraron operadores en este inquilino",
    "ops.tickets.noTicketId": "Sin ID de ticket",
    "ops.tickets.noTicketIdCreate": "Esta conversación no tiene un ticket persistido. Cree primero un ticket mediante Nuevo ticket.",
    "ops.tickets.noTicketAccept": "No se puede aceptar: no hay un ticket persistido vinculado a esta conversación.",
    "ops.tickets.noTicketDelete": "No se puede eliminar: no hay un ticket persistido vinculado a esta conversación.",
    "ops.tickets.noTicketLinked": "No hay un ticket persistido vinculado a esta conversación.",
    "ops.tickets.selectAnOperator": "Seleccione un operador",
    "ops.tickets.chooseStaffAssign": "Elija un miembro del personal al que asignar este ticket.",
    "ops.tickets.ticketAssigned": "Ticket asignado",
    "ops.tickets.ticketAssignedDesc": "El ticket ha sido asignado.",
    "ops.tickets.assignFailed": "Error al asignar",
    "ops.tickets.ticketAccepted": "Ticket aceptado",
    "ops.tickets.ticketAcceptedDesc": "Estado actualizado a En curso.",
    "ops.tickets.acceptFailed": "Error al aceptar",
    "ops.tickets.deleteConfirm": "¿Eliminar el ticket de invitado no válido {tid}? El historial de conversación vinculado se conserva.",
    "ops.tickets.ticketDeleted": "Ticket eliminado",
    "ops.tickets.ticketDeletedDesc": "Ticket {tid} eliminado.",
    "ops.tickets.deleteFailed": "Error al eliminar",
    "ops.tickets.selectOperatorTitle": "Seleccionar operador",
    "ops.tickets.chooseOperatorReassign": "Elija un operador al que reasignar este ticket.",
    "ops.tickets.ticketReassigned": "Ticket reasignado",
    "ops.tickets.ticketReassignedDesc": "El ticket ha sido reasignado.",
    "ops.tickets.reassignFailed": "Error al reasignar",
    "ops.tickets.ticketCreated": "Ticket creado",
    "ops.tickets.ticketCreatedDesc": "Ticket de soporte creado correctamente",
    "ops.tickets.failedCreate": "No se pudo crear el ticket",
    "ops.tickets.emptyMessage": "Mensaje vacío",
    "ops.tickets.enterResponse": "Introduzca un mensaje de respuesta",
    "ops.tickets.responseSent": "Respuesta enviada",
    "ops.tickets.messageSentSuccess": "Mensaje enviado correctamente",
    "ops.tickets.failedSendResponse": "No se pudo enviar la respuesta",
    "ops.tickets.reasonRequired": "Motivo obligatorio",
    "ops.tickets.provideEscReason": "Proporcione un motivo de escalación",
    "ops.tickets.ticketEscalated": "Ticket escalado",
    "ops.tickets.ticketEscalatedDesc": "Ticket escalado al soporte de nivel superior",
    "ops.tickets.failedEscalate": "No se pudo escalar el ticket",
    "ops.tickets.ticketResolved": "Ticket resuelto",
    "ops.tickets.ticketResolvedDesc": "Ticket marcado como resuelto",
    "ops.tickets.failedResolve": "No se pudo resolver el ticket",
    "ops.tickets.failedLoadTickets": "No se pudieron cargar los tickets. Inténtelo de nuevo.",
    "ops.tickets.noConvLinked": "No hay conversación vinculada a este ticket.",
    "ops.tickets.emailResolved": "Correo electrónico resuelto",
    "ops.tickets.composingTo": "Redactando mensaje para {email}",
    "ops.esc.pendingBadge": "{count} pendiente(s)",
    "ops.esc.escalationDetail": "Detalle de la escalación",
    "ops.esc.intent": "Intención",
    "ops.esc.escalationReason": "Motivo de la escalación",
    "ops.esc.contextSummary": "Resumen del contexto",
    "ops.esc.aiContextSummary": "Resumen de contexto de AI",
    "ops.esc.noContextSummary": "No hay resumen de contexto disponible.",
    "ops.esc.convTicketId": "ID de conversación / ticket",
    "ops.esc.notAvailable": "No disponible",
    "ops.esc.escalationId": "ID de escalación",
    "ops.esc.callbackDue": "Devolución de llamada pendiente",
    "ops.esc.voiceTranscript": "Transcripción de voz",
    "ops.esc.loadingTranscript": "Cargando transcripción…",
    "ops.esc.noTranscript": "No hay transcripción disponible para esta sesión.",
    "ops.esc.call": "Llamar",
    "ops.esc.callHint": "Inicia una llamada de Twilio y registra el evento de llamada en la conversación",
    "ops.esc.conversationThread": "Hilo de conversación",
    "ops.esc.loadingMessages": "Cargando mensajes…",
    "ops.esc.noMessagesYet": "Aún no hay mensajes. Envíe el primer mensaje a continuación.",
    "ops.esc.typeMessageCustomer": "Escriba un mensaje para el cliente…",
    "ops.esc.assignedToMe": "Asignadas a mí",
    "ops.esc.callbacks": "Devoluciones de llamada",
    "ops.esc.badgeOperator": "Operador",
    "ops.esc.badgeManager": "Gerente",
    "ops.esc.badgeAdmin": "Administrador",
    "ops.esc.noSummaryAvailable": "No hay resumen disponible",
    "ops.esc.acceptHandle": "Aceptar y gestionar",
    "ops.esc.viewDetails": "Ver detalles",
    "ops.esc.selectOperatorAssign": "Seleccionar operador para asignar…",
    "ops.esc.noStaffAvailable": "No hay personal disponible",
    "ops.esc.noPendingEsc": "No hay escalaciones pendientes",
    "ops.esc.allHandledEfficiently": "¡Todas las conversaciones se están gestionando de forma eficiente!",
    "ops.esc.noEscAssigned": "No tiene escalaciones asignadas",
    "ops.esc.noEscAssignedHelp": "Las escalaciones que se le asignen aparecerán aquí una vez que un administrador se las asigne",
    "ops.esc.messageCustomer": "Enviar mensaje al cliente",
    "ops.esc.typeMessageEnter": "Escriba un mensaje para el cliente… (Intro para enviar)",
    "ops.esc.noPendingCallbacks": "No hay devoluciones de llamada pendientes",
    "ops.esc.overdue": "VENCIDA",
    "ops.esc.due": "Vence",
    "ops.esc.claimCallback": "Reclamar devolución de llamada",
    "ops.esc.noResolvedYet": "Aún no hay escalaciones resueltas",
    "ops.esc.completedAppearHere": "Las escalaciones completadas aparecerán aquí",
    "ops.esc.loadingEscalations": "Cargando escalaciones…",
    "ops.esc.resolveEscalation": "Resolver escalación",
    "ops.esc.resolveEscDesc": "Documente la resolución. Opcionalmente, envíela a Solution Bank para revisión de un gerente: las soluciones aprobadas entrenan al asistente de AI.",
    "ops.esc.resolutionNotes": "Notas de resolución *",
    "ops.esc.submitToSolutionBank": "Enviar la resolución a Solution Bank para revisión",
    "ops.esc.approveBeforeAi": "Un gerente o administrador debe aprobarla antes de que la AI pueda usar esta resolución. Los envíos no aprobados nunca son utilizados por AI Chat ni AI Voice.",
    "ops.esc.submitForReviewSuffix": " y enviar para revisión",
    "ops.esc.failedLoadEsc": "No se pudieron cargar las escalaciones",
    "ops.esc.checkConnection": "Compruebe su conexión e inténtelo de nuevo.",
    "ops.esc.noConvLinkedTitle": "No hay conversación vinculada",
    "ops.esc.noConvLinkedDesc": "Esta escalación no tiene conversación vinculada. No se puede enviar el mensaje.",
    "ops.esc.messageSent": "Mensaje enviado",
    "ops.esc.messageSentPush": "El cliente recibirá su mensaje mediante una notificación push.",
    "ops.esc.sendFailed": "Error al enviar",
    "ops.esc.failedSendMessage": "No se pudo enviar el mensaje",
    "ops.esc.noLinkedConvEsc": "No hay conversación vinculada para esta escalación.",
    "ops.esc.cannotResolveEscId": "No se puede resolver el ID de la escalación",
    "ops.esc.cannotSelfAssign": "No se puede autoasignar",
    "ops.esc.cannotSelfAssignDesc": "No se pudo encontrar su perfil de personal. Pida a un administrador que le asigne esta escalación.",
    "ops.esc.escAccepted": "Escalación aceptada",
    "ops.esc.statusReceivingAttention": "Estado: Recibiendo atención",
    "ops.esc.failedAcceptEsc": "No se pudo aceptar la escalación",
    "ops.esc.escResolved": "Escalación resuelta",
    "ops.esc.resolutionSubmitted": "Resolución enviada a Solution Bank para revisión de un gerente.",
    "ops.esc.statusResolved": "Estado: Resuelto",
    "ops.esc.failedResolveEsc": "No se pudo resolver la escalación",
    "ops.esc.escAssigned": "Escalación asignada",
    "ops.esc.failedAssignEsc": "No se pudo asignar la escalación",
    "ops.esc.noEscId": "Sin ID de escalación",
    "ops.esc.noEscIdDesc": "Este registro no tiene un ID válido.",
    "ops.ops.manageOperators": "Gestionar operadores",
    "ops.ops.subtitle": "Supervisión en tiempo real y gestión del rendimiento",
    "ops.ops.dashboard": "Panel",
    "ops.ops.realtime": "En tiempo real",
    "ops.ops.historical": "Histórico",
    "ops.ops.scheduleShifts": "Programar turnos",
    "ops.ops.shiftNotAvailable": "La programación de turnos no está disponible en esta versión.",
    "ops.ops.shiftCreated": "Turno creado",
    "ops.ops.operator": "Operador",
    "ops.ops.certifications": "Certificaciones",
    "ops.ops.languages": "Idiomas",
    "ops.ops.coachingNotes": "Notas de coaching",
    "ops.ops.coachingPurpose": "Propósito",
    "ops.ops.coachingSaved": "Sesión de coaching guardada",
    "ops.ops.historicalMode": "Modo histórico",
    "ops.ops.noActivity": "Sin actividad",
    "ops.ops.noCoaching": "Sin sesiones de coaching",
    "ops.ops.noShifts": "Sin turnos programados",
    "ops.ops.skillsSaved": "Habilidades guardadas",
    "ops.ops.queueSettings": "Configuración de la cola",
    "ops.ops.queueNotAvailable": "La configuración de la cola no está disponible en esta versión.",
    "ops.ops.onlineOperators": "Operadores en línea",
    "ops.ops.callsToday": "Llamadas de hoy",
    "ops.ops.ticketsResolved": "Tickets resueltos",
    "ops.ops.activeTickets": "Tickets activos",
    "ops.ops.avgAht": "AHT promedio",
    "ops.ops.realtimeModeActive": "Modo en tiempo real activo: las alertas de escalación aparecerán aquí",
    "ops.ops.activeOperators": "Operadores activos",
    "ops.ops.noOperators": "Aún no hay operadores en este negocio.",
    "ops.ops.loadingMetrics": "Cargando métricas del operador…",
    "ops.ops.calls": "Llamadas",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "Seleccione un operador",
    "ops.ops.chooseOperator": "Elija un operador de la lista para ver métricas de rendimiento detalladas y supervisión en tiempo real",
    "ops.ops.kpis": "Indicadores clave de rendimiento",
    "ops.ops.avgHandleTime": "Tiempo medio de gestión",
    "ops.ops.firstCallResolution": "Resolución en la primera llamada",
    "ops.ops.customerSatisfaction": "Satisfacción del cliente",
    "ops.ops.callbackCompliance": "Cumplimiento de devoluciones de llamada",
    "ops.ops.todaysStats": "Estadísticas de hoy",
    "ops.ops.callsHandled": "Llamadas gestionadas",
    "ops.ops.avgHandleTimeShort": "Tiempo medio de gestión",
    "ops.ops.performance": "Rendimiento",
    "ops.ops.liveActivity": "Actividad en vivo",
    "ops.ops.presence": "Presencia",
    "ops.ops.onCall": "En llamada",
    "ops.ops.currentConversation": "Conversación actual",
    "ops.ops.lastActivity": "Última actividad",
    "ops.ops.skills": "Habilidades",
    "ops.ops.coaching": "Formación",
    "ops.ops.liveActivityNA": "La supervisión de actividad en vivo aún no está disponible",
    "ops.ops.liveActivityNADesc": "El flujo de llamadas / actividad en tiempo real llega en la Revisión 2 (OPEN_REVISION_2).",
    "ops.ops.skillsCerts": "Habilidades y certificaciones",
    "ops.ops.skillsNA": "Las habilidades y certificaciones aún no se registran",
    "ops.ops.skillsNADesc": "Las habilidades / idiomas / certificaciones de los operadores llegan en la Revisión 2 (OPEN_REVISION_2).",
    "ops.ops.coachingDev": "Formación y desarrollo",
    "ops.ops.coachingNA": "Las herramientas de formación y desarrollo aún no están disponibles: llegan en la Revisión 2 (OPEN_REVISION_2).",
    "ops.ops.scheduleCoaching": "Programar formación",
    "ops.ops.performanceReview": "Evaluación del rendimiento",
    "ops.ops.whisper": "Susurro",
    "ops.ops.joinCall": "Unirse a la llamada",
    "ops.ops.supervisionConnectingNotice": "Conectando a la supervisión…",
    "ops.ops.whisperActiveNotice": "Susurro activo — asesorando al operador.",
    "ops.ops.listeningNotice": "Escuchando la llamada.",
    "ops.ops.stopSupervision": "Detener la supervisión",
    "ops.ops.whisperHint": "Habla en privado con el operador sin que el cliente te oiga",
    "ops.ops.joinHint": "Únete a la llamada para que todos los participantes puedan oírte",
    "ops.ops.noActiveCall": "El operador no tiene ninguna llamada activa",
    "ops.ops.featureWhisper": "Supervisión por susurro (M11)",
    "ops.ops.featureBarge": "Intervención / unirse a la llamada (M11)",
    "ops.ops.notAvailableYet": "— aún no disponible",
    "ops.ops.rev2Saved": "Llega en la Revisión 2 (OPEN_REVISION_2). No se guardó nada.",
    "ops.tm.subtitle": "Emisión de tickets omnicanal con gestión de SLA y automatización",
  },
  fr: {
    "ops.common.missingInformation": "Informations manquantes",
    "ops.common.fillAllRequired": "Veuillez remplir tous les champs obligatoires",
    "ops.common.tryAgain": "Réessayer",
    "ops.common.customer": "Client",
    "ops.common.unassigned": "Non attribué",
    "ops.common.aiAgent": "Agent IA",
    "ops.common.status": "Statut",
    "ops.common.priority": "Priorité",
    "ops.common.assignedTo": "Attribué à",
    "ops.common.pending": "En attente",
    "ops.common.resolved": "Résolu",
    "ops.common.resolve": "Résoudre",
    "ops.common.assign": "Attribuer",
    "ops.common.view": "Voir",
    "ops.common.inProgress": "En cours",
    "ops.common.you": "Vous",
    "ops.common.system": "Système",
    "ops.common.agent": "Agent",
    "ops.common.cannotCall": "Appel impossible",
    "ops.common.callInitiated": "Appel lancé",
    "ops.common.callLogged": "Appel enregistré",
    "ops.common.calling": "Appel en cours",
    "ops.common.callRecordedFor": "Appel enregistré pour",
    "ops.common.callFailed": "Échec de l'appel",
    "ops.common.callNow": "Appeler maintenant",
    "ops.common.startingCall": "Appel en cours…",
    "ops.esc.noConvForCallback": "Aucune conversation disponible pour ce rappel",
    "ops.esc.cbDueSoon": "Bientôt",
    "ops.esc.cbOverdue": "En retard",
    "ops.esc.cbScheduled": "Planifié",
    "ops.esc.cbCompleted": "Terminé",
    "ops.esc.cbCancelled": "Annulé",
    "ops.esc.cbReminderTitle": "Rappel de rappel",
    "ops.esc.cbDueSoonMsg": "Rappel bientôt dû",
    "ops.common.describeResolution": "Décrivez comment ce problème a été résolu…",
    "ops.common.selectOperator": "Sélectionner un opérateur…",
    "ops.common.nameLabel": "Nom :",
    "ops.common.emailLabel": "E-mail :",
    "ops.staff.subscriptionPlan": "Forfait d'abonnement",
    "ops.staff.seatAllocation": "attribution des sièges",
    "ops.staff.inviteStaffMembers": "Inviter des membres du personnel",
    "ops.staff.inviteDescPre": "Invitez des membres du personnel par e-mail — chaque personne reçoit une invitation personnalisée avec votre Brand ID",
    "ops.staff.inviteDescMid": "et un lien pour effectuer l'auto-inscription à",
    "ops.staff.inviteExpire": "Les invitations expirent après 7 jours.",
    "ops.staff.emailAddresses": "Adresses e-mail",
    "ops.staff.emailsPlaceholder": "Saisissez des adresses e-mail séparées par des virgules, des points-virgules ou des retours à la ligne :",
    "ops.staff.validEmailsDetected": "{count} adresse(s) e-mail valide(s) détectée(s)",
    "ops.staff.defaultRole": "Rôle par défaut",
    "ops.staff.defaultRoleHelp": "Tous les membres du personnel invités se verront attribuer ce rôle par défaut",
    "ops.staff.invitationPreview": "Aperçu de l'invitation",
    "ops.staff.operatorDefault": "Opérateur (par défaut)",
    "ops.staff.sendingInvitations": "Envoi des invitations…",
    "ops.staff.sendInvitations": "Envoyer {count} invitation(s)",
    "ops.staff.brandId": "Brand ID :",
    "ops.staff.teamMembersCount": "{count} membres de l'équipe",
    "ops.staff.totalStaff": "Personnel total",
    "ops.staff.administrators": "Administrateurs",
    "ops.staff.operators": "Opérateurs",
    "ops.staff.otherRoles": "Autres rôles",
    "ops.staff.teamMembers": "Membres de l'équipe",
    "ops.staff.membersCount": "{count} membres",
    "ops.staff.noTeamMembers": "Aucun membre de l'équipe",
    "ops.staff.noTeamMembersHelp": "Invitez des membres du personnel à rejoindre l'équipe de votre entreprise",
    "ops.staff.inviteFirst": "Inviter le premier membre du personnel",
    "ops.staff.changeRole": "Changer de rôle",
    "ops.staff.removeStaff": "Retirer le membre du personnel",
    "ops.staff.regInstructions": "Instructions d'inscription du personnel",
    "ops.staff.forNewStaff": "Pour les nouveaux membres du personnel :",
    "ops.staff.shareBrandId": "Partagez votre Brand ID :",
    "ops.staff.directToReg": "Dirigez-les vers la page d'inscription du personnel",
    "ops.staff.assignedOperatorDefault": "Le rôle « Opérateur » leur sera attribué par défaut",
    "ops.staff.updateRoleDropdown": "Vous pouvez mettre à jour leur rôle à l'aide du menu déroulant ci-dessus",
    "ops.staff.registrationLink": "Lien d'inscription :",
    "ops.staff.changeRoleDesc": "Mettre à jour le rôle de {name}.",
    "ops.staff.thisStaffMember": "ce membre du personnel",
    "ops.staff.saving": "Enregistrement…",
    "ops.staff.saveRole": "Enregistrer le rôle",
    "ops.staff.removeStaffMember": "Retirer le membre du personnel",
    "ops.staff.removeWarning": "Cela révoquera immédiatement tout accès à l'entreprise pour ce membre du personnel.",
    "ops.staff.securityImpact": "Impact sur la sécurité :",
    "ops.staff.impact1": "perdra IMMÉDIATEMENT TOUT accès à l'entreprise",
    "ops.staff.impact2a": "Son compte de membre du personnel sera",
    "ops.staff.impact2b": "désactivé",
    "ops.staff.impact2c": "et son téléphone libéré de cette entreprise",
    "ops.staff.impact3": "Toutes les conversations professionnelles précédentes seront sécurisées et inaccessibles",
    "ops.staff.impact4": "Il ne pourra accéder à aucun profil du personnel ni à aucune donnée de l'entreprise",
    "ops.staff.staffDetails": "Détails du membre du personnel :",
    "ops.staff.currentRole": "Rôle actuel :",
    "ops.staff.joinDate": "Date d'arrivée :",
    "ops.staff.noteLabel": "Remarque :",
    "ops.staff.removeNote": "Cette action est irréversible. Si vous souhaitez réintégrer cette personne ultérieurement, elle aura besoin d'une nouvelle invitation et d'une nouvelle attribution de rôle.",
    "ops.staff.removeRevoke": "Retirer et révoquer l'accès",
    "ops.staff.descAdmin": "Accès complet à toutes les fonctionnalités et à la gestion du personnel",
    "ops.staff.descOperator": "Service client, gestion des tickets, communications",
    "ops.staff.descManager": "Supervision d'équipe, reporting, gestion SolutionBank",
    "ops.staff.descAnalyst": "Analyse de données, reporting, indicateurs de performance",
    "ops.staff.descDirector": "Planification stratégique, analytique de haut niveau",
    "ops.staff.descExecutive": "Supervision de l'entreprise, tableaux de bord exécutifs",
    "ops.staff.descIt": "Gestion technique, configuration système",
    "ops.staff.enterOneEmail": "Veuillez saisir au moins une adresse e-mail",
    "ops.staff.invalidEmailFormat": "Format d'e-mail invalide",
    "ops.staff.enterValidEmails": "Veuillez saisir des adresses e-mail valides",
    "ops.staff.invitationsSent": "Invitations envoyées",
    "ops.staff.invitesSentDesc": "{sent} invitation(s) sur {total} envoyée(s) avec succès.",
    "ops.staff.invitesFailedSuffix": " {failed} échec(s) — vérifiez les adresses.",
    "ops.staff.noInvitationsSent": "Aucune invitation envoyée",
    "ops.staff.allInvitesFailed": "Toutes les invitations ont échoué.",
    "ops.staff.failedToSendInvitations": "Échec de l'envoi des invitations",
    "ops.staff.roleNotAvailable": "Rôle non disponible avec votre forfait",
    "ops.staff.roleNotAvailableDesc": "{role} nécessite un niveau d'abonnement supérieur. Effectuez une mise à niveau pour accéder à ce rôle.",
    "ops.staff.roleUpdated": "Rôle mis à jour",
    "ops.staff.roleUpdatedDesc": "Le rôle du membre du personnel a été mis à jour vers {role}",
    "ops.staff.roleUpdateFailed": "Échec de la mise à jour du rôle",
    "ops.staff.roleUpdateFailedDesc": "Impossible de mettre à jour le rôle. Veuillez réessayer.",
    "ops.staff.accessRevoked": "Accès du personnel révoqué",
    "ops.staff.accessRevokedDesc": "{name} a été retiré de la liste",
    "ops.staff.removalFailed": "Échec du retrait",
    "ops.staff.removalFailedDesc": "Impossible de retirer le membre du personnel. Veuillez réessayer.",
    "ops.tickets.loadingBusinessData": "Chargement des données de l'entreprise",
    "ops.tickets.loadingBusinessInfo": "Veuillez patienter pendant le chargement des informations de votre entreprise.",
    "ops.tickets.createNewTicket": "Créer un nouveau ticket",
    "ops.tickets.createTicketDesc": "Créer un nouveau ticket d'assistance pour un client",
    "ops.tickets.titleLabel": "Titre *",
    "ops.tickets.titlePlaceholder": "Saisissez le titre du ticket",
    "ops.tickets.customerLabel": "Client *",
    "ops.tickets.customerPlaceholder": "Nom ou e-mail du client",
    "ops.tickets.category": "Catégorie",
    "ops.tickets.selectCategory": "Sélectionner une catégorie",
    "ops.tickets.catTechnical": "Assistance technique",
    "ops.tickets.catBilling": "Facturation",
    "ops.tickets.catGeneral": "Demande générale",
    "ops.tickets.catFeature": "Demande de fonctionnalité",
    "ops.tickets.catBug": "Signalement de bug",
    "ops.tickets.selectPriority": "Sélectionner une priorité",
    "ops.tickets.prioLow": "Faible",
    "ops.tickets.prioMedium": "Moyenne",
    "ops.tickets.prioHigh": "Élevée",
    "ops.tickets.prioUrgent": "Urgente",
    "ops.tickets.prioCritical": "Critique",
    "ops.tickets.descriptionLabel": "Description *",
    "ops.tickets.descriptionPlaceholder": "Décrivez le problème ou la demande",
    "ops.tickets.createTicket": "Créer le ticket",
    "ops.tickets.filterTickets": "Filtrer les tickets",
    "ops.tickets.filterTicketsDesc": "Appliquez des filtres pour trouver des tickets spécifiques",
    "ops.tickets.selectStatus": "Sélectionner un statut",
    "ops.tickets.allStatus": "Tous les statuts",
    "ops.tickets.statusOpen": "Ouvert",
    "ops.tickets.statusInProgress": "En cours",
    "ops.tickets.statusResolved": "Résolu",
    "ops.tickets.statusClosed": "Fermé",
    "ops.tickets.allPriorities": "Toutes les priorités",
    "ops.tickets.applyFilters": "Appliquer les filtres",
    "ops.tickets.respondToTicket": "Répondre au ticket",
    "ops.tickets.respondDesc": "Envoyer une réponse à {customer}",
    "ops.tickets.theCustomer": "le client",
    "ops.tickets.responseMessage": "Message de réponse",
    "ops.tickets.responsePlaceholder": "Saisissez votre réponse ici...",
    "ops.tickets.sendResponse": "Envoyer la réponse",
    "ops.tickets.escalateTicket": "Escalader le ticket",
    "ops.tickets.escalateDesc": "Escalader le ticket #{id} vers l'assistance de niveau supérieur",
    "ops.tickets.escalationReason": "Motif de l'escalade",
    "ops.tickets.escalationReasonPlaceholder": "Expliquez pourquoi ce ticket doit être escaladé...",
    "ops.tickets.searchTickets": "Rechercher des tickets...",
    "ops.tickets.tabAll": "Tous",
    "ops.tickets.tabActive": "Actifs",
    "ops.tickets.tabPending": "En attente",
    "ops.tickets.tabResolved": "Résolus",
    "ops.tickets.showingMyQueue": "Affichage de ma file d'attente",
    "ops.tickets.myQueue": "Ma file d'attente",
    "ops.tickets.loadingTickets": "Chargement des tickets...",
    "ops.tickets.noTicketsFound": "Aucun ticket trouvé",
    "ops.tickets.adjustSearch": "Essayez d'ajuster votre recherche ou vos filtres",
    "ops.tickets.newTicketsAppear": "Les nouveaux tickets apparaîtront ici",
    "ops.tickets.phone": "Téléphone",
    "ops.tickets.assignedBy": "Attribué par",
    "ops.tickets.created": "Créé :",
    "ops.tickets.updated": "Mis à jour :",
    "ops.tickets.acceptedBy": "Accepté par :",
    "ops.tickets.resolvedBy": "Résolu par :",
    "ops.tickets.reassignedBy": "Réattribué par :",
    "ops.tickets.assignedAt": "Attribué le :",
    "ops.tickets.loadingConversation": "Chargement de la conversation...",
    "ops.tickets.noMessages": "Aucun message",
    "ops.tickets.noConvHistory": "Aucun historique de conversation trouvé pour ce ticket.",
    "ops.tickets.selectTicket": "Sélectionner un ticket",
    "ops.tickets.clickTicketLoad": "Cliquez sur un ticket pour charger son historique de conversation.",
    "ops.tickets.respond": "Répondre",
    "ops.tickets.escalate": "Escalader",
    "ops.tickets.markResolved": "Marquer comme résolu",
    "ops.tickets.accept": "Accepter",
    "ops.tickets.reassign": "Réattribuer",
    "ops.tickets.deleteGuest": "Supprimer l'invité",
    "ops.tickets.chooseTicketRespond": "Choisissez un ticket dans la liste pour afficher les détails et répondre",
    "ops.tickets.reassignTicket": "Réattribuer le ticket",
    "ops.tickets.reassignDesc": "{id} — Transférer ce ticket à un autre opérateur actif.",
    "ops.tickets.reassignTo": "Réattribuer à",
    "ops.tickets.reasonOptional": "Motif (facultatif)",
    "ops.tickets.reassignReasonPlaceholder": "Pourquoi réattribuez-vous ce ticket ?",
    "ops.tickets.assignTicket": "Attribuer le ticket",
    "ops.tickets.assignDesc": "{id} — Sélectionnez un opérateur à qui attribuer ce ticket.",
    "ops.tickets.assignToLabel": "Attribuer à",
    "ops.tickets.noOperatorsTenant": "Aucun opérateur trouvé dans ce locataire",
    "ops.tickets.noTicketId": "Aucun ID de ticket",
    "ops.tickets.noTicketIdCreate": "Cette conversation ne comporte pas de ticket persistant. Créez d'abord un ticket via Nouveau ticket.",
    "ops.tickets.noTicketAccept": "Impossible d'accepter — aucun ticket persistant lié à cette conversation.",
    "ops.tickets.noTicketDelete": "Impossible de supprimer — aucun ticket persistant lié à cette conversation.",
    "ops.tickets.noTicketLinked": "Aucun ticket persistant lié à cette conversation.",
    "ops.tickets.selectAnOperator": "Sélectionner un opérateur",
    "ops.tickets.chooseStaffAssign": "Choisissez un membre du personnel à qui attribuer ce ticket.",
    "ops.tickets.ticketAssigned": "Ticket attribué",
    "ops.tickets.ticketAssignedDesc": "Le ticket a été attribué.",
    "ops.tickets.assignFailed": "Échec de l'attribution",
    "ops.tickets.ticketAccepted": "Ticket accepté",
    "ops.tickets.ticketAcceptedDesc": "Statut mis à jour vers En cours.",
    "ops.tickets.acceptFailed": "Échec de l'acceptation",
    "ops.tickets.deleteConfirm": "Supprimer le ticket invité non valide {tid} ? L'historique de conversation lié est conservé.",
    "ops.tickets.ticketDeleted": "Ticket supprimé",
    "ops.tickets.ticketDeletedDesc": "Ticket {tid} supprimé.",
    "ops.tickets.deleteFailed": "Échec de la suppression",
    "ops.tickets.selectOperatorTitle": "Sélectionner un opérateur",
    "ops.tickets.chooseOperatorReassign": "Choisissez un opérateur à qui réattribuer ce ticket.",
    "ops.tickets.ticketReassigned": "Ticket réattribué",
    "ops.tickets.ticketReassignedDesc": "Le ticket a été réattribué.",
    "ops.tickets.reassignFailed": "Échec de la réattribution",
    "ops.tickets.ticketCreated": "Ticket créé",
    "ops.tickets.ticketCreatedDesc": "Ticket d'assistance créé avec succès",
    "ops.tickets.failedCreate": "Échec de la création du ticket",
    "ops.tickets.emptyMessage": "Message vide",
    "ops.tickets.enterResponse": "Veuillez saisir un message de réponse",
    "ops.tickets.responseSent": "Réponse envoyée",
    "ops.tickets.messageSentSuccess": "Message envoyé avec succès",
    "ops.tickets.failedSendResponse": "Échec de l'envoi de la réponse",
    "ops.tickets.reasonRequired": "Motif requis",
    "ops.tickets.provideEscReason": "Veuillez indiquer un motif d'escalade",
    "ops.tickets.ticketEscalated": "Ticket escaladé",
    "ops.tickets.ticketEscalatedDesc": "Ticket escaladé vers l'assistance de niveau supérieur",
    "ops.tickets.failedEscalate": "Échec de l'escalade du ticket",
    "ops.tickets.ticketResolved": "Ticket résolu",
    "ops.tickets.ticketResolvedDesc": "Ticket marqué comme résolu",
    "ops.tickets.failedResolve": "Échec de la résolution du ticket",
    "ops.tickets.failedLoadTickets": "Échec du chargement des tickets. Veuillez réessayer.",
    "ops.tickets.noConvLinked": "Aucune conversation liée à ce ticket.",
    "ops.tickets.emailResolved": "E-mail résolu",
    "ops.tickets.composingTo": "Rédaction d'un message à {email}",
    "ops.esc.pendingBadge": "{count} en attente",
    "ops.esc.escalationDetail": "Détail de l'escalade",
    "ops.esc.intent": "Intention",
    "ops.esc.escalationReason": "Motif de l'escalade",
    "ops.esc.contextSummary": "Résumé du contexte",
    "ops.esc.aiContextSummary": "Résumé du contexte par l'IA",
    "ops.esc.noContextSummary": "Aucun résumé du contexte disponible.",
    "ops.esc.convTicketId": "ID de conversation / ticket",
    "ops.esc.notAvailable": "Non disponible",
    "ops.esc.escalationId": "ID d'escalade",
    "ops.esc.callbackDue": "Rappel prévu",
    "ops.esc.voiceTranscript": "Transcription vocale",
    "ops.esc.loadingTranscript": "Chargement de la transcription…",
    "ops.esc.noTranscript": "Aucune transcription disponible pour cette session.",
    "ops.esc.call": "Appeler",
    "ops.esc.callHint": "Lance un appel Twilio et enregistre l'événement d'appel dans la conversation",
    "ops.esc.conversationThread": "Fil de conversation",
    "ops.esc.loadingMessages": "Chargement des messages…",
    "ops.esc.noMessagesYet": "Aucun message pour le moment. Envoyez le premier message ci-dessous.",
    "ops.esc.typeMessageCustomer": "Saisissez un message pour le client…",
    "ops.esc.assignedToMe": "Attribué à moi",
    "ops.esc.callbacks": "Rappels",
    "ops.esc.badgeOperator": "Opérateur",
    "ops.esc.badgeManager": "Manager",
    "ops.esc.badgeAdmin": "Admin",
    "ops.esc.noSummaryAvailable": "Aucun résumé disponible",
    "ops.esc.acceptHandle": "Accepter et traiter",
    "ops.esc.viewDetails": "Voir les détails",
    "ops.esc.selectOperatorAssign": "Sélectionner un opérateur à attribuer…",
    "ops.esc.noStaffAvailable": "Aucun membre du personnel disponible",
    "ops.esc.noPendingEsc": "Aucune escalade en attente",
    "ops.esc.allHandledEfficiently": "Toutes les conversations sont traitées efficacement !",
    "ops.esc.noEscAssigned": "Aucune escalade ne vous est attribuée",
    "ops.esc.noEscAssignedHelp": "Les escalades qui vous sont attribuées apparaîtront ici une fois qu'un administrateur les aura attribuées",
    "ops.esc.messageCustomer": "Envoyer un message au client",
    "ops.esc.typeMessageEnter": "Saisissez un message pour le client… (Entrée pour envoyer)",
    "ops.esc.noPendingCallbacks": "Aucun rappel en attente",
    "ops.esc.overdue": "EN RETARD",
    "ops.esc.due": "Échéance",
    "ops.esc.claimCallback": "Prendre en charge le rappel",
    "ops.esc.noResolvedYet": "Aucune escalade résolue pour le moment",
    "ops.esc.completedAppearHere": "Les escalades terminées apparaîtront ici",
    "ops.esc.loadingEscalations": "Chargement des escalades...",
    "ops.esc.resolveEscalation": "Résoudre l'escalade",
    "ops.esc.resolveEscDesc": "Documentez la résolution. Vous pouvez éventuellement la soumettre à Solution Bank pour examen par un manager — les solutions approuvées entraînent l'assistant IA.",
    "ops.esc.resolutionNotes": "Notes de résolution *",
    "ops.esc.submitToSolutionBank": "Soumettre la résolution à Solution Bank pour examen",
    "ops.esc.approveBeforeAi": "Un manager ou un administrateur doit approuver avant que l'IA puisse utiliser cette résolution. Les soumissions non approuvées ne sont jamais utilisées par AI Chat ni AI Voice.",
    "ops.esc.submitForReviewSuffix": " et soumettre pour examen",
    "ops.esc.failedLoadEsc": "Échec du chargement des escalades",
    "ops.esc.checkConnection": "Vérifiez votre connexion et réessayez.",
    "ops.esc.noConvLinkedTitle": "Aucune conversation liée",
    "ops.esc.noConvLinkedDesc": "Cette escalade n'a aucune conversation liée. Impossible d'envoyer un message.",
    "ops.esc.messageSent": "Message envoyé",
    "ops.esc.messageSentPush": "Le client recevra votre message par notification push.",
    "ops.esc.sendFailed": "Échec de l'envoi",
    "ops.esc.failedSendMessage": "Échec de l'envoi du message",
    "ops.esc.noLinkedConvEsc": "Aucune conversation liée pour cette escalade.",
    "ops.esc.cannotResolveEscId": "Impossible de résoudre l'ID d'escalade",
    "ops.esc.cannotSelfAssign": "Auto-attribution impossible",
    "ops.esc.cannotSelfAssignDesc": "Votre profil de membre du personnel est introuvable. Demandez à un administrateur d'attribuer cette escalade.",
    "ops.esc.escAccepted": "Escalade acceptée",
    "ops.esc.statusReceivingAttention": "Statut : Prise en charge en cours",
    "ops.esc.failedAcceptEsc": "Échec de l'acceptation de l'escalade",
    "ops.esc.escResolved": "Escalade résolue",
    "ops.esc.resolutionSubmitted": "Résolution soumise à Solution Bank pour examen par un manager.",
    "ops.esc.statusResolved": "Statut : Résolu",
    "ops.esc.failedResolveEsc": "Échec de la résolution de l'escalade",
    "ops.esc.escAssigned": "Escalade attribuée",
    "ops.esc.failedAssignEsc": "Échec de l'attribution de l'escalade",
    "ops.esc.noEscId": "Aucun ID d'escalade",
    "ops.esc.noEscIdDesc": "Cet enregistrement ne comporte pas d'ID valide.",
    "ops.ops.manageOperators": "Gérer les opérateurs",
    "ops.ops.subtitle": "Surveillance en temps réel et gestion de la performance",
    "ops.ops.dashboard": "Tableau de bord",
    "ops.ops.realtime": "Temps réel",
    "ops.ops.historical": "Historique",
    "ops.ops.scheduleShifts": "Planifier les quarts de travail",
    "ops.ops.shiftNotAvailable": "La planification des quarts de travail n'est pas disponible dans cette version.",
    "ops.ops.shiftCreated": "Quart créé",
    "ops.ops.operator": "Opérateur",
    "ops.ops.certifications": "Certifications",
    "ops.ops.languages": "Langues",
    "ops.ops.coachingNotes": "Notes de coaching",
    "ops.ops.coachingPurpose": "Objectif",
    "ops.ops.coachingSaved": "Séance de coaching enregistrée",
    "ops.ops.historicalMode": "Mode historique",
    "ops.ops.noActivity": "Aucune activité",
    "ops.ops.noCoaching": "Aucune séance de coaching",
    "ops.ops.noShifts": "Aucun quart planifié",
    "ops.ops.skillsSaved": "Compétences enregistrées",
    "ops.ops.queueSettings": "Paramètres de la file d'attente",
    "ops.ops.queueNotAvailable": "La configuration de la file d'attente n'est pas disponible dans cette version.",
    "ops.ops.onlineOperators": "Opérateurs en ligne",
    "ops.ops.callsToday": "Appels aujourd'hui",
    "ops.ops.ticketsResolved": "Tickets résolus",
    "ops.ops.activeTickets": "Tickets actifs",
    "ops.ops.avgAht": "AHT moyen",
    "ops.ops.realtimeModeActive": "Mode temps réel actif — les alertes d'escalade apparaîtront ici",
    "ops.ops.activeOperators": "Opérateurs actifs",
    "ops.ops.noOperators": "Aucun opérateur dans cette entreprise pour le moment.",
    "ops.ops.loadingMetrics": "Chargement des indicateurs des opérateurs…",
    "ops.ops.calls": "Appels",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "Sélectionner un opérateur",
    "ops.ops.chooseOperator": "Choisissez un opérateur dans la liste pour afficher des indicateurs de performance détaillés et la surveillance en temps réel",
    "ops.ops.kpis": "Indicateurs clés de performance",
    "ops.ops.avgHandleTime": "Temps de traitement moyen",
    "ops.ops.firstCallResolution": "Résolution au premier appel",
    "ops.ops.customerSatisfaction": "Satisfaction client",
    "ops.ops.callbackCompliance": "Respect des rappels",
    "ops.ops.todaysStats": "Statistiques du jour",
    "ops.ops.callsHandled": "Appels traités",
    "ops.ops.avgHandleTimeShort": "Temps de traitement moyen",
    "ops.ops.performance": "Performance",
    "ops.ops.liveActivity": "Activité en direct",
    "ops.ops.presence": "Présence",
    "ops.ops.onCall": "En appel",
    "ops.ops.currentConversation": "Conversation en cours",
    "ops.ops.lastActivity": "Dernière activité",
    "ops.ops.skills": "Compétences",
    "ops.ops.coaching": "Accompagnement",
    "ops.ops.liveActivityNA": "La surveillance de l'activité en direct n'est pas encore disponible",
    "ops.ops.liveActivityNADesc": "Le flux d'appels / d'activité en temps réel arrive dans la Révision 2 (OPEN_REVISION_2).",
    "ops.ops.skillsCerts": "Compétences et certifications",
    "ops.ops.skillsNA": "Les compétences et certifications ne sont pas encore suivies",
    "ops.ops.skillsNADesc": "Les compétences / langues / certifications des opérateurs arrivent dans la Révision 2 (OPEN_REVISION_2).",
    "ops.ops.coachingDev": "Accompagnement et développement",
    "ops.ops.coachingNA": "Les outils d'accompagnement et de développement ne sont pas encore disponibles — ils arrivent dans la Révision 2 (OPEN_REVISION_2).",
    "ops.ops.scheduleCoaching": "Planifier un accompagnement",
    "ops.ops.performanceReview": "Évaluation de la performance",
    "ops.ops.whisper": "Whisper",
    "ops.ops.joinCall": "Rejoindre l'appel",
    "ops.ops.supervisionConnectingNotice": "Connexion à la supervision…",
    "ops.ops.whisperActiveNotice": "Mode Whisper actif — accompagnement de l'opérateur (audio vérifié à la sortie).",
    "ops.ops.listeningNotice": "Écoute de l'appel (audio vérifié à la sortie).",
    "ops.ops.stopSupervision": "Arrêter la supervision",
    "ops.ops.whisperHint": "Parlez à l'opérateur sans que le client puisse vous entendre",
    "ops.ops.joinHint": "Rejoignez l'appel afin que tous les participants puissent vous entendre",
    "ops.ops.noActiveCall": "L'opérateur n'a aucun appel actif",
    "ops.ops.featureWhisper": "Supervision Whisper (M11)",
    "ops.ops.featureBarge": "Intrusion / rejoindre l'appel (M11)",
    "ops.ops.notAvailableYet": "— pas encore disponible",
    "ops.ops.rev2Saved": "Arrive dans la Révision 2 (OPEN_REVISION_2). Rien n'a été enregistré.",
    "ops.tm.subtitle": "Ticketing omnicanal avec gestion des SLA et automatisation",
  },
  pt: {
    "ops.common.missingInformation": "Informações Ausentes",
    "ops.common.fillAllRequired": "Preencha todos os campos obrigatórios",
    "ops.common.tryAgain": "Tentar Novamente",
    "ops.common.customer": "Cliente",
    "ops.common.unassigned": "Não Atribuído",
    "ops.common.aiAgent": "Agente de IA",
    "ops.common.status": "Status",
    "ops.common.priority": "Prioridade",
    "ops.common.assignedTo": "Atribuído A",
    "ops.common.pending": "Pendente",
    "ops.common.resolved": "Resolvido",
    "ops.common.resolve": "Resolver",
    "ops.common.assign": "Atribuir",
    "ops.common.view": "Visualizar",
    "ops.common.inProgress": "Em Andamento",
    "ops.common.you": "Você",
    "ops.common.system": "Sistema",
    "ops.common.agent": "Agente",
    "ops.common.cannotCall": "Não é Possível Ligar",
    "ops.common.callInitiated": "Chamada Iniciada",
    "ops.common.callLogged": "Chamada Registrada",
    "ops.common.calling": "Ligando",
    "ops.common.callRecordedFor": "Chamada registrada para",
    "ops.common.callFailed": "Falha na Chamada",
    "ops.common.callNow": "Ligar agora",
    "ops.common.startingCall": "Iniciando chamada…",
    "ops.esc.noConvForCallback": "Nenhuma conversa disponível para este retorno de chamada",
    "ops.esc.cbDueSoon": "Em breve",
    "ops.esc.cbOverdue": "Atrasada",
    "ops.esc.cbScheduled": "Agendada",
    "ops.esc.cbCompleted": "Concluída",
    "ops.esc.cbCancelled": "Cancelada",
    "ops.esc.cbReminderTitle": "Lembrete de retorno",
    "ops.esc.cbDueSoonMsg": "Retorno em breve",
    "ops.common.describeResolution": "Descreva como este problema foi resolvido...",
    "ops.common.selectOperator": "Selecionar operador…",
    "ops.common.nameLabel": "Nome:",
    "ops.common.emailLabel": "E-mail:",
    "ops.staff.subscriptionPlan": "Plano de Assinatura",
    "ops.staff.seatAllocation": "alocação de assentos",
    "ops.staff.inviteStaffMembers": "Convidar Membros da Equipe",
    "ops.staff.inviteDescPre": "Convide membros da equipe por e-mail — cada pessoa recebe um convite personalizado com sua Brand ID",
    "ops.staff.inviteDescMid": "e um link para concluir o autocadastro em",
    "ops.staff.inviteExpire": "Os convites expiram após 7 dias.",
    "ops.staff.emailAddresses": "Endereços de E-mail",
    "ops.staff.emailsPlaceholder": "Insira os endereços de e-mail separados por vírgulas, ponto e vírgula ou novas linhas:",
    "ops.staff.validEmailsDetected": "{count} e-mail(s) válido(s) detectado(s)",
    "ops.staff.defaultRole": "Função Padrão",
    "ops.staff.defaultRoleHelp": "Todos os membros convidados receberão esta função por padrão",
    "ops.staff.invitationPreview": "Prévia do Convite",
    "ops.staff.operatorDefault": "Operador (Padrão)",
    "ops.staff.sendingInvitations": "Enviando Convites…",
    "ops.staff.sendInvitations": "Enviar {count} Convite(s)",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "{count} Membros da Equipe",
    "ops.staff.totalStaff": "Total da Equipe",
    "ops.staff.administrators": "Administradores",
    "ops.staff.operators": "Operadores",
    "ops.staff.otherRoles": "Outras Funções",
    "ops.staff.teamMembers": "Membros da Equipe",
    "ops.staff.membersCount": "{count} membros",
    "ops.staff.noTeamMembers": "Nenhum Membro da Equipe",
    "ops.staff.noTeamMembersHelp": "Convide membros da equipe para se juntarem à equipe da sua empresa",
    "ops.staff.inviteFirst": "Convidar Primeiro Membro da Equipe",
    "ops.staff.changeRole": "Alterar Função",
    "ops.staff.removeStaff": "Remover Membro",
    "ops.staff.regInstructions": "Instruções de Cadastro da Equipe",
    "ops.staff.forNewStaff": "Para novos membros da equipe:",
    "ops.staff.shareBrandId": "Compartilhe sua Brand ID:",
    "ops.staff.directToReg": "Direcione-os para a página de Cadastro da Equipe",
    "ops.staff.assignedOperatorDefault": "Eles receberão a função \"Operador\" por padrão",
    "ops.staff.updateRoleDropdown": "Você pode atualizar a função deles usando o menu suspenso acima",
    "ops.staff.registrationLink": "Link de Cadastro:",
    "ops.staff.changeRoleDesc": "Atualize a função de {name}.",
    "ops.staff.thisStaffMember": "este membro da equipe",
    "ops.staff.saving": "Salvando…",
    "ops.staff.saveRole": "Salvar Função",
    "ops.staff.removeStaffMember": "Remover Membro da Equipe",
    "ops.staff.removeWarning": "Isso revogará imediatamente todo o acesso deste membro da equipe à empresa.",
    "ops.staff.securityImpact": "Impacto na Segurança:",
    "ops.staff.impact1": "perderá TODO o acesso à empresa imediatamente",
    "ops.staff.impact2a": "A conta de equipe deles será",
    "ops.staff.impact2b": "desativada",
    "ops.staff.impact2c": "e o telefone deles será liberado desta empresa",
    "ops.staff.impact3": "Todas as conversas anteriores da empresa serão protegidas e ficarão inacessíveis",
    "ops.staff.impact4": "Eles não poderão acessar nenhum perfil da equipe ou dados da empresa",
    "ops.staff.staffDetails": "Detalhes da Equipe:",
    "ops.staff.currentRole": "Função Atual:",
    "ops.staff.joinDate": "Data de Ingresso:",
    "ops.staff.noteLabel": "Observação:",
    "ops.staff.removeNote": "Esta ação não pode ser desfeita. Se quiser readicionar esta pessoa posteriormente, ela precisará de um novo convite e atribuição de função.",
    "ops.staff.removeRevoke": "Remover e Revogar Acesso",
    "ops.staff.descAdmin": "Acesso total a todos os recursos e à gestão da equipe",
    "ops.staff.descOperator": "Atendimento ao cliente, gestão de tickets, comunicações",
    "ops.staff.descManager": "Supervisão da equipe, relatórios, gestão do SolutionBank",
    "ops.staff.descAnalyst": "Análise de dados, relatórios, métricas de desempenho",
    "ops.staff.descDirector": "Planejamento estratégico, análises de alto nível",
    "ops.staff.descExecutive": "Supervisão do negócio, painéis executivos",
    "ops.staff.descIt": "Gestão técnica, configuração do sistema",
    "ops.staff.enterOneEmail": "Insira pelo menos um endereço de e-mail",
    "ops.staff.invalidEmailFormat": "Formato de E-mail Inválido",
    "ops.staff.enterValidEmails": "Insira endereços de e-mail válidos",
    "ops.staff.invitationsSent": "Convites Enviados",
    "ops.staff.invitesSentDesc": "{sent} de {total} e-mail(s) de convite enviado(s) com sucesso.",
    "ops.staff.invitesFailedSuffix": " {failed} falharam — verifique os endereços.",
    "ops.staff.noInvitationsSent": "Nenhum Convite Enviado",
    "ops.staff.allInvitesFailed": "Todos os convites falharam.",
    "ops.staff.failedToSendInvitations": "Falha ao enviar convites",
    "ops.staff.roleNotAvailable": "Função não disponível no seu plano",
    "ops.staff.roleNotAvailableDesc": "{role} requer um nível de assinatura superior. Faça upgrade para acessar esta função.",
    "ops.staff.roleUpdated": "Função Atualizada",
    "ops.staff.roleUpdatedDesc": "A função do membro da equipe foi atualizada para {role}",
    "ops.staff.roleUpdateFailed": "Falha na Atualização da Função",
    "ops.staff.roleUpdateFailedDesc": "Não foi possível atualizar a função. Tente novamente.",
    "ops.staff.accessRevoked": "Acesso da Equipe Revogado",
    "ops.staff.accessRevokedDesc": "{name} foi removido da lista",
    "ops.staff.removalFailed": "Falha na Remoção",
    "ops.staff.removalFailedDesc": "Não foi possível remover o membro da equipe. Tente novamente.",
    "ops.tickets.loadingBusinessData": "Carregando Dados da Empresa",
    "ops.tickets.loadingBusinessInfo": "Aguarde enquanto carregamos as informações da sua empresa.",
    "ops.tickets.createNewTicket": "Criar Novo Ticket",
    "ops.tickets.createTicketDesc": "Crie um novo ticket de suporte para um cliente",
    "ops.tickets.titleLabel": "Título *",
    "ops.tickets.titlePlaceholder": "Insira o título do ticket",
    "ops.tickets.customerLabel": "Cliente *",
    "ops.tickets.customerPlaceholder": "Nome ou e-mail do cliente",
    "ops.tickets.category": "Categoria",
    "ops.tickets.selectCategory": "Selecionar categoria",
    "ops.tickets.catTechnical": "Suporte Técnico",
    "ops.tickets.catBilling": "Faturamento",
    "ops.tickets.catGeneral": "Consulta Geral",
    "ops.tickets.catFeature": "Solicitação de Recurso",
    "ops.tickets.catBug": "Relatório de Erro",
    "ops.tickets.selectPriority": "Selecionar prioridade",
    "ops.tickets.prioLow": "Baixa",
    "ops.tickets.prioMedium": "Média",
    "ops.tickets.prioHigh": "Alta",
    "ops.tickets.prioUrgent": "Urgente",
    "ops.tickets.prioCritical": "Crítica",
    "ops.tickets.descriptionLabel": "Descrição *",
    "ops.tickets.descriptionPlaceholder": "Descreva o problema ou a solicitação",
    "ops.tickets.createTicket": "Criar Ticket",
    "ops.tickets.filterTickets": "Filtrar Tickets",
    "ops.tickets.filterTicketsDesc": "Aplique filtros para encontrar tickets específicos",
    "ops.tickets.selectStatus": "Selecionar status",
    "ops.tickets.allStatus": "Todos os Status",
    "ops.tickets.statusOpen": "Aberto",
    "ops.tickets.statusInProgress": "Em Andamento",
    "ops.tickets.statusResolved": "Resolvido",
    "ops.tickets.statusClosed": "Fechado",
    "ops.tickets.allPriorities": "Todas as Prioridades",
    "ops.tickets.applyFilters": "Aplicar Filtros",
    "ops.tickets.respondToTicket": "Responder ao Ticket",
    "ops.tickets.respondDesc": "Enviar uma resposta para {customer}",
    "ops.tickets.theCustomer": "o cliente",
    "ops.tickets.responseMessage": "Mensagem de Resposta",
    "ops.tickets.responsePlaceholder": "Digite sua resposta aqui...",
    "ops.tickets.sendResponse": "Enviar Resposta",
    "ops.tickets.escalateTicket": "Escalar Ticket",
    "ops.tickets.escalateDesc": "Escalar o ticket #{id} para o suporte sênior",
    "ops.tickets.escalationReason": "Motivo do Escalonamento",
    "ops.tickets.escalationReasonPlaceholder": "Explique por que este ticket precisa de escalonamento...",
    "ops.tickets.searchTickets": "Buscar tickets...",
    "ops.tickets.tabAll": "Todos",
    "ops.tickets.tabActive": "Ativos",
    "ops.tickets.tabPending": "Pendentes",
    "ops.tickets.tabResolved": "Resolvidos",
    "ops.tickets.showingMyQueue": "Exibindo Minha Fila",
    "ops.tickets.myQueue": "Minha Fila",
    "ops.tickets.loadingTickets": "Carregando tickets...",
    "ops.tickets.noTicketsFound": "Nenhum ticket encontrado",
    "ops.tickets.adjustSearch": "Tente ajustar sua busca ou filtros",
    "ops.tickets.newTicketsAppear": "Novos tickets aparecerão aqui",
    "ops.tickets.phone": "Telefone",
    "ops.tickets.assignedBy": "Atribuído Por",
    "ops.tickets.created": "Criado:",
    "ops.tickets.updated": "Atualizado:",
    "ops.tickets.acceptedBy": "Aceito por:",
    "ops.tickets.resolvedBy": "Resolvido por:",
    "ops.tickets.reassignedBy": "Reatribuído por:",
    "ops.tickets.assignedAt": "Atribuído em:",
    "ops.tickets.loadingConversation": "Carregando conversa...",
    "ops.tickets.noMessages": "Sem mensagens",
    "ops.tickets.noConvHistory": "Nenhum histórico de conversa encontrado para este ticket.",
    "ops.tickets.selectTicket": "Selecione um ticket",
    "ops.tickets.clickTicketLoad": "Clique em um ticket para carregar seu histórico de conversa.",
    "ops.tickets.respond": "Responder",
    "ops.tickets.escalate": "Escalar",
    "ops.tickets.markResolved": "Marcar como Resolvido",
    "ops.tickets.accept": "Aceitar",
    "ops.tickets.reassign": "Reatribuir",
    "ops.tickets.deleteGuest": "Excluir Convidado",
    "ops.tickets.chooseTicketRespond": "Escolha um ticket da lista para ver os detalhes e responder",
    "ops.tickets.reassignTicket": "Reatribuir Ticket",
    "ops.tickets.reassignDesc": "{id} — Transfira este ticket para outro operador ativo.",
    "ops.tickets.reassignTo": "Reatribuir Para",
    "ops.tickets.reasonOptional": "Motivo (opcional)",
    "ops.tickets.reassignReasonPlaceholder": "Por que você está reatribuindo este ticket?",
    "ops.tickets.assignTicket": "Atribuir Ticket",
    "ops.tickets.assignDesc": "{id} — Selecione um operador para atribuir este ticket.",
    "ops.tickets.assignToLabel": "Atribuir Para",
    "ops.tickets.noOperatorsTenant": "Nenhum operador encontrado neste locatário",
    "ops.tickets.noTicketId": "Sem ID de Ticket",
    "ops.tickets.noTicketIdCreate": "Esta conversa não possui um ticket persistido. Crie um ticket primeiro em Novo Ticket.",
    "ops.tickets.noTicketAccept": "Não é possível aceitar — nenhum ticket persistido vinculado a esta conversa.",
    "ops.tickets.noTicketDelete": "Não é possível excluir — nenhum ticket persistido vinculado a esta conversa.",
    "ops.tickets.noTicketLinked": "Nenhum ticket persistido vinculado a esta conversa.",
    "ops.tickets.selectAnOperator": "Selecione um operador",
    "ops.tickets.chooseStaffAssign": "Escolha um membro da equipe para atribuir este ticket.",
    "ops.tickets.ticketAssigned": "Ticket Atribuído",
    "ops.tickets.ticketAssignedDesc": "O ticket foi atribuído.",
    "ops.tickets.assignFailed": "Falha na Atribuição",
    "ops.tickets.ticketAccepted": "Ticket Aceito",
    "ops.tickets.ticketAcceptedDesc": "Status atualizado para Em Andamento.",
    "ops.tickets.acceptFailed": "Falha ao Aceitar",
    "ops.tickets.deleteConfirm": "Excluir o ticket de convidado inválido {tid}? O histórico de conversa vinculado é preservado.",
    "ops.tickets.ticketDeleted": "Ticket Excluído",
    "ops.tickets.ticketDeletedDesc": "Ticket {tid} removido.",
    "ops.tickets.deleteFailed": "Falha na Exclusão",
    "ops.tickets.selectOperatorTitle": "Selecionar Operador",
    "ops.tickets.chooseOperatorReassign": "Escolha um operador para reatribuir este ticket.",
    "ops.tickets.ticketReassigned": "Ticket Reatribuído",
    "ops.tickets.ticketReassignedDesc": "O ticket foi reatribuído.",
    "ops.tickets.reassignFailed": "Falha na Reatribuição",
    "ops.tickets.ticketCreated": "Ticket Criado",
    "ops.tickets.ticketCreatedDesc": "Ticket de suporte criado com sucesso",
    "ops.tickets.failedCreate": "Falha ao criar o ticket",
    "ops.tickets.emptyMessage": "Mensagem Vazia",
    "ops.tickets.enterResponse": "Insira uma mensagem de resposta",
    "ops.tickets.responseSent": "Resposta Enviada",
    "ops.tickets.messageSentSuccess": "Mensagem enviada com sucesso",
    "ops.tickets.failedSendResponse": "Falha ao enviar a resposta",
    "ops.tickets.reasonRequired": "Motivo Obrigatório",
    "ops.tickets.provideEscReason": "Forneça um motivo para o escalonamento",
    "ops.tickets.ticketEscalated": "Ticket Escalado",
    "ops.tickets.ticketEscalatedDesc": "Ticket escalado para o suporte sênior",
    "ops.tickets.failedEscalate": "Falha ao escalar o ticket",
    "ops.tickets.ticketResolved": "Ticket Resolvido",
    "ops.tickets.ticketResolvedDesc": "Ticket marcado como resolvido",
    "ops.tickets.failedResolve": "Falha ao resolver o ticket",
    "ops.tickets.failedLoadTickets": "Falha ao carregar os tickets. Tente novamente.",
    "ops.tickets.noConvLinked": "Nenhuma conversa vinculada a este ticket.",
    "ops.tickets.emailResolved": "E-mail Resolvido",
    "ops.tickets.composingTo": "Redigindo mensagem para {email}",
    "ops.esc.pendingBadge": "{count} pendente(s)",
    "ops.esc.escalationDetail": "Detalhe do Escalonamento",
    "ops.esc.intent": "Intenção",
    "ops.esc.escalationReason": "Motivo do Escalonamento",
    "ops.esc.contextSummary": "Resumo do Contexto",
    "ops.esc.aiContextSummary": "Resumo de Contexto por IA",
    "ops.esc.noContextSummary": "Nenhum resumo de contexto disponível.",
    "ops.esc.convTicketId": "ID da Conversa / Ticket",
    "ops.esc.notAvailable": "Não disponível",
    "ops.esc.escalationId": "ID do Escalonamento",
    "ops.esc.callbackDue": "Retorno Previsto",
    "ops.esc.voiceTranscript": "Transcrição de Voz",
    "ops.esc.loadingTranscript": "Carregando transcrição…",
    "ops.esc.noTranscript": "Nenhuma transcrição disponível para esta sessão.",
    "ops.esc.call": "Ligar",
    "ops.esc.callHint": "Inicia uma chamada Twilio e registra o evento da chamada na conversa",
    "ops.esc.conversationThread": "Fluxo da Conversa",
    "ops.esc.loadingMessages": "Carregando mensagens…",
    "ops.esc.noMessagesYet": "Nenhuma mensagem ainda. Envie a primeira mensagem abaixo.",
    "ops.esc.typeMessageCustomer": "Digite uma mensagem para o cliente…",
    "ops.esc.assignedToMe": "Atribuídos a Mim",
    "ops.esc.callbacks": "Retornos",
    "ops.esc.badgeOperator": "Operador",
    "ops.esc.badgeManager": "Gerente",
    "ops.esc.badgeAdmin": "Admin",
    "ops.esc.noSummaryAvailable": "Nenhum resumo disponível",
    "ops.esc.acceptHandle": "Aceitar e Atender",
    "ops.esc.viewDetails": "Ver Detalhes",
    "ops.esc.selectOperatorAssign": "Selecione o operador para atribuir…",
    "ops.esc.noStaffAvailable": "Nenhum membro da equipe disponível",
    "ops.esc.noPendingEsc": "Nenhum escalonamento pendente",
    "ops.esc.allHandledEfficiently": "Todas as conversas estão sendo atendidas com eficiência!",
    "ops.esc.noEscAssigned": "Nenhum escalonamento atribuído a você",
    "ops.esc.noEscAssignedHelp": "Os escalonamentos atribuídos a você aparecerão aqui assim que um admin os atribuir",
    "ops.esc.messageCustomer": "Enviar Mensagem ao Cliente",
    "ops.esc.typeMessageEnter": "Digite uma mensagem para o cliente… (Enter para enviar)",
    "ops.esc.noPendingCallbacks": "Nenhum retorno pendente",
    "ops.esc.overdue": "ATRASADO",
    "ops.esc.due": "Previsto",
    "ops.esc.claimCallback": "Assumir Retorno",
    "ops.esc.noResolvedYet": "Nenhum escalonamento resolvido ainda",
    "ops.esc.completedAppearHere": "Os escalonamentos concluídos aparecerão aqui",
    "ops.esc.loadingEscalations": "Carregando escalonamentos...",
    "ops.esc.resolveEscalation": "Resolver Escalonamento",
    "ops.esc.resolveEscDesc": "Documente a resolução. Opcionalmente, envie ao Solution Bank para revisão do gerente — soluções aprovadas treinam o assistente de IA.",
    "ops.esc.resolutionNotes": "Notas de Resolução *",
    "ops.esc.submitToSolutionBank": "Enviar resolução ao Solution Bank para revisão",
    "ops.esc.approveBeforeAi": "Um gerente ou admin deve aprovar antes que a IA possa usar esta resolução. Envios não aprovados nunca são usados pelo AI Chat ou AI Voice.",
    "ops.esc.submitForReviewSuffix": " e Enviar para Revisão",
    "ops.esc.failedLoadEsc": "Falha ao carregar os escalonamentos",
    "ops.esc.checkConnection": "Verifique sua conexão e tente novamente.",
    "ops.esc.noConvLinkedTitle": "Nenhuma conversa vinculada",
    "ops.esc.noConvLinkedDesc": "Este escalonamento não possui conversa vinculada. Não é possível enviar mensagem.",
    "ops.esc.messageSent": "Mensagem enviada",
    "ops.esc.messageSentPush": "O cliente receberá sua mensagem por notificação push.",
    "ops.esc.sendFailed": "Falha no envio",
    "ops.esc.failedSendMessage": "Falha ao enviar a mensagem",
    "ops.esc.noLinkedConvEsc": "Nenhuma conversa vinculada a este escalonamento.",
    "ops.esc.cannotResolveEscId": "Não é possível resolver o ID do escalonamento",
    "ops.esc.cannotSelfAssign": "Não é possível autoatribuir",
    "ops.esc.cannotSelfAssignDesc": "Seu perfil de equipe não pôde ser encontrado. Peça a um admin para atribuir este escalonamento.",
    "ops.esc.escAccepted": "Escalonamento aceito",
    "ops.esc.statusReceivingAttention": "Status: Recebendo Atenção",
    "ops.esc.failedAcceptEsc": "Falha ao aceitar o escalonamento",
    "ops.esc.escResolved": "Escalonamento resolvido",
    "ops.esc.resolutionSubmitted": "Resolução enviada ao Solution Bank para revisão do gerente.",
    "ops.esc.statusResolved": "Status: Resolvido",
    "ops.esc.failedResolveEsc": "Falha ao resolver o escalonamento",
    "ops.esc.escAssigned": "Escalonamento atribuído",
    "ops.esc.failedAssignEsc": "Falha ao atribuir o escalonamento",
    "ops.esc.noEscId": "Sem ID de escalonamento",
    "ops.esc.noEscIdDesc": "Este registro não possui um ID válido.",
    "ops.ops.manageOperators": "Gerenciar Operadores",
    "ops.ops.subtitle": "Monitoramento em tempo real e gestão de desempenho",
    "ops.ops.dashboard": "Painel",
    "ops.ops.realtime": "Tempo real",
    "ops.ops.historical": "Histórico",
    "ops.ops.scheduleShifts": "Programar Turnos",
    "ops.ops.shiftNotAvailable": "A programação de turnos não está disponível nesta versão.",
    "ops.ops.shiftCreated": "Turno criado",
    "ops.ops.operator": "Operador",
    "ops.ops.certifications": "Certificações",
    "ops.ops.languages": "Idiomas",
    "ops.ops.coachingNotes": "Notas de coaching",
    "ops.ops.coachingPurpose": "Objetivo",
    "ops.ops.coachingSaved": "Sessão de coaching salva",
    "ops.ops.historicalMode": "Modo histórico",
    "ops.ops.noActivity": "Sem atividade",
    "ops.ops.noCoaching": "Sem sessões de coaching",
    "ops.ops.noShifts": "Sem turnos agendados",
    "ops.ops.skillsSaved": "Habilidades salvas",
    "ops.ops.queueSettings": "Configurações de Fila",
    "ops.ops.queueNotAvailable": "A configuração de fila não está disponível nesta versão.",
    "ops.ops.onlineOperators": "Operadores Online",
    "ops.ops.callsToday": "Chamadas Hoje",
    "ops.ops.ticketsResolved": "Tickets Resolvidos",
    "ops.ops.activeTickets": "Tickets Ativos",
    "ops.ops.avgAht": "AHT Médio",
    "ops.ops.realtimeModeActive": "Modo em tempo real ativo — alertas de escalonamento aparecerão aqui",
    "ops.ops.activeOperators": "Operadores Ativos",
    "ops.ops.noOperators": "Ainda não há operadores nesta empresa.",
    "ops.ops.loadingMetrics": "Carregando métricas do operador…",
    "ops.ops.calls": "Chamadas",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "Selecione um Operador",
    "ops.ops.chooseOperator": "Escolha um operador da lista para ver métricas de desempenho detalhadas e monitoramento em tempo real",
    "ops.ops.kpis": "Indicadores-Chave de Desempenho",
    "ops.ops.avgHandleTime": "Tempo Médio de Atendimento",
    "ops.ops.firstCallResolution": "Resolução na Primeira Chamada",
    "ops.ops.customerSatisfaction": "Satisfação do Cliente",
    "ops.ops.callbackCompliance": "Cumprimento de Retornos",
    "ops.ops.todaysStats": "Estatísticas de Hoje",
    "ops.ops.callsHandled": "Chamadas Atendidas",
    "ops.ops.avgHandleTimeShort": "Tempo Médio de Atend.",
    "ops.ops.performance": "Desempenho",
    "ops.ops.liveActivity": "Atividade ao Vivo",
    "ops.ops.presence": "Presença",
    "ops.ops.onCall": "Em chamada",
    "ops.ops.currentConversation": "Conversa atual",
    "ops.ops.lastActivity": "Última atividade",
    "ops.ops.skills": "Habilidades",
    "ops.ops.coaching": "Treinamento",
    "ops.ops.liveActivityNA": "O monitoramento de atividade ao vivo ainda não está disponível",
    "ops.ops.liveActivityNADesc": "O feed de chamadas / atividades em tempo real chega na Revisão 2 (OPEN_REVISION_2).",
    "ops.ops.skillsCerts": "Habilidades e Certificações",
    "ops.ops.skillsNA": "Habilidades e certificações ainda não são monitoradas",
    "ops.ops.skillsNADesc": "Habilidades / idiomas / certificações dos operadores chegam na Revisão 2 (OPEN_REVISION_2).",
    "ops.ops.coachingDev": "Treinamento e Desenvolvimento",
    "ops.ops.coachingNA": "As ferramentas de treinamento e desenvolvimento ainda não estão disponíveis — elas chegam na Revisão 2 (OPEN_REVISION_2).",
    "ops.ops.scheduleCoaching": "Programar Treinamento",
    "ops.ops.performanceReview": "Avaliação de Desempenho",
    "ops.ops.whisper": "Whisper",
    "ops.ops.joinCall": "Entrar na Chamada",
    "ops.ops.supervisionConnectingNotice": "Conectando à supervisão…",
    "ops.ops.whisperActiveNotice": "Sussurro ativo — orientando o operador.",
    "ops.ops.listeningNotice": "Ouvindo a chamada.",
    "ops.ops.stopSupervision": "Parar a supervisão",
    "ops.ops.whisperHint": "Fale em particular com o operador sem que o cliente o ouça",
    "ops.ops.joinHint": "Entre na chamada para que todos os participantes possam ouvi-lo",
    "ops.ops.noActiveCall": "O operador não tem nenhuma chamada ativa",
    "ops.ops.featureWhisper": "Supervisão por sussurro (M11)",
    "ops.ops.featureBarge": "Interrupção / entrar na chamada (M11)",
    "ops.ops.notAvailableYet": "— ainda não disponível",
    "ops.ops.rev2Saved": "Chega na Revisão 2 (OPEN_REVISION_2). Nada foi salvo.",
    "ops.tm.subtitle": "Emissão de tickets omnichannel com gestão de SLA e automação",
  },
  de: {
    "ops.common.missingInformation": "Fehlende Angaben",
    "ops.common.fillAllRequired": "Bitte füllen Sie alle Pflichtfelder aus",
    "ops.common.tryAgain": "Erneut versuchen",
    "ops.common.customer": "Kunde",
    "ops.common.unassigned": "Nicht zugewiesen",
    "ops.common.aiAgent": "KI-Agent",
    "ops.common.status": "Status",
    "ops.common.priority": "Priorität",
    "ops.common.assignedTo": "Zugewiesen an",
    "ops.common.pending": "Ausstehend",
    "ops.common.resolved": "Gelöst",
    "ops.common.resolve": "Lösen",
    "ops.common.assign": "Zuweisen",
    "ops.common.view": "Ansehen",
    "ops.common.inProgress": "In Bearbeitung",
    "ops.common.you": "Sie",
    "ops.common.system": "System",
    "ops.common.agent": "Agent",
    "ops.common.cannotCall": "Anruf nicht möglich",
    "ops.common.callInitiated": "Anruf eingeleitet",
    "ops.common.callLogged": "Anruf protokolliert",
    "ops.common.calling": "Anruf läuft",
    "ops.common.callRecordedFor": "Anruf protokolliert für",
    "ops.common.callFailed": "Anruf fehlgeschlagen",
    "ops.common.callNow": "Jetzt anrufen",
    "ops.common.startingCall": "Anruf wird gestartet…",
    "ops.esc.noConvForCallback": "Keine Konversation für diesen Rückruf verfügbar",
    "ops.esc.cbDueSoon": "Bald fällig",
    "ops.esc.cbOverdue": "Überfällig",
    "ops.esc.cbScheduled": "Geplant",
    "ops.esc.cbCompleted": "Abgeschlossen",
    "ops.esc.cbCancelled": "Abgebrochen",
    "ops.esc.cbReminderTitle": "Rückruf-Erinnerung",
    "ops.esc.cbDueSoonMsg": "Rückruf bald fällig",
    "ops.common.describeResolution": "Beschreiben Sie, wie dieses Problem gelöst wurde …",
    "ops.common.selectOperator": "Operator auswählen …",
    "ops.common.nameLabel": "Name:",
    "ops.common.emailLabel": "E-Mail:",
    "ops.staff.subscriptionPlan": "Abonnement-Tarif",
    "ops.staff.seatAllocation": "Platzzuteilung",
    "ops.staff.inviteStaffMembers": "Mitarbeiter einladen",
    "ops.staff.inviteDescPre": "Laden Sie Mitarbeiter per E-Mail ein – jede Person erhält eine markenspezifische Einladung mit Ihrer Brand ID",
    "ops.staff.inviteDescMid": "und einen Link zum Abschluss der Selbstregistrierung unter",
    "ops.staff.inviteExpire": "Einladungen verfallen nach 7 Tagen.",
    "ops.staff.emailAddresses": "E-Mail-Adressen",
    "ops.staff.emailsPlaceholder": "Geben Sie E-Mail-Adressen getrennt durch Kommas, Semikolons oder Zeilenumbrüche ein:",
    "ops.staff.validEmailsDetected": "{count} gültige E-Mail-Adresse(n) erkannt",
    "ops.staff.defaultRole": "Standardrolle",
    "ops.staff.defaultRoleHelp": "Allen eingeladenen Mitarbeitern wird standardmäßig diese Rolle zugewiesen",
    "ops.staff.invitationPreview": "Einladungsvorschau",
    "ops.staff.operatorDefault": "Operator (Standard)",
    "ops.staff.sendingInvitations": "Einladungen werden gesendet …",
    "ops.staff.sendInvitations": "{count} Einladung(en) senden",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "{count} Teammitglieder",
    "ops.staff.totalStaff": "Mitarbeiter gesamt",
    "ops.staff.administrators": "Administratoren",
    "ops.staff.operators": "Operatoren",
    "ops.staff.otherRoles": "Weitere Rollen",
    "ops.staff.teamMembers": "Teammitglieder",
    "ops.staff.membersCount": "{count} Mitglieder",
    "ops.staff.noTeamMembers": "Keine Teammitglieder",
    "ops.staff.noTeamMembersHelp": "Laden Sie Mitarbeiter ein, um Ihrem Geschäftsteam beizutreten",
    "ops.staff.inviteFirst": "Ersten Mitarbeiter einladen",
    "ops.staff.changeRole": "Rolle ändern",
    "ops.staff.removeStaff": "Mitarbeiter entfernen",
    "ops.staff.regInstructions": "Anleitung zur Mitarbeiterregistrierung",
    "ops.staff.forNewStaff": "Für neue Mitarbeiter:",
    "ops.staff.shareBrandId": "Teilen Sie Ihre Brand ID:",
    "ops.staff.directToReg": "Leiten Sie sie zur Seite für die Mitarbeiterregistrierung",
    "ops.staff.assignedOperatorDefault": "Ihnen wird standardmäßig die Rolle „Operator“ zugewiesen",
    "ops.staff.updateRoleDropdown": "Sie können ihre Rolle über das Dropdown-Menü oben aktualisieren",
    "ops.staff.registrationLink": "Registrierungslink:",
    "ops.staff.changeRoleDesc": "Aktualisieren Sie die Rolle für {name}.",
    "ops.staff.thisStaffMember": "diesen Mitarbeiter",
    "ops.staff.saving": "Wird gespeichert …",
    "ops.staff.saveRole": "Rolle speichern",
    "ops.staff.removeStaffMember": "Mitarbeiter entfernen",
    "ops.staff.removeWarning": "Dadurch werden sämtliche Geschäftszugriffe dieses Mitarbeiters sofort entzogen.",
    "ops.staff.securityImpact": "Sicherheitsauswirkung:",
    "ops.staff.impact1": "verliert sofort SÄMTLICHE Geschäftszugriffe",
    "ops.staff.impact2a": "Ihr Mitarbeiterkonto wird",
    "ops.staff.impact2b": "deaktiviert",
    "ops.staff.impact2c": "und ihre Telefonnummer aus diesem Unternehmen freigegeben",
    "ops.staff.impact3": "Alle bisherigen Geschäftskonversationen werden gesichert und sind nicht mehr zugänglich",
    "ops.staff.impact4": "Sie können auf keine Mitarbeiterprofile oder Geschäftsdaten mehr zugreifen",
    "ops.staff.staffDetails": "Mitarbeiterdetails:",
    "ops.staff.currentRole": "Aktuelle Rolle:",
    "ops.staff.joinDate": "Beitrittsdatum:",
    "ops.staff.noteLabel": "Hinweis:",
    "ops.staff.removeNote": "Diese Aktion kann nicht rückgängig gemacht werden. Wenn Sie diese Person später erneut hinzufügen möchten, benötigt sie eine neue Einladung und Rollenzuweisung.",
    "ops.staff.removeRevoke": "Entfernen & Zugriff entziehen",
    "ops.staff.descAdmin": "Vollzugriff auf alle Funktionen und die Mitarbeiterverwaltung",
    "ops.staff.descOperator": "Kundenservice, Ticketverwaltung, Kommunikation",
    "ops.staff.descManager": "Teamaufsicht, Berichtswesen, SolutionBank-Verwaltung",
    "ops.staff.descAnalyst": "Datenanalyse, Berichtswesen, Leistungskennzahlen",
    "ops.staff.descDirector": "Strategische Planung, übergeordnete Analysen",
    "ops.staff.descExecutive": "Geschäftsaufsicht, Führungs-Dashboards",
    "ops.staff.descIt": "Technische Verwaltung, Systemkonfiguration",
    "ops.staff.enterOneEmail": "Bitte geben Sie mindestens eine E-Mail-Adresse ein",
    "ops.staff.invalidEmailFormat": "Ungültiges E-Mail-Format",
    "ops.staff.enterValidEmails": "Bitte geben Sie gültige E-Mail-Adressen ein",
    "ops.staff.invitationsSent": "Einladungen gesendet",
    "ops.staff.invitesSentDesc": "{sent} von {total} Einladungs-E-Mail(s) erfolgreich gesendet.",
    "ops.staff.invitesFailedSuffix": " {failed} fehlgeschlagen – Adressen prüfen.",
    "ops.staff.noInvitationsSent": "Keine Einladungen gesendet",
    "ops.staff.allInvitesFailed": "Alle Einladungen fehlgeschlagen.",
    "ops.staff.failedToSendInvitations": "Einladungen konnten nicht gesendet werden",
    "ops.staff.roleNotAvailable": "Rolle in Ihrem Tarif nicht verfügbar",
    "ops.staff.roleNotAvailableDesc": "{role} erfordert eine höhere Abonnementstufe. Führen Sie ein Upgrade durch, um auf diese Rolle zuzugreifen.",
    "ops.staff.roleUpdated": "Rolle aktualisiert",
    "ops.staff.roleUpdatedDesc": "Die Rolle des Mitarbeiters wurde auf {role} aktualisiert",
    "ops.staff.roleUpdateFailed": "Rollenaktualisierung fehlgeschlagen",
    "ops.staff.roleUpdateFailedDesc": "Die Rolle konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    "ops.staff.accessRevoked": "Mitarbeiterzugriff entzogen",
    "ops.staff.accessRevokedDesc": "{name} wurde aus der Liste entfernt",
    "ops.staff.removalFailed": "Entfernen fehlgeschlagen",
    "ops.staff.removalFailedDesc": "Der Mitarbeiter konnte nicht entfernt werden. Bitte versuchen Sie es erneut.",
    "ops.tickets.loadingBusinessData": "Geschäftsdaten werden geladen",
    "ops.tickets.loadingBusinessInfo": "Bitte warten Sie, während wir Ihre Geschäftsinformationen laden.",
    "ops.tickets.createNewTicket": "Neues Ticket erstellen",
    "ops.tickets.createTicketDesc": "Erstellen Sie ein neues Support-Ticket für einen Kunden",
    "ops.tickets.titleLabel": "Titel *",
    "ops.tickets.titlePlaceholder": "Tickettitel eingeben",
    "ops.tickets.customerLabel": "Kunde *",
    "ops.tickets.customerPlaceholder": "Kundenname oder E-Mail",
    "ops.tickets.category": "Kategorie",
    "ops.tickets.selectCategory": "Kategorie auswählen",
    "ops.tickets.catTechnical": "Technischer Support",
    "ops.tickets.catBilling": "Abrechnung",
    "ops.tickets.catGeneral": "Allgemeine Anfrage",
    "ops.tickets.catFeature": "Funktionswunsch",
    "ops.tickets.catBug": "Fehlerbericht",
    "ops.tickets.selectPriority": "Priorität auswählen",
    "ops.tickets.prioLow": "Niedrig",
    "ops.tickets.prioMedium": "Mittel",
    "ops.tickets.prioHigh": "Hoch",
    "ops.tickets.prioUrgent": "Dringend",
    "ops.tickets.prioCritical": "Kritisch",
    "ops.tickets.descriptionLabel": "Beschreibung *",
    "ops.tickets.descriptionPlaceholder": "Beschreiben Sie das Problem oder die Anfrage",
    "ops.tickets.createTicket": "Ticket erstellen",
    "ops.tickets.filterTickets": "Tickets filtern",
    "ops.tickets.filterTicketsDesc": "Wenden Sie Filter an, um bestimmte Tickets zu finden",
    "ops.tickets.selectStatus": "Status auswählen",
    "ops.tickets.allStatus": "Alle Status",
    "ops.tickets.statusOpen": "Offen",
    "ops.tickets.statusInProgress": "In Bearbeitung",
    "ops.tickets.statusResolved": "Gelöst",
    "ops.tickets.statusClosed": "Geschlossen",
    "ops.tickets.allPriorities": "Alle Prioritäten",
    "ops.tickets.applyFilters": "Filter anwenden",
    "ops.tickets.respondToTicket": "Auf Ticket antworten",
    "ops.tickets.respondDesc": "Senden Sie eine Antwort an {customer}",
    "ops.tickets.theCustomer": "den Kunden",
    "ops.tickets.responseMessage": "Antwortnachricht",
    "ops.tickets.responsePlaceholder": "Geben Sie hier Ihre Antwort ein …",
    "ops.tickets.sendResponse": "Antwort senden",
    "ops.tickets.escalateTicket": "Ticket eskalieren",
    "ops.tickets.escalateDesc": "Ticket #{id} an den Senior-Support eskalieren",
    "ops.tickets.escalationReason": "Eskalationsgrund",
    "ops.tickets.escalationReasonPlaceholder": "Erklären Sie, warum dieses Ticket eskaliert werden muss …",
    "ops.tickets.searchTickets": "Tickets suchen …",
    "ops.tickets.tabAll": "Alle",
    "ops.tickets.tabActive": "Aktiv",
    "ops.tickets.tabPending": "Ausstehend",
    "ops.tickets.tabResolved": "Gelöst",
    "ops.tickets.showingMyQueue": "Meine Warteschlange wird angezeigt",
    "ops.tickets.myQueue": "Meine Warteschlange",
    "ops.tickets.loadingTickets": "Tickets werden geladen …",
    "ops.tickets.noTicketsFound": "Keine Tickets gefunden",
    "ops.tickets.adjustSearch": "Versuchen Sie, Ihre Suche oder Filter anzupassen",
    "ops.tickets.newTicketsAppear": "Neue Tickets werden hier angezeigt",
    "ops.tickets.phone": "Telefon",
    "ops.tickets.assignedBy": "Zugewiesen von",
    "ops.tickets.created": "Erstellt:",
    "ops.tickets.updated": "Aktualisiert:",
    "ops.tickets.acceptedBy": "Angenommen von:",
    "ops.tickets.resolvedBy": "Gelöst von:",
    "ops.tickets.reassignedBy": "Neu zugewiesen von:",
    "ops.tickets.assignedAt": "Zugewiesen am:",
    "ops.tickets.loadingConversation": "Konversation wird geladen …",
    "ops.tickets.noMessages": "Keine Nachrichten",
    "ops.tickets.noConvHistory": "Für dieses Ticket wurde kein Konversationsverlauf gefunden.",
    "ops.tickets.selectTicket": "Ticket auswählen",
    "ops.tickets.clickTicketLoad": "Klicken Sie auf ein Ticket, um dessen Konversationsverlauf zu laden.",
    "ops.tickets.respond": "Antworten",
    "ops.tickets.escalate": "Eskalieren",
    "ops.tickets.markResolved": "Als gelöst markieren",
    "ops.tickets.accept": "Annehmen",
    "ops.tickets.reassign": "Neu zuweisen",
    "ops.tickets.deleteGuest": "Gast löschen",
    "ops.tickets.chooseTicketRespond": "Wählen Sie ein Ticket aus der Liste, um Details anzuzeigen und zu antworten",
    "ops.tickets.reassignTicket": "Ticket neu zuweisen",
    "ops.tickets.reassignDesc": "{id} – Übertragen Sie dieses Ticket an einen anderen aktiven Operator.",
    "ops.tickets.reassignTo": "Neu zuweisen an",
    "ops.tickets.reasonOptional": "Grund (optional)",
    "ops.tickets.reassignReasonPlaceholder": "Warum weisen Sie dieses Ticket neu zu?",
    "ops.tickets.assignTicket": "Ticket zuweisen",
    "ops.tickets.assignDesc": "{id} – Wählen Sie einen Operator aus, dem dieses Ticket zugewiesen werden soll.",
    "ops.tickets.assignToLabel": "Zuweisen an",
    "ops.tickets.noOperatorsTenant": "Keine Operatoren in diesem Mandanten gefunden",
    "ops.tickets.noTicketId": "Keine Ticket-ID",
    "ops.tickets.noTicketIdCreate": "Für diese Konversation ist kein dauerhaftes Ticket vorhanden. Erstellen Sie zunächst über „Neues Ticket“ ein Ticket.",
    "ops.tickets.noTicketAccept": "Annehmen nicht möglich – kein dauerhaftes Ticket mit dieser Konversation verknüpft.",
    "ops.tickets.noTicketDelete": "Löschen nicht möglich – kein dauerhaftes Ticket mit dieser Konversation verknüpft.",
    "ops.tickets.noTicketLinked": "Kein dauerhaftes Ticket mit dieser Konversation verknüpft.",
    "ops.tickets.selectAnOperator": "Operator auswählen",
    "ops.tickets.chooseStaffAssign": "Wählen Sie einen Mitarbeiter aus, dem dieses Ticket zugewiesen werden soll.",
    "ops.tickets.ticketAssigned": "Ticket zugewiesen",
    "ops.tickets.ticketAssignedDesc": "Das Ticket wurde zugewiesen.",
    "ops.tickets.assignFailed": "Zuweisung fehlgeschlagen",
    "ops.tickets.ticketAccepted": "Ticket angenommen",
    "ops.tickets.ticketAcceptedDesc": "Status auf „In Bearbeitung“ aktualisiert.",
    "ops.tickets.acceptFailed": "Annahme fehlgeschlagen",
    "ops.tickets.deleteConfirm": "Ungültiges Gast-Ticket {tid} löschen? Der verknüpfte Konversationsverlauf bleibt erhalten.",
    "ops.tickets.ticketDeleted": "Ticket gelöscht",
    "ops.tickets.ticketDeletedDesc": "Ticket {tid} entfernt.",
    "ops.tickets.deleteFailed": "Löschen fehlgeschlagen",
    "ops.tickets.selectOperatorTitle": "Operator auswählen",
    "ops.tickets.chooseOperatorReassign": "Wählen Sie einen Operator aus, dem dieses Ticket neu zugewiesen werden soll.",
    "ops.tickets.ticketReassigned": "Ticket neu zugewiesen",
    "ops.tickets.ticketReassignedDesc": "Das Ticket wurde neu zugewiesen.",
    "ops.tickets.reassignFailed": "Neuzuweisung fehlgeschlagen",
    "ops.tickets.ticketCreated": "Ticket erstellt",
    "ops.tickets.ticketCreatedDesc": "Support-Ticket erfolgreich erstellt",
    "ops.tickets.failedCreate": "Ticket konnte nicht erstellt werden",
    "ops.tickets.emptyMessage": "Leere Nachricht",
    "ops.tickets.enterResponse": "Bitte geben Sie eine Antwortnachricht ein",
    "ops.tickets.responseSent": "Antwort gesendet",
    "ops.tickets.messageSentSuccess": "Nachricht erfolgreich gesendet",
    "ops.tickets.failedSendResponse": "Antwort konnte nicht gesendet werden",
    "ops.tickets.reasonRequired": "Grund erforderlich",
    "ops.tickets.provideEscReason": "Bitte geben Sie einen Eskalationsgrund an",
    "ops.tickets.ticketEscalated": "Ticket eskaliert",
    "ops.tickets.ticketEscalatedDesc": "Ticket an den Senior-Support eskaliert",
    "ops.tickets.failedEscalate": "Ticket konnte nicht eskaliert werden",
    "ops.tickets.ticketResolved": "Ticket gelöst",
    "ops.tickets.ticketResolvedDesc": "Ticket als gelöst markiert",
    "ops.tickets.failedResolve": "Ticket konnte nicht gelöst werden",
    "ops.tickets.failedLoadTickets": "Tickets konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "ops.tickets.noConvLinked": "Keine Konversation mit diesem Ticket verknüpft.",
    "ops.tickets.emailResolved": "E-Mail aufgelöst",
    "ops.tickets.composingTo": "Nachricht an {email} wird verfasst",
    "ops.esc.pendingBadge": "{count} ausstehend",
    "ops.esc.escalationDetail": "Eskalationsdetails",
    "ops.esc.intent": "Absicht",
    "ops.esc.escalationReason": "Eskalationsgrund",
    "ops.esc.contextSummary": "Kontextzusammenfassung",
    "ops.esc.aiContextSummary": "KI-Kontextzusammenfassung",
    "ops.esc.noContextSummary": "Keine Kontextzusammenfassung verfügbar.",
    "ops.esc.convTicketId": "Konversations-/Ticket-ID",
    "ops.esc.notAvailable": "Nicht verfügbar",
    "ops.esc.escalationId": "Eskalations-ID",
    "ops.esc.callbackDue": "Rückruf fällig",
    "ops.esc.voiceTranscript": "Sprachtranskript",
    "ops.esc.loadingTranscript": "Transkript wird geladen …",
    "ops.esc.noTranscript": "Für diese Sitzung ist kein Transkript verfügbar.",
    "ops.esc.call": "Anrufen",
    "ops.esc.callHint": "Startet einen Twilio-Anruf und protokolliert das Anrufereignis in der Konversation",
    "ops.esc.conversationThread": "Konversationsverlauf",
    "ops.esc.loadingMessages": "Nachrichten werden geladen …",
    "ops.esc.noMessagesYet": "Noch keine Nachrichten. Senden Sie unten die erste Nachricht.",
    "ops.esc.typeMessageCustomer": "Geben Sie eine Nachricht an den Kunden ein …",
    "ops.esc.assignedToMe": "Mir zugewiesen",
    "ops.esc.callbacks": "Rückrufe",
    "ops.esc.badgeOperator": "Operator",
    "ops.esc.badgeManager": "Manager",
    "ops.esc.badgeAdmin": "Admin",
    "ops.esc.noSummaryAvailable": "Keine Zusammenfassung verfügbar",
    "ops.esc.acceptHandle": "Annehmen & bearbeiten",
    "ops.esc.viewDetails": "Details anzeigen",
    "ops.esc.selectOperatorAssign": "Operator zum Zuweisen auswählen …",
    "ops.esc.noStaffAvailable": "Keine Mitarbeiter verfügbar",
    "ops.esc.noPendingEsc": "Keine ausstehenden Eskalationen",
    "ops.esc.allHandledEfficiently": "Alle Konversationen werden effizient bearbeitet!",
    "ops.esc.noEscAssigned": "Ihnen sind keine Eskalationen zugewiesen",
    "ops.esc.noEscAssignedHelp": "Ihnen zugewiesene Eskalationen werden hier angezeigt, sobald ein Admin sie zuweist",
    "ops.esc.messageCustomer": "Kunde benachrichtigen",
    "ops.esc.typeMessageEnter": "Geben Sie eine Nachricht an den Kunden ein … (Enter zum Senden)",
    "ops.esc.noPendingCallbacks": "Keine ausstehenden Rückrufe",
    "ops.esc.overdue": "ÜBERFÄLLIG",
    "ops.esc.due": "Fällig",
    "ops.esc.claimCallback": "Rückruf übernehmen",
    "ops.esc.noResolvedYet": "Noch keine gelösten Eskalationen",
    "ops.esc.completedAppearHere": "Abgeschlossene Eskalationen werden hier angezeigt",
    "ops.esc.loadingEscalations": "Eskalationen werden geladen …",
    "ops.esc.resolveEscalation": "Eskalation lösen",
    "ops.esc.resolveEscDesc": "Dokumentieren Sie die Lösung. Optional können Sie sie zur Prüfung durch einen Manager an die Solution Bank übermitteln – genehmigte Lösungen trainieren den KI-Assistenten.",
    "ops.esc.resolutionNotes": "Lösungsnotizen *",
    "ops.esc.submitToSolutionBank": "Lösung zur Prüfung an die Solution Bank übermitteln",
    "ops.esc.approveBeforeAi": "Ein Manager oder Admin muss die Lösung genehmigen, bevor die KI sie verwenden kann. Nicht genehmigte Übermittlungen werden von AI Chat oder AI Voice niemals verwendet.",
    "ops.esc.submitForReviewSuffix": " & zur Prüfung übermitteln",
    "ops.esc.failedLoadEsc": "Eskalationen konnten nicht geladen werden",
    "ops.esc.checkConnection": "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "ops.esc.noConvLinkedTitle": "Keine Konversation verknüpft",
    "ops.esc.noConvLinkedDesc": "Mit dieser Eskalation ist keine Konversation verknüpft. Nachricht kann nicht gesendet werden.",
    "ops.esc.messageSent": "Nachricht gesendet",
    "ops.esc.messageSentPush": "Der Kunde erhält Ihre Nachricht per Push-Benachrichtigung.",
    "ops.esc.sendFailed": "Senden fehlgeschlagen",
    "ops.esc.failedSendMessage": "Nachricht konnte nicht gesendet werden",
    "ops.esc.noLinkedConvEsc": "Keine verknüpfte Konversation für diese Eskalation.",
    "ops.esc.cannotResolveEscId": "Eskalations-ID kann nicht aufgelöst werden",
    "ops.esc.cannotSelfAssign": "Selbstzuweisung nicht möglich",
    "ops.esc.cannotSelfAssignDesc": "Ihr Mitarbeiterprofil konnte nicht gefunden werden. Bitten Sie einen Admin, diese Eskalation zuzuweisen.",
    "ops.esc.escAccepted": "Eskalation angenommen",
    "ops.esc.statusReceivingAttention": "Status: In Bearbeitung",
    "ops.esc.failedAcceptEsc": "Eskalation konnte nicht angenommen werden",
    "ops.esc.escResolved": "Eskalation gelöst",
    "ops.esc.resolutionSubmitted": "Lösung zur Prüfung durch einen Manager an die Solution Bank übermittelt.",
    "ops.esc.statusResolved": "Status: Gelöst",
    "ops.esc.failedResolveEsc": "Eskalation konnte nicht gelöst werden",
    "ops.esc.escAssigned": "Eskalation zugewiesen",
    "ops.esc.failedAssignEsc": "Eskalation konnte nicht zugewiesen werden",
    "ops.esc.noEscId": "Keine Eskalations-ID",
    "ops.esc.noEscIdDesc": "Dieser Datensatz hat keine gültige ID.",
    "ops.ops.manageOperators": "Operatoren verwalten",
    "ops.ops.subtitle": "Echtzeitüberwachung und Leistungsmanagement",
    "ops.ops.dashboard": "Dashboard",
    "ops.ops.realtime": "Echtzeit",
    "ops.ops.historical": "Verlauf",
    "ops.ops.scheduleShifts": "Schichten planen",
    "ops.ops.shiftNotAvailable": "Die Schichtplanung ist in dieser Version nicht verfügbar.",
    "ops.ops.shiftCreated": "Schicht erstellt",
    "ops.ops.operator": "Bediener",
    "ops.ops.certifications": "Zertifizierungen",
    "ops.ops.languages": "Sprachen",
    "ops.ops.coachingNotes": "Coaching-Notizen",
    "ops.ops.coachingPurpose": "Zweck",
    "ops.ops.coachingSaved": "Coaching-Sitzung gespeichert",
    "ops.ops.historicalMode": "Verlaufsmodus",
    "ops.ops.noActivity": "Keine Aktivität",
    "ops.ops.noCoaching": "Keine Coaching-Sitzungen",
    "ops.ops.noShifts": "Keine Schichten geplant",
    "ops.ops.skillsSaved": "Fähigkeiten gespeichert",
    "ops.ops.queueSettings": "Warteschlangeneinstellungen",
    "ops.ops.queueNotAvailable": "Die Warteschlangenkonfiguration ist in dieser Version nicht verfügbar.",
    "ops.ops.onlineOperators": "Online-Operatoren",
    "ops.ops.callsToday": "Anrufe heute",
    "ops.ops.ticketsResolved": "Gelöste Tickets",
    "ops.ops.activeTickets": "Aktive Tickets",
    "ops.ops.avgAht": "Durchschn. AHT",
    "ops.ops.realtimeModeActive": "Echtzeitmodus aktiv – Eskalationswarnungen werden hier angezeigt",
    "ops.ops.activeOperators": "Aktive Operatoren",
    "ops.ops.noOperators": "Noch keine Operatoren in diesem Unternehmen.",
    "ops.ops.loadingMetrics": "Operator-Kennzahlen werden geladen …",
    "ops.ops.calls": "Anrufe",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "Operator auswählen",
    "ops.ops.chooseOperator": "Wählen Sie einen Operator aus der Liste, um detaillierte Leistungskennzahlen und die Echtzeitüberwachung anzuzeigen",
    "ops.ops.kpis": "Wichtige Leistungskennzahlen",
    "ops.ops.avgHandleTime": "Durchschnittliche Bearbeitungszeit",
    "ops.ops.firstCallResolution": "Erstlösungsquote",
    "ops.ops.customerSatisfaction": "Kundenzufriedenheit",
    "ops.ops.callbackCompliance": "Rückruf-Einhaltung",
    "ops.ops.todaysStats": "Heutige Statistiken",
    "ops.ops.callsHandled": "Bearbeitete Anrufe",
    "ops.ops.avgHandleTimeShort": "Durchschn. Bearbeitungszeit",
    "ops.ops.performance": "Leistung",
    "ops.ops.liveActivity": "Live-Aktivität",
    "ops.ops.presence": "Präsenz",
    "ops.ops.onCall": "Im Gespräch",
    "ops.ops.currentConversation": "Aktuelle Konversation",
    "ops.ops.lastActivity": "Letzte Aktivität",
    "ops.ops.skills": "Fähigkeiten",
    "ops.ops.coaching": "Coaching",
    "ops.ops.liveActivityNA": "Die Live-Aktivitätsüberwachung ist noch nicht verfügbar",
    "ops.ops.liveActivityNADesc": "Der Echtzeit-Feed für Anrufe/Aktivitäten erscheint in Revision 2 (OPEN_REVISION_2).",
    "ops.ops.skillsCerts": "Fähigkeiten & Zertifizierungen",
    "ops.ops.skillsNA": "Fähigkeiten & Zertifizierungen werden noch nicht erfasst",
    "ops.ops.skillsNADesc": "Fähigkeiten/Sprachen/Zertifizierungen von Operatoren kommen in Revision 2 (OPEN_REVISION_2).",
    "ops.ops.coachingDev": "Coaching & Entwicklung",
    "ops.ops.coachingNA": "Coaching- & Entwicklungswerkzeuge sind noch nicht verfügbar – sie erscheinen in Revision 2 (OPEN_REVISION_2).",
    "ops.ops.scheduleCoaching": "Coaching planen",
    "ops.ops.performanceReview": "Leistungsbeurteilung",
    "ops.ops.whisper": "Whisper",
    "ops.ops.joinCall": "Anruf beitreten",
    "ops.ops.supervisionConnectingNotice": "Verbindung zur Supervision…",
    "ops.ops.whisperActiveNotice": "Whisper aktiv — Coaching des Operators.",
    "ops.ops.listeningNotice": "Anruf wird mitgehört.",
    "ops.ops.stopSupervision": "Supervision beenden",
    "ops.ops.whisperHint": "Sprechen Sie privat mit dem Operator, ohne dass der Kunde Sie hört",
    "ops.ops.joinHint": "Treten Sie dem Anruf bei, damit alle Teilnehmer Sie hören können",
    "ops.ops.noActiveCall": "Der Operator hat keinen aktiven Anruf",
    "ops.ops.featureWhisper": "Whisper-Supervision (M11)",
    "ops.ops.featureBarge": "Barge-in / Anruf beitreten (M11)",
    "ops.ops.notAvailableYet": "– noch nicht verfügbar",
    "ops.ops.rev2Saved": "Erscheint in Revision 2 (OPEN_REVISION_2). Es wurde nichts gespeichert.",
    "ops.tm.subtitle": "Omnichannel-Ticketing mit SLA-Verwaltung und Automatisierung",
  },
  it: {
    "ops.common.missingInformation": "Informazioni mancanti",
    "ops.common.fillAllRequired": "Compila tutti i campi obbligatori",
    "ops.common.tryAgain": "Riprova",
    "ops.common.customer": "Cliente",
    "ops.common.unassigned": "Non assegnato",
    "ops.common.aiAgent": "Agente AI",
    "ops.common.status": "Stato",
    "ops.common.priority": "Priorità",
    "ops.common.assignedTo": "Assegnato a",
    "ops.common.pending": "In attesa",
    "ops.common.resolved": "Risolto",
    "ops.common.resolve": "Risolvi",
    "ops.common.assign": "Assegna",
    "ops.common.view": "Visualizza",
    "ops.common.inProgress": "In corso",
    "ops.common.you": "Tu",
    "ops.common.system": "Sistema",
    "ops.common.agent": "Agente",
    "ops.common.cannotCall": "Impossibile chiamare",
    "ops.common.callInitiated": "Chiamata avviata",
    "ops.common.callLogged": "Chiamata registrata",
    "ops.common.calling": "Chiamata in corso",
    "ops.common.callRecordedFor": "Chiamata registrata per",
    "ops.common.callFailed": "Chiamata non riuscita",
    "ops.common.callNow": "Chiama ora",
    "ops.common.startingCall": "Avvio chiamata…",
    "ops.esc.noConvForCallback": "Nessuna conversazione disponibile per questa richiamata",
    "ops.esc.cbDueSoon": "A breve",
    "ops.esc.cbOverdue": "In ritardo",
    "ops.esc.cbScheduled": "Programmata",
    "ops.esc.cbCompleted": "Completata",
    "ops.esc.cbCancelled": "Annullata",
    "ops.esc.cbReminderTitle": "Promemoria richiamata",
    "ops.esc.cbDueSoonMsg": "Richiamata a breve",
    "ops.common.describeResolution": "Descrivi come è stato risolto il problema...",
    "ops.common.selectOperator": "Seleziona operatore…",
    "ops.common.nameLabel": "Nome:",
    "ops.common.emailLabel": "Email:",
    "ops.staff.subscriptionPlan": "Piano di abbonamento",
    "ops.staff.seatAllocation": "assegnazione postazioni",
    "ops.staff.inviteStaffMembers": "Invita membri del personale",
    "ops.staff.inviteDescPre": "Invita i membri del personale via email — ogni persona riceve un invito personalizzato con il tuo Brand ID",
    "ops.staff.inviteDescMid": "e un link per completare l'auto-registrazione su",
    "ops.staff.inviteExpire": "Gli inviti scadono dopo 7 giorni.",
    "ops.staff.emailAddresses": "Indirizzi email",
    "ops.staff.emailsPlaceholder": "Inserisci gli indirizzi email separati da virgole, punti e virgola o a capo:",
    "ops.staff.validEmailsDetected": "{count} email valida/e rilevata/e",
    "ops.staff.defaultRole": "Ruolo predefinito",
    "ops.staff.defaultRoleHelp": "A tutto il personale invitato verrà assegnato questo ruolo per impostazione predefinita",
    "ops.staff.invitationPreview": "Anteprima invito",
    "ops.staff.operatorDefault": "Operatore (Predefinito)",
    "ops.staff.sendingInvitations": "Invio inviti in corso…",
    "ops.staff.sendInvitations": "Invia {count} invito/i",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "{count} membri del team",
    "ops.staff.totalStaff": "Personale totale",
    "ops.staff.administrators": "Amministratori",
    "ops.staff.operators": "Operatori",
    "ops.staff.otherRoles": "Altri ruoli",
    "ops.staff.teamMembers": "Membri del team",
    "ops.staff.membersCount": "{count} membri",
    "ops.staff.noTeamMembers": "Nessun membro del team",
    "ops.staff.noTeamMembersHelp": "Invita membri del personale a unirsi al team della tua azienda",
    "ops.staff.inviteFirst": "Invita il primo membro del personale",
    "ops.staff.changeRole": "Modifica ruolo",
    "ops.staff.removeStaff": "Rimuovi personale",
    "ops.staff.regInstructions": "Istruzioni per la registrazione del personale",
    "ops.staff.forNewStaff": "Per i nuovi membri del personale:",
    "ops.staff.shareBrandId": "Condividi il tuo Brand ID:",
    "ops.staff.directToReg": "Indirizzali alla pagina di registrazione del personale",
    "ops.staff.assignedOperatorDefault": "Verrà loro assegnato il ruolo \"Operatore\" per impostazione predefinita",
    "ops.staff.updateRoleDropdown": "Puoi aggiornare il loro ruolo utilizzando il menu a discesa qui sopra",
    "ops.staff.registrationLink": "Link di registrazione:",
    "ops.staff.changeRoleDesc": "Aggiorna il ruolo per {name}.",
    "ops.staff.thisStaffMember": "questo membro del personale",
    "ops.staff.saving": "Salvataggio…",
    "ops.staff.saveRole": "Salva ruolo",
    "ops.staff.removeStaffMember": "Rimuovi membro del personale",
    "ops.staff.removeWarning": "Questa operazione revocherà immediatamente tutto l'accesso aziendale per questo membro del personale.",
    "ops.staff.securityImpact": "Impatto sulla sicurezza:",
    "ops.staff.impact1": "perderà immediatamente TUTTO l'accesso aziendale",
    "ops.staff.impact2a": "Il loro account del personale verrà",
    "ops.staff.impact2b": "disattivato",
    "ops.staff.impact2c": "e il loro telefono rilasciato da questa azienda",
    "ops.staff.impact3": "Tutte le conversazioni aziendali precedenti saranno protette e inaccessibili",
    "ops.staff.impact4": "Non potranno accedere ad alcun profilo del personale o dato aziendale",
    "ops.staff.staffDetails": "Dettagli del personale:",
    "ops.staff.currentRole": "Ruolo attuale:",
    "ops.staff.joinDate": "Data di adesione:",
    "ops.staff.noteLabel": "Nota:",
    "ops.staff.removeNote": "Questa azione non può essere annullata. Se vuoi riaggiungere questa persona in seguito, sarà necessario un nuovo invito e l'assegnazione di un ruolo.",
    "ops.staff.removeRevoke": "Rimuovi e revoca l'accesso",
    "ops.staff.descAdmin": "Accesso completo a tutte le funzionalità e alla gestione del personale",
    "ops.staff.descOperator": "Servizio clienti, gestione ticket, comunicazioni",
    "ops.staff.descManager": "Supervisione del team, reportistica, gestione SolutionBank",
    "ops.staff.descAnalyst": "Analisi dei dati, reportistica, metriche di performance",
    "ops.staff.descDirector": "Pianificazione strategica, analisi di alto livello",
    "ops.staff.descExecutive": "Supervisione aziendale, dashboard esecutive",
    "ops.staff.descIt": "Gestione tecnica, configurazione del sistema",
    "ops.staff.enterOneEmail": "Inserisci almeno un indirizzo email",
    "ops.staff.invalidEmailFormat": "Formato email non valido",
    "ops.staff.enterValidEmails": "Inserisci indirizzi email validi",
    "ops.staff.invitationsSent": "Inviti inviati",
    "ops.staff.invitesSentDesc": "{sent} di {total} email di invito inviate con successo.",
    "ops.staff.invitesFailedSuffix": " {failed} non riuscite — controlla gli indirizzi.",
    "ops.staff.noInvitationsSent": "Nessun invito inviato",
    "ops.staff.allInvitesFailed": "Tutti gli inviti non sono andati a buon fine.",
    "ops.staff.failedToSendInvitations": "Invio degli inviti non riuscito",
    "ops.staff.roleNotAvailable": "Ruolo non disponibile nel tuo piano",
    "ops.staff.roleNotAvailableDesc": "{role} richiede un livello di abbonamento superiore. Esegui l'upgrade per accedere a questo ruolo.",
    "ops.staff.roleUpdated": "Ruolo aggiornato",
    "ops.staff.roleUpdatedDesc": "Il ruolo del membro del personale è stato aggiornato a {role}",
    "ops.staff.roleUpdateFailed": "Aggiornamento del ruolo non riuscito",
    "ops.staff.roleUpdateFailedDesc": "Impossibile aggiornare il ruolo. Riprova.",
    "ops.staff.accessRevoked": "Accesso del personale revocato",
    "ops.staff.accessRevokedDesc": "{name} è stato rimosso dall'elenco",
    "ops.staff.removalFailed": "Rimozione non riuscita",
    "ops.staff.removalFailedDesc": "Impossibile rimuovere il membro del personale. Riprova.",
    "ops.tickets.loadingBusinessData": "Caricamento dati aziendali",
    "ops.tickets.loadingBusinessInfo": "Attendi mentre carichiamo le informazioni della tua azienda.",
    "ops.tickets.createNewTicket": "Crea nuovo ticket",
    "ops.tickets.createTicketDesc": "Crea un nuovo ticket di assistenza per un cliente",
    "ops.tickets.titleLabel": "Titolo *",
    "ops.tickets.titlePlaceholder": "Inserisci il titolo del ticket",
    "ops.tickets.customerLabel": "Cliente *",
    "ops.tickets.customerPlaceholder": "Nome o email del cliente",
    "ops.tickets.category": "Categoria",
    "ops.tickets.selectCategory": "Seleziona categoria",
    "ops.tickets.catTechnical": "Supporto tecnico",
    "ops.tickets.catBilling": "Fatturazione",
    "ops.tickets.catGeneral": "Richiesta generale",
    "ops.tickets.catFeature": "Richiesta di funzionalità",
    "ops.tickets.catBug": "Segnalazione bug",
    "ops.tickets.selectPriority": "Seleziona priorità",
    "ops.tickets.prioLow": "Bassa",
    "ops.tickets.prioMedium": "Media",
    "ops.tickets.prioHigh": "Alta",
    "ops.tickets.prioUrgent": "Urgente",
    "ops.tickets.prioCritical": "Critica",
    "ops.tickets.descriptionLabel": "Descrizione *",
    "ops.tickets.descriptionPlaceholder": "Descrivi il problema o la richiesta",
    "ops.tickets.createTicket": "Crea ticket",
    "ops.tickets.filterTickets": "Filtra ticket",
    "ops.tickets.filterTicketsDesc": "Applica filtri per trovare ticket specifici",
    "ops.tickets.selectStatus": "Seleziona stato",
    "ops.tickets.allStatus": "Tutti gli stati",
    "ops.tickets.statusOpen": "Aperto",
    "ops.tickets.statusInProgress": "In corso",
    "ops.tickets.statusResolved": "Risolto",
    "ops.tickets.statusClosed": "Chiuso",
    "ops.tickets.allPriorities": "Tutte le priorità",
    "ops.tickets.applyFilters": "Applica filtri",
    "ops.tickets.respondToTicket": "Rispondi al ticket",
    "ops.tickets.respondDesc": "Invia una risposta a {customer}",
    "ops.tickets.theCustomer": "il cliente",
    "ops.tickets.responseMessage": "Messaggio di risposta",
    "ops.tickets.responsePlaceholder": "Scrivi qui la tua risposta...",
    "ops.tickets.sendResponse": "Invia risposta",
    "ops.tickets.escalateTicket": "Inoltra ticket",
    "ops.tickets.escalateDesc": "Inoltra il ticket #{id} al supporto senior",
    "ops.tickets.escalationReason": "Motivo dell'inoltro",
    "ops.tickets.escalationReasonPlaceholder": "Spiega perché questo ticket necessita di un inoltro...",
    "ops.tickets.searchTickets": "Cerca ticket...",
    "ops.tickets.tabAll": "Tutti",
    "ops.tickets.tabActive": "Attivi",
    "ops.tickets.tabPending": "In attesa",
    "ops.tickets.tabResolved": "Risolti",
    "ops.tickets.showingMyQueue": "Visualizzazione della mia coda",
    "ops.tickets.myQueue": "La mia coda",
    "ops.tickets.loadingTickets": "Caricamento ticket...",
    "ops.tickets.noTicketsFound": "Nessun ticket trovato",
    "ops.tickets.adjustSearch": "Prova a modificare la ricerca o i filtri",
    "ops.tickets.newTicketsAppear": "I nuovi ticket appariranno qui",
    "ops.tickets.phone": "Telefono",
    "ops.tickets.assignedBy": "Assegnato da",
    "ops.tickets.created": "Creato:",
    "ops.tickets.updated": "Aggiornato:",
    "ops.tickets.acceptedBy": "Accettato da:",
    "ops.tickets.resolvedBy": "Risolto da:",
    "ops.tickets.reassignedBy": "Riassegnato da:",
    "ops.tickets.assignedAt": "Assegnato il:",
    "ops.tickets.loadingConversation": "Caricamento conversazione...",
    "ops.tickets.noMessages": "Nessun messaggio",
    "ops.tickets.noConvHistory": "Nessuna cronologia delle conversazioni trovata per questo ticket.",
    "ops.tickets.selectTicket": "Seleziona un ticket",
    "ops.tickets.clickTicketLoad": "Fai clic su un ticket per caricarne la cronologia delle conversazioni.",
    "ops.tickets.respond": "Rispondi",
    "ops.tickets.escalate": "Inoltra",
    "ops.tickets.markResolved": "Segna come risolto",
    "ops.tickets.accept": "Accetta",
    "ops.tickets.reassign": "Riassegna",
    "ops.tickets.deleteGuest": "Elimina ospite",
    "ops.tickets.chooseTicketRespond": "Scegli un ticket dall'elenco per visualizzarne i dettagli e rispondere",
    "ops.tickets.reassignTicket": "Riassegna ticket",
    "ops.tickets.reassignDesc": "{id} — Trasferisci questo ticket a un altro operatore attivo.",
    "ops.tickets.reassignTo": "Riassegna a",
    "ops.tickets.reasonOptional": "Motivo (facoltativo)",
    "ops.tickets.reassignReasonPlaceholder": "Perché stai riassegnando questo ticket?",
    "ops.tickets.assignTicket": "Assegna ticket",
    "ops.tickets.assignDesc": "{id} — Seleziona un operatore a cui assegnare questo ticket.",
    "ops.tickets.assignToLabel": "Assegna a",
    "ops.tickets.noOperatorsTenant": "Nessun operatore trovato in questo tenant",
    "ops.tickets.noTicketId": "Nessun ID ticket",
    "ops.tickets.noTicketIdCreate": "Questa conversazione non ha un ticket persistente. Crea prima un ticket tramite Nuovo ticket.",
    "ops.tickets.noTicketAccept": "Impossibile accettare — nessun ticket persistente collegato a questa conversazione.",
    "ops.tickets.noTicketDelete": "Impossibile eliminare — nessun ticket persistente collegato a questa conversazione.",
    "ops.tickets.noTicketLinked": "Nessun ticket persistente collegato a questa conversazione.",
    "ops.tickets.selectAnOperator": "Seleziona un operatore",
    "ops.tickets.chooseStaffAssign": "Scegli un membro del personale a cui assegnare questo ticket.",
    "ops.tickets.ticketAssigned": "Ticket assegnato",
    "ops.tickets.ticketAssignedDesc": "Il ticket è stato assegnato.",
    "ops.tickets.assignFailed": "Assegnazione non riuscita",
    "ops.tickets.ticketAccepted": "Ticket accettato",
    "ops.tickets.ticketAcceptedDesc": "Stato aggiornato a In corso.",
    "ops.tickets.acceptFailed": "Accettazione non riuscita",
    "ops.tickets.deleteConfirm": "Eliminare il ticket ospite non valido {tid}? La cronologia della conversazione collegata viene conservata.",
    "ops.tickets.ticketDeleted": "Ticket eliminato",
    "ops.tickets.ticketDeletedDesc": "Ticket {tid} rimosso.",
    "ops.tickets.deleteFailed": "Eliminazione non riuscita",
    "ops.tickets.selectOperatorTitle": "Seleziona operatore",
    "ops.tickets.chooseOperatorReassign": "Scegli un operatore a cui riassegnare questo ticket.",
    "ops.tickets.ticketReassigned": "Ticket riassegnato",
    "ops.tickets.ticketReassignedDesc": "Il ticket è stato riassegnato.",
    "ops.tickets.reassignFailed": "Riassegnazione non riuscita",
    "ops.tickets.ticketCreated": "Ticket creato",
    "ops.tickets.ticketCreatedDesc": "Ticket di assistenza creato con successo",
    "ops.tickets.failedCreate": "Creazione del ticket non riuscita",
    "ops.tickets.emptyMessage": "Messaggio vuoto",
    "ops.tickets.enterResponse": "Inserisci un messaggio di risposta",
    "ops.tickets.responseSent": "Risposta inviata",
    "ops.tickets.messageSentSuccess": "Messaggio inviato con successo",
    "ops.tickets.failedSendResponse": "Invio della risposta non riuscito",
    "ops.tickets.reasonRequired": "Motivo obbligatorio",
    "ops.tickets.provideEscReason": "Fornisci un motivo per l'inoltro",
    "ops.tickets.ticketEscalated": "Ticket inoltrato",
    "ops.tickets.ticketEscalatedDesc": "Ticket inoltrato al supporto senior",
    "ops.tickets.failedEscalate": "Inoltro del ticket non riuscito",
    "ops.tickets.ticketResolved": "Ticket risolto",
    "ops.tickets.ticketResolvedDesc": "Ticket segnato come risolto",
    "ops.tickets.failedResolve": "Risoluzione del ticket non riuscita",
    "ops.tickets.failedLoadTickets": "Caricamento dei ticket non riuscito. Riprova.",
    "ops.tickets.noConvLinked": "Nessuna conversazione collegata a questo ticket.",
    "ops.tickets.emailResolved": "Email risolta",
    "ops.tickets.composingTo": "Composizione del messaggio per {email}",
    "ops.esc.pendingBadge": "{count} in attesa",
    "ops.esc.escalationDetail": "Dettaglio inoltro",
    "ops.esc.intent": "Intento",
    "ops.esc.escalationReason": "Motivo dell'inoltro",
    "ops.esc.contextSummary": "Riepilogo del contesto",
    "ops.esc.aiContextSummary": "Riepilogo del contesto AI",
    "ops.esc.noContextSummary": "Nessun riepilogo del contesto disponibile.",
    "ops.esc.convTicketId": "ID conversazione / ticket",
    "ops.esc.notAvailable": "Non disponibile",
    "ops.esc.escalationId": "ID inoltro",
    "ops.esc.callbackDue": "Richiamata prevista",
    "ops.esc.voiceTranscript": "Trascrizione vocale",
    "ops.esc.loadingTranscript": "Caricamento trascrizione…",
    "ops.esc.noTranscript": "Nessuna trascrizione disponibile per questa sessione.",
    "ops.esc.call": "Chiama",
    "ops.esc.callHint": "Avvia una chiamata Twilio e registra l'evento di chiamata nella conversazione",
    "ops.esc.conversationThread": "Thread della conversazione",
    "ops.esc.loadingMessages": "Caricamento messaggi…",
    "ops.esc.noMessagesYet": "Ancora nessun messaggio. Invia il primo messaggio qui sotto.",
    "ops.esc.typeMessageCustomer": "Scrivi un messaggio al cliente…",
    "ops.esc.assignedToMe": "Assegnati a me",
    "ops.esc.callbacks": "Richiamate",
    "ops.esc.badgeOperator": "Operatore",
    "ops.esc.badgeManager": "Manager",
    "ops.esc.badgeAdmin": "Admin",
    "ops.esc.noSummaryAvailable": "Nessun riepilogo disponibile",
    "ops.esc.acceptHandle": "Accetta e gestisci",
    "ops.esc.viewDetails": "Visualizza dettagli",
    "ops.esc.selectOperatorAssign": "Seleziona operatore da assegnare…",
    "ops.esc.noStaffAvailable": "Nessun membro del personale disponibile",
    "ops.esc.noPendingEsc": "Nessun inoltro in attesa",
    "ops.esc.allHandledEfficiently": "Tutte le conversazioni vengono gestite in modo efficiente!",
    "ops.esc.noEscAssigned": "Nessun inoltro assegnato a te",
    "ops.esc.noEscAssignedHelp": "Gli inoltri assegnati a te appariranno qui una volta che un amministratore li assegna",
    "ops.esc.messageCustomer": "Invia messaggio al cliente",
    "ops.esc.typeMessageEnter": "Scrivi un messaggio al cliente… (Invio per inviare)",
    "ops.esc.noPendingCallbacks": "Nessuna richiamata in attesa",
    "ops.esc.overdue": "IN RITARDO",
    "ops.esc.due": "Prevista",
    "ops.esc.claimCallback": "Prendi in carico la richiamata",
    "ops.esc.noResolvedYet": "Ancora nessun inoltro risolto",
    "ops.esc.completedAppearHere": "Gli inoltri completati appariranno qui",
    "ops.esc.loadingEscalations": "Caricamento inoltri...",
    "ops.esc.resolveEscalation": "Risolvi inoltro",
    "ops.esc.resolveEscDesc": "Documenta la risoluzione. Facoltativamente, invia alla Solution Bank per la revisione del manager — le soluzioni approvate addestrano l'assistente AI.",
    "ops.esc.resolutionNotes": "Note di risoluzione *",
    "ops.esc.submitToSolutionBank": "Invia la risoluzione alla Solution Bank per la revisione",
    "ops.esc.approveBeforeAi": "Un manager o un amministratore deve approvare prima che l'AI possa utilizzare questa risoluzione. Gli invii non approvati non vengono mai utilizzati da AI Chat o AI Voice.",
    "ops.esc.submitForReviewSuffix": " e invia per la revisione",
    "ops.esc.failedLoadEsc": "Caricamento degli inoltri non riuscito",
    "ops.esc.checkConnection": "Controlla la connessione e riprova.",
    "ops.esc.noConvLinkedTitle": "Nessuna conversazione collegata",
    "ops.esc.noConvLinkedDesc": "Questo inoltro non ha una conversazione collegata. Impossibile inviare il messaggio.",
    "ops.esc.messageSent": "Messaggio inviato",
    "ops.esc.messageSentPush": "Il cliente riceverà il tuo messaggio tramite notifica push.",
    "ops.esc.sendFailed": "Invio non riuscito",
    "ops.esc.failedSendMessage": "Invio del messaggio non riuscito",
    "ops.esc.noLinkedConvEsc": "Nessuna conversazione collegata a questo inoltro.",
    "ops.esc.cannotResolveEscId": "Impossibile risolvere l'ID dell'inoltro",
    "ops.esc.cannotSelfAssign": "Impossibile auto-assegnarsi",
    "ops.esc.cannotSelfAssignDesc": "Impossibile trovare il tuo profilo del personale. Chiedi a un amministratore di assegnare questo inoltro.",
    "ops.esc.escAccepted": "Inoltro accettato",
    "ops.esc.statusReceivingAttention": "Stato: In fase di gestione",
    "ops.esc.failedAcceptEsc": "Accettazione dell'inoltro non riuscita",
    "ops.esc.escResolved": "Inoltro risolto",
    "ops.esc.resolutionSubmitted": "Risoluzione inviata alla Solution Bank per la revisione del manager.",
    "ops.esc.statusResolved": "Stato: Risolto",
    "ops.esc.failedResolveEsc": "Risoluzione dell'inoltro non riuscita",
    "ops.esc.escAssigned": "Inoltro assegnato",
    "ops.esc.failedAssignEsc": "Assegnazione dell'inoltro non riuscita",
    "ops.esc.noEscId": "Nessun ID inoltro",
    "ops.esc.noEscIdDesc": "Questo record non ha un ID valido.",
    "ops.ops.manageOperators": "Gestisci operatori",
    "ops.ops.subtitle": "Monitoraggio in tempo reale e gestione delle performance",
    "ops.ops.dashboard": "Dashboard",
    "ops.ops.realtime": "Tempo reale",
    "ops.ops.historical": "Storico",
    "ops.ops.scheduleShifts": "Pianifica turni",
    "ops.ops.shiftNotAvailable": "La pianificazione dei turni non è disponibile in questa versione.",
    "ops.ops.shiftCreated": "Turno creato",
    "ops.ops.operator": "Operatore",
    "ops.ops.certifications": "Certificazioni",
    "ops.ops.languages": "Lingue",
    "ops.ops.coachingNotes": "Note di coaching",
    "ops.ops.coachingPurpose": "Scopo",
    "ops.ops.coachingSaved": "Sessione di coaching salvata",
    "ops.ops.historicalMode": "Modalità storica",
    "ops.ops.noActivity": "Nessuna attività",
    "ops.ops.noCoaching": "Nessuna sessione di coaching",
    "ops.ops.noShifts": "Nessun turno pianificato",
    "ops.ops.skillsSaved": "Competenze salvate",
    "ops.ops.queueSettings": "Impostazioni coda",
    "ops.ops.queueNotAvailable": "La configurazione della coda non è disponibile in questa versione.",
    "ops.ops.onlineOperators": "Operatori online",
    "ops.ops.callsToday": "Chiamate oggi",
    "ops.ops.ticketsResolved": "Ticket risolti",
    "ops.ops.activeTickets": "Ticket attivi",
    "ops.ops.avgAht": "AHT medio",
    "ops.ops.realtimeModeActive": "Modalità tempo reale attiva — gli avvisi di inoltro appariranno qui",
    "ops.ops.activeOperators": "Operatori attivi",
    "ops.ops.noOperators": "Ancora nessun operatore in questa azienda.",
    "ops.ops.loadingMetrics": "Caricamento metriche operatore…",
    "ops.ops.calls": "Chiamate",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "Seleziona un operatore",
    "ops.ops.chooseOperator": "Scegli un operatore dall'elenco per visualizzare metriche di performance dettagliate e il monitoraggio in tempo reale",
    "ops.ops.kpis": "Indicatori chiave di performance",
    "ops.ops.avgHandleTime": "Tempo medio di gestione",
    "ops.ops.firstCallResolution": "Risoluzione alla prima chiamata",
    "ops.ops.customerSatisfaction": "Soddisfazione del cliente",
    "ops.ops.callbackCompliance": "Conformità delle richiamate",
    "ops.ops.todaysStats": "Statistiche di oggi",
    "ops.ops.callsHandled": "Chiamate gestite",
    "ops.ops.avgHandleTimeShort": "Tempo medio di gestione",
    "ops.ops.performance": "Performance",
    "ops.ops.liveActivity": "Attività in tempo reale",
    "ops.ops.presence": "Presenza",
    "ops.ops.onCall": "In chiamata",
    "ops.ops.currentConversation": "Conversazione attuale",
    "ops.ops.lastActivity": "Ultima attività",
    "ops.ops.skills": "Competenze",
    "ops.ops.coaching": "Coaching",
    "ops.ops.liveActivityNA": "Il monitoraggio dell'attività in tempo reale non è ancora disponibile",
    "ops.ops.liveActivityNADesc": "Il feed in tempo reale delle chiamate / attività arriverà nella Revisione 2 (OPEN_REVISION_2).",
    "ops.ops.skillsCerts": "Competenze e certificazioni",
    "ops.ops.skillsNA": "Le competenze e le certificazioni non sono ancora tracciate",
    "ops.ops.skillsNADesc": "Le competenze / lingue / certificazioni degli operatori arriveranno nella Revisione 2 (OPEN_REVISION_2).",
    "ops.ops.coachingDev": "Coaching e sviluppo",
    "ops.ops.coachingNA": "Gli strumenti di coaching e sviluppo non sono ancora disponibili — arriveranno nella Revisione 2 (OPEN_REVISION_2).",
    "ops.ops.scheduleCoaching": "Pianifica coaching",
    "ops.ops.performanceReview": "Valutazione delle performance",
    "ops.ops.whisper": "Whisper",
    "ops.ops.joinCall": "Unisciti alla chiamata",
    "ops.ops.supervisionConnectingNotice": "Connessione alla supervisione…",
    "ops.ops.whisperActiveNotice": "Whisper attivo — affiancamento dell'operatore.",
    "ops.ops.listeningNotice": "Ascolto della chiamata.",
    "ops.ops.stopSupervision": "Interrompi la supervisione",
    "ops.ops.whisperHint": "Parla in privato con l'operatore senza che il cliente ti senta",
    "ops.ops.joinHint": "Unisciti alla chiamata così tutti i partecipanti possono sentirti",
    "ops.ops.noActiveCall": "L'operatore non ha nessuna chiamata attiva",
    "ops.ops.featureWhisper": "Supervisione Whisper (M11)",
    "ops.ops.featureBarge": "Barge-in / unione alla chiamata (M11)",
    "ops.ops.notAvailableYet": "— non ancora disponibile",
    "ops.ops.rev2Saved": "Arriverà nella Revisione 2 (OPEN_REVISION_2). Nulla è stato salvato.",
    "ops.tm.subtitle": "Ticketing omnicanale con gestione SLA e automazione",
  },
  ja: {
    "ops.common.missingInformation": "情報が不足しています",
    "ops.common.fillAllRequired": "必須項目をすべて入力してください",
    "ops.common.tryAgain": "再試行",
    "ops.common.customer": "顧客",
    "ops.common.unassigned": "未割り当て",
    "ops.common.aiAgent": "AIエージェント",
    "ops.common.status": "ステータス",
    "ops.common.priority": "優先度",
    "ops.common.assignedTo": "割り当て先",
    "ops.common.pending": "保留中",
    "ops.common.resolved": "解決済み",
    "ops.common.resolve": "解決",
    "ops.common.assign": "割り当て",
    "ops.common.view": "表示",
    "ops.common.inProgress": "対応中",
    "ops.common.you": "あなた",
    "ops.common.system": "システム",
    "ops.common.agent": "エージェント",
    "ops.common.cannotCall": "発信できません",
    "ops.common.callInitiated": "発信を開始しました",
    "ops.common.callLogged": "通話を記録しました",
    "ops.common.calling": "発信中",
    "ops.common.callRecordedFor": "通話の記録先",
    "ops.common.callFailed": "発信に失敗しました",
    "ops.common.callNow": "今すぐ発信",
    "ops.common.startingCall": "発信中…",
    "ops.esc.noConvForCallback": "このコールバックに利用できる会話がありません",
    "ops.esc.cbDueSoon": "まもなく",
    "ops.esc.cbOverdue": "期限超過",
    "ops.esc.cbScheduled": "予定",
    "ops.esc.cbCompleted": "完了",
    "ops.esc.cbCancelled": "キャンセル",
    "ops.esc.cbReminderTitle": "コールバックのリマインダー",
    "ops.esc.cbDueSoonMsg": "まもなくコールバック",
    "ops.common.describeResolution": "この問題がどのように解決されたかを記述してください...",
    "ops.common.selectOperator": "オペレーターを選択…",
    "ops.common.nameLabel": "名前:",
    "ops.common.emailLabel": "メール:",
    "ops.staff.subscriptionPlan": "サブスクリプションプラン",
    "ops.staff.seatAllocation": "シート割り当て",
    "ops.staff.inviteStaffMembers": "スタッフを招待",
    "ops.staff.inviteDescPre": "メールでスタッフを招待します。各メンバーには、貴社のBrand IDが記載されたブランド付き招待状が届きます",
    "ops.staff.inviteDescMid": "また、次の場所でセルフ登録を完了するためのリンクが含まれます:",
    "ops.staff.inviteExpire": "招待状は7日後に有効期限が切れます。",
    "ops.staff.emailAddresses": "メールアドレス",
    "ops.staff.emailsPlaceholder": "カンマ、セミコロン、または改行で区切ってメールアドレスを入力してください:",
    "ops.staff.validEmailsDetected": "{count}件の有効なメールアドレスが検出されました",
    "ops.staff.defaultRole": "デフォルトの役割",
    "ops.staff.defaultRoleHelp": "招待されたすべてのスタッフには、デフォルトでこの役割が割り当てられます",
    "ops.staff.invitationPreview": "招待状のプレビュー",
    "ops.staff.operatorDefault": "オペレーター(デフォルト)",
    "ops.staff.sendingInvitations": "招待状を送信中…",
    "ops.staff.sendInvitations": "{count}件の招待状を送信",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "{count}人のチームメンバー",
    "ops.staff.totalStaff": "スタッフ総数",
    "ops.staff.administrators": "管理者",
    "ops.staff.operators": "オペレーター",
    "ops.staff.otherRoles": "その他の役割",
    "ops.staff.teamMembers": "チームメンバー",
    "ops.staff.membersCount": "{count}人のメンバー",
    "ops.staff.noTeamMembers": "チームメンバーがいません",
    "ops.staff.noTeamMembersHelp": "スタッフを招待して、貴社のチームに参加してもらいましょう",
    "ops.staff.inviteFirst": "最初のスタッフを招待",
    "ops.staff.changeRole": "役割を変更",
    "ops.staff.removeStaff": "スタッフを削除",
    "ops.staff.regInstructions": "スタッフ登録手順",
    "ops.staff.forNewStaff": "新しいスタッフの方へ:",
    "ops.staff.shareBrandId": "貴社のBrand IDを共有してください:",
    "ops.staff.directToReg": "スタッフ登録ページへ案内してください",
    "ops.staff.assignedOperatorDefault": "デフォルトで「オペレーター」の役割が割り当てられます",
    "ops.staff.updateRoleDropdown": "上のドロップダウンから役割を更新できます",
    "ops.staff.registrationLink": "登録リンク:",
    "ops.staff.changeRoleDesc": "{name}の役割を更新します。",
    "ops.staff.thisStaffMember": "このスタッフ",
    "ops.staff.saving": "保存中…",
    "ops.staff.saveRole": "役割を保存",
    "ops.staff.removeStaffMember": "スタッフを削除",
    "ops.staff.removeWarning": "このスタッフのすべての業務アクセス権が直ちに取り消されます。",
    "ops.staff.securityImpact": "セキュリティへの影響:",
    "ops.staff.impact1": "すべての業務アクセス権が直ちに失われます",
    "ops.staff.impact2a": "スタッフアカウントは",
    "ops.staff.impact2b": "無効化されます",
    "ops.staff.impact2c": "また、電話番号はこの事業から解放されます",
    "ops.staff.impact3": "これまでの業務上の会話はすべて保護され、アクセスできなくなります",
    "ops.staff.impact4": "スタッフプロフィールや業務データには一切アクセスできなくなります",
    "ops.staff.staffDetails": "スタッフ詳細:",
    "ops.staff.currentRole": "現在の役割:",
    "ops.staff.joinDate": "参加日:",
    "ops.staff.noteLabel": "注記:",
    "ops.staff.removeNote": "この操作は取り消せません。後でこの人を再度追加する場合は、新しい招待状と役割の割り当てが必要になります。",
    "ops.staff.removeRevoke": "削除してアクセス権を取り消す",
    "ops.staff.descAdmin": "すべての機能とスタッフ管理へのフルアクセス",
    "ops.staff.descOperator": "カスタマーサービス、チケット管理、コミュニケーション",
    "ops.staff.descManager": "チーム監督、レポート作成、SolutionBank管理",
    "ops.staff.descAnalyst": "データ分析、レポート作成、パフォーマンス指標",
    "ops.staff.descDirector": "戦略立案、高度な分析",
    "ops.staff.descExecutive": "事業監督、経営ダッシュボード",
    "ops.staff.descIt": "技術管理、システム構成",
    "ops.staff.enterOneEmail": "メールアドレスを少なくとも1件入力してください",
    "ops.staff.invalidEmailFormat": "無効なメール形式",
    "ops.staff.enterValidEmails": "有効なメールアドレスを入力してください",
    "ops.staff.invitationsSent": "招待状を送信しました",
    "ops.staff.invitesSentDesc": "{total}件中{sent}件の招待メールが正常に送信されました。",
    "ops.staff.invitesFailedSuffix": " {failed}件が失敗しました — アドレスをご確認ください。",
    "ops.staff.noInvitationsSent": "招待状は送信されませんでした",
    "ops.staff.allInvitesFailed": "すべての招待が失敗しました。",
    "ops.staff.failedToSendInvitations": "招待状の送信に失敗しました",
    "ops.staff.roleNotAvailable": "この役割はご利用のプランでは利用できません",
    "ops.staff.roleNotAvailableDesc": "{role}にはより上位のサブスクリプションが必要です。この役割を利用するにはアップグレードしてください。",
    "ops.staff.roleUpdated": "役割を更新しました",
    "ops.staff.roleUpdatedDesc": "スタッフの役割が{role}に更新されました",
    "ops.staff.roleUpdateFailed": "役割の更新に失敗しました",
    "ops.staff.roleUpdateFailedDesc": "役割を更新できませんでした。もう一度お試しください。",
    "ops.staff.accessRevoked": "スタッフのアクセス権を取り消しました",
    "ops.staff.accessRevokedDesc": "{name}が名簿から削除されました",
    "ops.staff.removalFailed": "削除に失敗しました",
    "ops.staff.removalFailedDesc": "スタッフを削除できませんでした。もう一度お試しください。",
    "ops.tickets.loadingBusinessData": "業務データを読み込み中",
    "ops.tickets.loadingBusinessInfo": "業務情報を読み込んでいます。しばらくお待ちください。",
    "ops.tickets.createNewTicket": "新規チケットを作成",
    "ops.tickets.createTicketDesc": "顧客向けに新しいサポートチケットを作成します",
    "ops.tickets.titleLabel": "タイトル *",
    "ops.tickets.titlePlaceholder": "チケットのタイトルを入力",
    "ops.tickets.customerLabel": "顧客 *",
    "ops.tickets.customerPlaceholder": "顧客名またはメールアドレス",
    "ops.tickets.category": "カテゴリー",
    "ops.tickets.selectCategory": "カテゴリーを選択",
    "ops.tickets.catTechnical": "テクニカルサポート",
    "ops.tickets.catBilling": "請求",
    "ops.tickets.catGeneral": "一般的なお問い合わせ",
    "ops.tickets.catFeature": "機能リクエスト",
    "ops.tickets.catBug": "バグ報告",
    "ops.tickets.selectPriority": "優先度を選択",
    "ops.tickets.prioLow": "低",
    "ops.tickets.prioMedium": "中",
    "ops.tickets.prioHigh": "高",
    "ops.tickets.prioUrgent": "緊急",
    "ops.tickets.prioCritical": "重大",
    "ops.tickets.descriptionLabel": "説明 *",
    "ops.tickets.descriptionPlaceholder": "問題またはリクエストの内容を記述してください",
    "ops.tickets.createTicket": "チケットを作成",
    "ops.tickets.filterTickets": "チケットを絞り込む",
    "ops.tickets.filterTicketsDesc": "フィルターを適用して特定のチケットを検索します",
    "ops.tickets.selectStatus": "ステータスを選択",
    "ops.tickets.allStatus": "すべてのステータス",
    "ops.tickets.statusOpen": "オープン",
    "ops.tickets.statusInProgress": "対応中",
    "ops.tickets.statusResolved": "解決済み",
    "ops.tickets.statusClosed": "クローズ",
    "ops.tickets.allPriorities": "すべての優先度",
    "ops.tickets.applyFilters": "フィルターを適用",
    "ops.tickets.respondToTicket": "チケットに返信",
    "ops.tickets.respondDesc": "{customer}へ返信を送信します",
    "ops.tickets.theCustomer": "顧客",
    "ops.tickets.responseMessage": "返信メッセージ",
    "ops.tickets.responsePlaceholder": "ここに返信を入力してください...",
    "ops.tickets.sendResponse": "返信を送信",
    "ops.tickets.escalateTicket": "チケットをエスカレーション",
    "ops.tickets.escalateDesc": "チケット #{id} を上位サポートへエスカレーションします",
    "ops.tickets.escalationReason": "エスカレーションの理由",
    "ops.tickets.escalationReasonPlaceholder": "このチケットをエスカレーションする必要がある理由を説明してください...",
    "ops.tickets.searchTickets": "チケットを検索...",
    "ops.tickets.tabAll": "すべて",
    "ops.tickets.tabActive": "アクティブ",
    "ops.tickets.tabPending": "保留中",
    "ops.tickets.tabResolved": "解決済み",
    "ops.tickets.showingMyQueue": "自分のキューを表示中",
    "ops.tickets.myQueue": "自分のキュー",
    "ops.tickets.loadingTickets": "チケットを読み込み中...",
    "ops.tickets.noTicketsFound": "チケットが見つかりません",
    "ops.tickets.adjustSearch": "検索条件やフィルターを調整してみてください",
    "ops.tickets.newTicketsAppear": "新しいチケットはここに表示されます",
    "ops.tickets.phone": "電話番号",
    "ops.tickets.assignedBy": "割り当て者",
    "ops.tickets.created": "作成日:",
    "ops.tickets.updated": "更新日:",
    "ops.tickets.acceptedBy": "受付担当:",
    "ops.tickets.resolvedBy": "解決担当:",
    "ops.tickets.reassignedBy": "再割り当て者:",
    "ops.tickets.assignedAt": "割り当て日時:",
    "ops.tickets.loadingConversation": "会話を読み込み中...",
    "ops.tickets.noMessages": "メッセージがありません",
    "ops.tickets.noConvHistory": "このチケットには会話履歴が見つかりませんでした。",
    "ops.tickets.selectTicket": "チケットを選択",
    "ops.tickets.clickTicketLoad": "チケットをクリックすると会話履歴が読み込まれます。",
    "ops.tickets.respond": "返信",
    "ops.tickets.escalate": "エスカレーション",
    "ops.tickets.markResolved": "解決済みにする",
    "ops.tickets.accept": "受け付ける",
    "ops.tickets.reassign": "再割り当て",
    "ops.tickets.deleteGuest": "ゲストを削除",
    "ops.tickets.chooseTicketRespond": "リストからチケットを選択して詳細を表示し、返信してください",
    "ops.tickets.reassignTicket": "チケットを再割り当て",
    "ops.tickets.reassignDesc": "{id} — このチケットを別のアクティブなオペレーターに転送します。",
    "ops.tickets.reassignTo": "再割り当て先",
    "ops.tickets.reasonOptional": "理由(任意)",
    "ops.tickets.reassignReasonPlaceholder": "このチケットを再割り当てする理由は何ですか?",
    "ops.tickets.assignTicket": "チケットを割り当て",
    "ops.tickets.assignDesc": "{id} — このチケットを割り当てるオペレーターを選択してください。",
    "ops.tickets.assignToLabel": "割り当て先",
    "ops.tickets.noOperatorsTenant": "このテナントにはオペレーターが見つかりません",
    "ops.tickets.noTicketId": "チケットIDがありません",
    "ops.tickets.noTicketIdCreate": "この会話には保存されたチケットがありません。まず「新規チケット」からチケットを作成してください。",
    "ops.tickets.noTicketAccept": "受け付けできません — この会話にはリンクされた保存済みチケットがありません。",
    "ops.tickets.noTicketDelete": "削除できません — この会話にはリンクされた保存済みチケットがありません。",
    "ops.tickets.noTicketLinked": "この会話にはリンクされた保存済みチケットがありません。",
    "ops.tickets.selectAnOperator": "オペレーターを選択",
    "ops.tickets.chooseStaffAssign": "このチケットを割り当てるスタッフを選択してください。",
    "ops.tickets.ticketAssigned": "チケットを割り当てました",
    "ops.tickets.ticketAssignedDesc": "チケットが割り当てられました。",
    "ops.tickets.assignFailed": "割り当てに失敗しました",
    "ops.tickets.ticketAccepted": "チケットを受け付けました",
    "ops.tickets.ticketAcceptedDesc": "ステータスが「対応中」に更新されました。",
    "ops.tickets.acceptFailed": "受け付けに失敗しました",
    "ops.tickets.deleteConfirm": "無効なゲストチケット {tid} を削除しますか?リンクされた会話履歴は保持されます。",
    "ops.tickets.ticketDeleted": "チケットを削除しました",
    "ops.tickets.ticketDeletedDesc": "チケット {tid} を削除しました。",
    "ops.tickets.deleteFailed": "削除に失敗しました",
    "ops.tickets.selectOperatorTitle": "オペレーターを選択",
    "ops.tickets.chooseOperatorReassign": "このチケットを再割り当てするオペレーターを選択してください。",
    "ops.tickets.ticketReassigned": "チケットを再割り当てしました",
    "ops.tickets.ticketReassignedDesc": "チケットが再割り当てされました。",
    "ops.tickets.reassignFailed": "再割り当てに失敗しました",
    "ops.tickets.ticketCreated": "チケットを作成しました",
    "ops.tickets.ticketCreatedDesc": "サポートチケットが正常に作成されました",
    "ops.tickets.failedCreate": "チケットの作成に失敗しました",
    "ops.tickets.emptyMessage": "メッセージが空です",
    "ops.tickets.enterResponse": "返信メッセージを入力してください",
    "ops.tickets.responseSent": "返信を送信しました",
    "ops.tickets.messageSentSuccess": "メッセージが正常に送信されました",
    "ops.tickets.failedSendResponse": "返信の送信に失敗しました",
    "ops.tickets.reasonRequired": "理由が必要です",
    "ops.tickets.provideEscReason": "エスカレーションの理由を入力してください",
    "ops.tickets.ticketEscalated": "チケットをエスカレーションしました",
    "ops.tickets.ticketEscalatedDesc": "チケットを上位サポートへエスカレーションしました",
    "ops.tickets.failedEscalate": "チケットのエスカレーションに失敗しました",
    "ops.tickets.ticketResolved": "チケットを解決しました",
    "ops.tickets.ticketResolvedDesc": "チケットを解決済みにしました",
    "ops.tickets.failedResolve": "チケットの解決に失敗しました",
    "ops.tickets.failedLoadTickets": "チケットの読み込みに失敗しました。もう一度お試しください。",
    "ops.tickets.noConvLinked": "このチケットにはリンクされた会話がありません。",
    "ops.tickets.emailResolved": "メールを解決しました",
    "ops.tickets.composingTo": "{email}へのメッセージを作成中",
    "ops.esc.pendingBadge": "{count}件保留中",
    "ops.esc.escalationDetail": "エスカレーション詳細",
    "ops.esc.intent": "インテント",
    "ops.esc.escalationReason": "エスカレーションの理由",
    "ops.esc.contextSummary": "コンテキストの要約",
    "ops.esc.aiContextSummary": "AIコンテキストの要約",
    "ops.esc.noContextSummary": "コンテキストの要約はありません。",
    "ops.esc.convTicketId": "会話 / チケットID",
    "ops.esc.notAvailable": "利用できません",
    "ops.esc.escalationId": "エスカレーションID",
    "ops.esc.callbackDue": "折り返し期限",
    "ops.esc.voiceTranscript": "音声の文字起こし",
    "ops.esc.loadingTranscript": "文字起こしを読み込み中…",
    "ops.esc.noTranscript": "このセッションには文字起こしがありません。",
    "ops.esc.call": "発信",
    "ops.esc.callHint": "Twilio通話を開始し、会話に通話イベントを記録します",
    "ops.esc.conversationThread": "会話スレッド",
    "ops.esc.loadingMessages": "メッセージを読み込み中…",
    "ops.esc.noMessagesYet": "メッセージはまだありません。下から最初のメッセージを送信してください。",
    "ops.esc.typeMessageCustomer": "顧客へのメッセージを入力…",
    "ops.esc.assignedToMe": "自分に割り当て済み",
    "ops.esc.callbacks": "折り返し",
    "ops.esc.badgeOperator": "オペレーター",
    "ops.esc.badgeManager": "マネージャー",
    "ops.esc.badgeAdmin": "管理者",
    "ops.esc.noSummaryAvailable": "要約はありません",
    "ops.esc.acceptHandle": "受け付けて対応",
    "ops.esc.viewDetails": "詳細を表示",
    "ops.esc.selectOperatorAssign": "割り当てるオペレーターを選択…",
    "ops.esc.noStaffAvailable": "利用可能なスタッフがいません",
    "ops.esc.noPendingEsc": "保留中のエスカレーションはありません",
    "ops.esc.allHandledEfficiently": "すべての会話が効率的に対応されています!",
    "ops.esc.noEscAssigned": "あなたに割り当てられたエスカレーションはありません",
    "ops.esc.noEscAssignedHelp": "管理者が割り当てると、あなたに割り当てられたエスカレーションがここに表示されます",
    "ops.esc.messageCustomer": "顧客にメッセージ",
    "ops.esc.typeMessageEnter": "顧客へのメッセージを入力…(Enterで送信)",
    "ops.esc.noPendingCallbacks": "保留中の折り返しはありません",
    "ops.esc.overdue": "期限超過",
    "ops.esc.due": "期限",
    "ops.esc.claimCallback": "折り返しを引き受ける",
    "ops.esc.noResolvedYet": "解決済みのエスカレーションはまだありません",
    "ops.esc.completedAppearHere": "完了したエスカレーションはここに表示されます",
    "ops.esc.loadingEscalations": "エスカレーションを読み込み中...",
    "ops.esc.resolveEscalation": "エスカレーションを解決",
    "ops.esc.resolveEscDesc": "解決内容を記録してください。任意で、マネージャーのレビュー用にSolution Bankへ送信できます — 承認された解決策はAIアシスタントの学習に使用されます。",
    "ops.esc.resolutionNotes": "解決メモ *",
    "ops.esc.submitToSolutionBank": "解決策をレビュー用にSolution Bankへ送信する",
    "ops.esc.approveBeforeAi": "AIがこの解決策を使用する前に、マネージャーまたは管理者による承認が必要です。未承認の送信内容がAIチャットやAI音声で使用されることは一切ありません。",
    "ops.esc.submitForReviewSuffix": " してレビューに送信",
    "ops.esc.failedLoadEsc": "エスカレーションの読み込みに失敗しました",
    "ops.esc.checkConnection": "接続を確認して、もう一度お試しください。",
    "ops.esc.noConvLinkedTitle": "リンクされた会話がありません",
    "ops.esc.noConvLinkedDesc": "このエスカレーションにはリンクされた会話がありません。メッセージを送信できません。",
    "ops.esc.messageSent": "メッセージを送信しました",
    "ops.esc.messageSentPush": "顧客はプッシュ通知でメッセージを受け取ります。",
    "ops.esc.sendFailed": "送信に失敗しました",
    "ops.esc.failedSendMessage": "メッセージの送信に失敗しました",
    "ops.esc.noLinkedConvEsc": "このエスカレーションにはリンクされた会話がありません。",
    "ops.esc.cannotResolveEscId": "エスカレーションIDを解決できません",
    "ops.esc.cannotSelfAssign": "自己割り当てできません",
    "ops.esc.cannotSelfAssignDesc": "あなたのスタッフプロフィールが見つかりませんでした。管理者にこのエスカレーションの割り当てを依頼してください。",
    "ops.esc.escAccepted": "エスカレーションを受け付けました",
    "ops.esc.statusReceivingAttention": "ステータス:対応中",
    "ops.esc.failedAcceptEsc": "エスカレーションの受け付けに失敗しました",
    "ops.esc.escResolved": "エスカレーションを解決しました",
    "ops.esc.resolutionSubmitted": "解決策をマネージャーのレビュー用にSolution Bankへ送信しました。",
    "ops.esc.statusResolved": "ステータス:解決済み",
    "ops.esc.failedResolveEsc": "エスカレーションの解決に失敗しました",
    "ops.esc.escAssigned": "エスカレーションを割り当てました",
    "ops.esc.failedAssignEsc": "エスカレーションの割り当てに失敗しました",
    "ops.esc.noEscId": "エスカレーションIDがありません",
    "ops.esc.noEscIdDesc": "このレコードには有効なIDがありません。",
    "ops.ops.manageOperators": "オペレーターを管理",
    "ops.ops.subtitle": "リアルタイムのモニタリングとパフォーマンス管理",
    "ops.ops.dashboard": "ダッシュボード",
    "ops.ops.realtime": "リアルタイム",
    "ops.ops.historical": "履歴",
    "ops.ops.scheduleShifts": "シフトを計画",
    "ops.ops.shiftNotAvailable": "シフトのスケジュール機能はこのリリースでは利用できません。",
    "ops.ops.shiftCreated": "シフトを作成しました",
    "ops.ops.operator": "オペレーター",
    "ops.ops.certifications": "認定",
    "ops.ops.languages": "言語",
    "ops.ops.coachingNotes": "コーチングメモ",
    "ops.ops.coachingPurpose": "目的",
    "ops.ops.coachingSaved": "コーチングを保存しました",
    "ops.ops.historicalMode": "履歴モード",
    "ops.ops.noActivity": "アクティビティなし",
    "ops.ops.noCoaching": "コーチングはありません",
    "ops.ops.noShifts": "予定されたシフトはありません",
    "ops.ops.skillsSaved": "スキルを保存しました",
    "ops.ops.queueSettings": "キュー設定",
    "ops.ops.queueNotAvailable": "キューの構成機能はこのリリースでは利用できません。",
    "ops.ops.onlineOperators": "オンラインのオペレーター",
    "ops.ops.callsToday": "本日の通話数",
    "ops.ops.ticketsResolved": "解決済みチケット",
    "ops.ops.activeTickets": "アクティブなチケット",
    "ops.ops.avgAht": "平均AHT",
    "ops.ops.realtimeModeActive": "リアルタイムモードが有効です — エスカレーションアラートがここに表示されます",
    "ops.ops.activeOperators": "アクティブなオペレーター",
    "ops.ops.noOperators": "この事業にはまだオペレーターがいません。",
    "ops.ops.loadingMetrics": "オペレーター指標を読み込み中…",
    "ops.ops.calls": "通話",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "オペレーターを選択",
    "ops.ops.chooseOperator": "リストからオペレーターを選択すると、詳細なパフォーマンス指標とリアルタイムモニタリングを表示できます",
    "ops.ops.kpis": "重要業績評価指標",
    "ops.ops.avgHandleTime": "平均処理時間",
    "ops.ops.firstCallResolution": "初回解決率",
    "ops.ops.customerSatisfaction": "顧客満足度",
    "ops.ops.callbackCompliance": "折り返し遵守率",
    "ops.ops.todaysStats": "本日の統計",
    "ops.ops.callsHandled": "対応した通話数",
    "ops.ops.avgHandleTimeShort": "平均処理時間",
    "ops.ops.performance": "パフォーマンス",
    "ops.ops.liveActivity": "ライブアクティビティ",
    "ops.ops.presence": "プレゼンス",
    "ops.ops.onCall": "通話中",
    "ops.ops.currentConversation": "現在の会話",
    "ops.ops.lastActivity": "最終アクティビティ",
    "ops.ops.skills": "スキル",
    "ops.ops.coaching": "コーチング",
    "ops.ops.liveActivityNA": "ライブアクティビティのモニタリングはまだ利用できません",
    "ops.ops.liveActivityNADesc": "リアルタイムの通話 / アクティビティフィードはリビジョン2(OPEN_REVISION_2)で提供されます。",
    "ops.ops.skillsCerts": "スキルと認定資格",
    "ops.ops.skillsNA": "スキルと認定資格はまだ記録されていません",
    "ops.ops.skillsNADesc": "オペレーターのスキル / 言語 / 認定資格はリビジョン2(OPEN_REVISION_2)で提供されます。",
    "ops.ops.coachingDev": "コーチングと能力開発",
    "ops.ops.coachingNA": "コーチングと能力開発ツールはまだ利用できません — リビジョン2(OPEN_REVISION_2)で提供されます。",
    "ops.ops.scheduleCoaching": "コーチングを計画",
    "ops.ops.performanceReview": "パフォーマンスレビュー",
    "ops.ops.whisper": "ウィスパー",
    "ops.ops.joinCall": "通話に参加",
    "ops.ops.supervisionConnectingNotice": "監督に接続しています…",
    "ops.ops.whisperActiveNotice": "ウィスパー中 — オペレーターをコーチングしています。",
    "ops.ops.listeningNotice": "通話をモニタリングしています。",
    "ops.ops.stopSupervision": "監督を停止",
    "ops.ops.whisperHint": "顧客に聞こえないようにオペレーターへ内緒で話します",
    "ops.ops.joinHint": "通話に参加して、全員があなたの声を聞けるようにします",
    "ops.ops.noActiveCall": "オペレーターにアクティブな通話はありません",
    "ops.ops.featureWhisper": "ウィスパー監督(M11)",
    "ops.ops.featureBarge": "割り込み / 通話に参加(M11)",
    "ops.ops.notAvailableYet": "— まだ利用できません",
    "ops.ops.rev2Saved": "リビジョン2(OPEN_REVISION_2)で提供されます。保存は行われませんでした。",
    "ops.tm.subtitle": "SLA管理と自動化を備えたオムニチャネルチケット管理",
  },
  ko: {
    "ops.common.missingInformation": "정보 누락",
    "ops.common.fillAllRequired": "모든 필수 항목을 입력해 주십시오",
    "ops.common.tryAgain": "다시 시도",
    "ops.common.customer": "고객",
    "ops.common.unassigned": "미배정",
    "ops.common.aiAgent": "AI 상담원",
    "ops.common.status": "상태",
    "ops.common.priority": "우선순위",
    "ops.common.assignedTo": "배정 대상",
    "ops.common.pending": "대기 중",
    "ops.common.resolved": "해결됨",
    "ops.common.resolve": "해결",
    "ops.common.assign": "배정",
    "ops.common.view": "보기",
    "ops.common.inProgress": "진행 중",
    "ops.common.you": "나",
    "ops.common.system": "시스템",
    "ops.common.agent": "상담원",
    "ops.common.cannotCall": "전화할 수 없음",
    "ops.common.callInitiated": "전화 시작됨",
    "ops.common.callLogged": "통화 기록됨",
    "ops.common.calling": "전화 거는 중",
    "ops.common.callRecordedFor": "다음에 대한 통화 기록됨",
    "ops.common.callFailed": "전화 실패",
    "ops.common.callNow": "지금 전화",
    "ops.common.startingCall": "전화 시작 중…",
    "ops.esc.noConvForCallback": "이 콜백에 사용할 수 있는 대화가 없습니다",
    "ops.esc.cbDueSoon": "곧",
    "ops.esc.cbOverdue": "기한 초과",
    "ops.esc.cbScheduled": "예정됨",
    "ops.esc.cbCompleted": "완료됨",
    "ops.esc.cbCancelled": "취소됨",
    "ops.esc.cbReminderTitle": "콜백 알림",
    "ops.esc.cbDueSoonMsg": "곧 콜백 예정",
    "ops.common.describeResolution": "이 문제가 어떻게 해결되었는지 설명해 주십시오...",
    "ops.common.selectOperator": "운영자 선택…",
    "ops.common.nameLabel": "이름:",
    "ops.common.emailLabel": "이메일:",
    "ops.staff.subscriptionPlan": "구독 요금제",
    "ops.staff.seatAllocation": "좌석 할당",
    "ops.staff.inviteStaffMembers": "직원 초대",
    "ops.staff.inviteDescPre": "이메일로 직원을 초대하십시오 — 각 담당자는 귀하의 Brand ID가 포함된 브랜드 초대장을 받게 됩니다",
    "ops.staff.inviteDescMid": "그리고 다음에서 자가 등록을 완료할 수 있는 링크",
    "ops.staff.inviteExpire": "초대장은 7일 후에 만료됩니다.",
    "ops.staff.emailAddresses": "이메일 주소",
    "ops.staff.emailsPlaceholder": "쉼표, 세미콜론 또는 줄 바꿈으로 구분하여 이메일 주소를 입력하십시오:",
    "ops.staff.validEmailsDetected": "{count}개의 유효한 이메일이 감지되었습니다",
    "ops.staff.defaultRole": "기본 역할",
    "ops.staff.defaultRoleHelp": "초대된 모든 직원은 기본적으로 이 역할이 배정됩니다",
    "ops.staff.invitationPreview": "초대장 미리보기",
    "ops.staff.operatorDefault": "운영자 (기본값)",
    "ops.staff.sendingInvitations": "초대장 전송 중…",
    "ops.staff.sendInvitations": "초대장 {count}개 전송",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "팀원 {count}명",
    "ops.staff.totalStaff": "전체 직원",
    "ops.staff.administrators": "관리자",
    "ops.staff.operators": "운영자",
    "ops.staff.otherRoles": "기타 역할",
    "ops.staff.teamMembers": "팀원",
    "ops.staff.membersCount": "구성원 {count}명",
    "ops.staff.noTeamMembers": "팀원 없음",
    "ops.staff.noTeamMembersHelp": "비즈니스 팀에 참여하도록 직원을 초대하십시오",
    "ops.staff.inviteFirst": "첫 직원 초대",
    "ops.staff.changeRole": "역할 변경",
    "ops.staff.removeStaff": "직원 삭제",
    "ops.staff.regInstructions": "직원 등록 안내",
    "ops.staff.forNewStaff": "신규 직원용:",
    "ops.staff.shareBrandId": "귀하의 Brand ID를 공유하십시오:",
    "ops.staff.directToReg": "직원 등록 페이지로 안내하십시오",
    "ops.staff.assignedOperatorDefault": "기본적으로 \"운영자\" 역할이 배정됩니다",
    "ops.staff.updateRoleDropdown": "위의 드롭다운을 사용하여 역할을 변경할 수 있습니다",
    "ops.staff.registrationLink": "등록 링크:",
    "ops.staff.changeRoleDesc": "{name}의 역할을 변경합니다.",
    "ops.staff.thisStaffMember": "이 직원",
    "ops.staff.saving": "저장 중…",
    "ops.staff.saveRole": "역할 저장",
    "ops.staff.removeStaffMember": "직원 삭제",
    "ops.staff.removeWarning": "이 작업은 해당 직원의 모든 비즈니스 접근 권한을 즉시 취소합니다.",
    "ops.staff.securityImpact": "보안 영향:",
    "ops.staff.impact1": "모든 비즈니스 접근 권한을 즉시 상실합니다",
    "ops.staff.impact2a": "해당 직원 계정은",
    "ops.staff.impact2b": "비활성화됩니다",
    "ops.staff.impact2c": "그리고 해당 전화번호는 이 비즈니스에서 해제됩니다",
    "ops.staff.impact3": "이전의 모든 비즈니스 대화는 보안 처리되어 접근할 수 없게 됩니다",
    "ops.staff.impact4": "직원 프로필이나 비즈니스 데이터에 접근할 수 없습니다",
    "ops.staff.staffDetails": "직원 정보:",
    "ops.staff.currentRole": "현재 역할:",
    "ops.staff.joinDate": "참여일:",
    "ops.staff.noteLabel": "참고:",
    "ops.staff.removeNote": "이 작업은 취소할 수 없습니다. 나중에 이 담당자를 다시 추가하려면 새 초대장과 역할 배정이 필요합니다.",
    "ops.staff.removeRevoke": "삭제 및 접근 권한 취소",
    "ops.staff.descAdmin": "모든 기능 및 직원 관리에 대한 전체 접근",
    "ops.staff.descOperator": "고객 서비스, 티켓 관리, 커뮤니케이션",
    "ops.staff.descManager": "팀 관리 감독, 보고, SolutionBank 관리",
    "ops.staff.descAnalyst": "데이터 분석, 보고, 성과 지표",
    "ops.staff.descDirector": "전략 기획, 고위 수준 분석",
    "ops.staff.descExecutive": "비즈니스 감독, 경영진 대시보드",
    "ops.staff.descIt": "기술 관리, 시스템 구성",
    "ops.staff.enterOneEmail": "최소 한 개의 이메일 주소를 입력해 주십시오",
    "ops.staff.invalidEmailFormat": "잘못된 이메일 형식",
    "ops.staff.enterValidEmails": "유효한 이메일 주소를 입력해 주십시오",
    "ops.staff.invitationsSent": "초대장 전송됨",
    "ops.staff.invitesSentDesc": "초대장 이메일 {total}개 중 {sent}개가 성공적으로 전송되었습니다.",
    "ops.staff.invitesFailedSuffix": " {failed}개 실패 — 주소를 확인하십시오.",
    "ops.staff.noInvitationsSent": "전송된 초대장 없음",
    "ops.staff.allInvitesFailed": "모든 초대장 전송에 실패했습니다.",
    "ops.staff.failedToSendInvitations": "초대장 전송에 실패했습니다",
    "ops.staff.roleNotAvailable": "현재 요금제에서 사용할 수 없는 역할입니다",
    "ops.staff.roleNotAvailableDesc": "{role} 역할은 상위 구독 등급이 필요합니다. 이 역할을 사용하려면 업그레이드하십시오.",
    "ops.staff.roleUpdated": "역할 변경됨",
    "ops.staff.roleUpdatedDesc": "직원 역할이 {role}(으)로 변경되었습니다",
    "ops.staff.roleUpdateFailed": "역할 변경 실패",
    "ops.staff.roleUpdateFailedDesc": "역할을 변경할 수 없습니다. 다시 시도해 주십시오.",
    "ops.staff.accessRevoked": "직원 접근 권한 취소됨",
    "ops.staff.accessRevokedDesc": "{name}이(가) 명단에서 삭제되었습니다",
    "ops.staff.removalFailed": "삭제 실패",
    "ops.staff.removalFailedDesc": "직원을 삭제할 수 없습니다. 다시 시도해 주십시오.",
    "ops.tickets.loadingBusinessData": "비즈니스 데이터 로딩 중",
    "ops.tickets.loadingBusinessInfo": "비즈니스 정보를 불러오는 동안 잠시 기다려 주십시오.",
    "ops.tickets.createNewTicket": "새 티켓 생성",
    "ops.tickets.createTicketDesc": "고객을 위한 새 지원 티켓을 생성합니다",
    "ops.tickets.titleLabel": "제목 *",
    "ops.tickets.titlePlaceholder": "티켓 제목을 입력하십시오",
    "ops.tickets.customerLabel": "고객 *",
    "ops.tickets.customerPlaceholder": "고객 이름 또는 이메일",
    "ops.tickets.category": "카테고리",
    "ops.tickets.selectCategory": "카테고리 선택",
    "ops.tickets.catTechnical": "기술 지원",
    "ops.tickets.catBilling": "결제",
    "ops.tickets.catGeneral": "일반 문의",
    "ops.tickets.catFeature": "기능 요청",
    "ops.tickets.catBug": "버그 신고",
    "ops.tickets.selectPriority": "우선순위 선택",
    "ops.tickets.prioLow": "낮음",
    "ops.tickets.prioMedium": "보통",
    "ops.tickets.prioHigh": "높음",
    "ops.tickets.prioUrgent": "긴급",
    "ops.tickets.prioCritical": "심각",
    "ops.tickets.descriptionLabel": "설명 *",
    "ops.tickets.descriptionPlaceholder": "문제 또는 요청을 설명하십시오",
    "ops.tickets.createTicket": "티켓 생성",
    "ops.tickets.filterTickets": "티켓 필터",
    "ops.tickets.filterTicketsDesc": "필터를 적용하여 특정 티켓을 찾습니다",
    "ops.tickets.selectStatus": "상태 선택",
    "ops.tickets.allStatus": "전체 상태",
    "ops.tickets.statusOpen": "열림",
    "ops.tickets.statusInProgress": "진행 중",
    "ops.tickets.statusResolved": "해결됨",
    "ops.tickets.statusClosed": "종료됨",
    "ops.tickets.allPriorities": "전체 우선순위",
    "ops.tickets.applyFilters": "필터 적용",
    "ops.tickets.respondToTicket": "티켓에 응답",
    "ops.tickets.respondDesc": "{customer}에게 응답을 보냅니다",
    "ops.tickets.theCustomer": "고객",
    "ops.tickets.responseMessage": "응답 메시지",
    "ops.tickets.responsePlaceholder": "여기에 응답을 입력하십시오...",
    "ops.tickets.sendResponse": "응답 전송",
    "ops.tickets.escalateTicket": "티켓 에스컬레이션",
    "ops.tickets.escalateDesc": "티켓 #{id}을(를) 상위 지원팀으로 에스컬레이션합니다",
    "ops.tickets.escalationReason": "에스컬레이션 사유",
    "ops.tickets.escalationReasonPlaceholder": "이 티켓에 에스컬레이션이 필요한 이유를 설명하십시오...",
    "ops.tickets.searchTickets": "티켓 검색...",
    "ops.tickets.tabAll": "전체",
    "ops.tickets.tabActive": "활성",
    "ops.tickets.tabPending": "대기 중",
    "ops.tickets.tabResolved": "해결됨",
    "ops.tickets.showingMyQueue": "내 대기열 표시 중",
    "ops.tickets.myQueue": "내 대기열",
    "ops.tickets.loadingTickets": "티켓 로딩 중...",
    "ops.tickets.noTicketsFound": "티켓을 찾을 수 없습니다",
    "ops.tickets.adjustSearch": "검색어나 필터를 조정해 보십시오",
    "ops.tickets.newTicketsAppear": "새 티켓이 여기에 표시됩니다",
    "ops.tickets.phone": "전화",
    "ops.tickets.assignedBy": "배정자",
    "ops.tickets.created": "생성:",
    "ops.tickets.updated": "업데이트:",
    "ops.tickets.acceptedBy": "수락자:",
    "ops.tickets.resolvedBy": "해결자:",
    "ops.tickets.reassignedBy": "재배정자:",
    "ops.tickets.assignedAt": "배정 시각:",
    "ops.tickets.loadingConversation": "대화 로딩 중...",
    "ops.tickets.noMessages": "메시지 없음",
    "ops.tickets.noConvHistory": "이 티켓에 대한 대화 기록을 찾을 수 없습니다.",
    "ops.tickets.selectTicket": "티켓 선택",
    "ops.tickets.clickTicketLoad": "티켓을 클릭하여 대화 기록을 불러오십시오.",
    "ops.tickets.respond": "응답",
    "ops.tickets.escalate": "에스컬레이션",
    "ops.tickets.markResolved": "해결됨으로 표시",
    "ops.tickets.accept": "수락",
    "ops.tickets.reassign": "재배정",
    "ops.tickets.deleteGuest": "게스트 삭제",
    "ops.tickets.chooseTicketRespond": "목록에서 티켓을 선택하여 세부 정보를 확인하고 응답하십시오",
    "ops.tickets.reassignTicket": "티켓 재배정",
    "ops.tickets.reassignDesc": "{id} — 이 티켓을 다른 활성 운영자에게 이관합니다.",
    "ops.tickets.reassignTo": "재배정 대상",
    "ops.tickets.reasonOptional": "사유 (선택 사항)",
    "ops.tickets.reassignReasonPlaceholder": "이 티켓을 재배정하는 이유는 무엇입니까?",
    "ops.tickets.assignTicket": "티켓 배정",
    "ops.tickets.assignDesc": "{id} — 이 티켓을 배정할 운영자를 선택하십시오.",
    "ops.tickets.assignToLabel": "배정 대상",
    "ops.tickets.noOperatorsTenant": "이 테넌트에서 운영자를 찾을 수 없습니다",
    "ops.tickets.noTicketId": "티켓 ID 없음",
    "ops.tickets.noTicketIdCreate": "이 대화에는 저장된 티켓이 없습니다. 먼저 새 티켓을 통해 티켓을 생성하십시오.",
    "ops.tickets.noTicketAccept": "수락할 수 없습니다 — 이 대화에 연결된 저장된 티켓이 없습니다.",
    "ops.tickets.noTicketDelete": "삭제할 수 없습니다 — 이 대화에 연결된 저장된 티켓이 없습니다.",
    "ops.tickets.noTicketLinked": "이 대화에 연결된 저장된 티켓이 없습니다.",
    "ops.tickets.selectAnOperator": "운영자 선택",
    "ops.tickets.chooseStaffAssign": "이 티켓을 배정할 직원을 선택하십시오.",
    "ops.tickets.ticketAssigned": "티켓 배정됨",
    "ops.tickets.ticketAssignedDesc": "티켓이 배정되었습니다.",
    "ops.tickets.assignFailed": "배정 실패",
    "ops.tickets.ticketAccepted": "티켓 수락됨",
    "ops.tickets.ticketAcceptedDesc": "상태가 진행 중으로 변경되었습니다.",
    "ops.tickets.acceptFailed": "수락 실패",
    "ops.tickets.deleteConfirm": "유효하지 않은 게스트 티켓 {tid}을(를) 삭제하시겠습니까? 연결된 대화 기록은 보존됩니다.",
    "ops.tickets.ticketDeleted": "티켓 삭제됨",
    "ops.tickets.ticketDeletedDesc": "티켓 {tid}이(가) 삭제되었습니다.",
    "ops.tickets.deleteFailed": "삭제 실패",
    "ops.tickets.selectOperatorTitle": "운영자 선택",
    "ops.tickets.chooseOperatorReassign": "이 티켓을 재배정할 운영자를 선택하십시오.",
    "ops.tickets.ticketReassigned": "티켓 재배정됨",
    "ops.tickets.ticketReassignedDesc": "티켓이 재배정되었습니다.",
    "ops.tickets.reassignFailed": "재배정 실패",
    "ops.tickets.ticketCreated": "티켓 생성됨",
    "ops.tickets.ticketCreatedDesc": "지원 티켓이 성공적으로 생성되었습니다",
    "ops.tickets.failedCreate": "티켓 생성에 실패했습니다",
    "ops.tickets.emptyMessage": "빈 메시지",
    "ops.tickets.enterResponse": "응답 메시지를 입력해 주십시오",
    "ops.tickets.responseSent": "응답 전송됨",
    "ops.tickets.messageSentSuccess": "메시지가 성공적으로 전송되었습니다",
    "ops.tickets.failedSendResponse": "응답 전송에 실패했습니다",
    "ops.tickets.reasonRequired": "사유 필수",
    "ops.tickets.provideEscReason": "에스컬레이션 사유를 입력해 주십시오",
    "ops.tickets.ticketEscalated": "티켓 에스컬레이션됨",
    "ops.tickets.ticketEscalatedDesc": "티켓이 상위 지원팀으로 에스컬레이션되었습니다",
    "ops.tickets.failedEscalate": "티켓 에스컬레이션에 실패했습니다",
    "ops.tickets.ticketResolved": "티켓 해결됨",
    "ops.tickets.ticketResolvedDesc": "티켓이 해결됨으로 표시되었습니다",
    "ops.tickets.failedResolve": "티켓 해결에 실패했습니다",
    "ops.tickets.failedLoadTickets": "티켓을 불러오지 못했습니다. 다시 시도해 주십시오.",
    "ops.tickets.noConvLinked": "이 티켓에 연결된 대화가 없습니다.",
    "ops.tickets.emailResolved": "이메일 확인됨",
    "ops.tickets.composingTo": "{email}에게 메시지 작성 중",
    "ops.esc.pendingBadge": "{count}개 대기 중",
    "ops.esc.escalationDetail": "에스컬레이션 세부 정보",
    "ops.esc.intent": "의도",
    "ops.esc.escalationReason": "에스컬레이션 사유",
    "ops.esc.contextSummary": "컨텍스트 요약",
    "ops.esc.aiContextSummary": "AI 컨텍스트 요약",
    "ops.esc.noContextSummary": "사용 가능한 컨텍스트 요약이 없습니다.",
    "ops.esc.convTicketId": "대화 / 티켓 ID",
    "ops.esc.notAvailable": "사용 불가",
    "ops.esc.escalationId": "에스컬레이션 ID",
    "ops.esc.callbackDue": "콜백 예정",
    "ops.esc.voiceTranscript": "음성 기록",
    "ops.esc.loadingTranscript": "기록 로딩 중…",
    "ops.esc.noTranscript": "이 세션에 대한 사용 가능한 기록이 없습니다.",
    "ops.esc.call": "전화",
    "ops.esc.callHint": "Twilio 전화를 시작하고 대화에 통화 이벤트를 기록합니다",
    "ops.esc.conversationThread": "대화 스레드",
    "ops.esc.loadingMessages": "메시지 로딩 중…",
    "ops.esc.noMessagesYet": "아직 메시지가 없습니다. 아래에서 첫 메시지를 보내십시오.",
    "ops.esc.typeMessageCustomer": "고객에게 보낼 메시지를 입력하십시오…",
    "ops.esc.assignedToMe": "나에게 배정됨",
    "ops.esc.callbacks": "콜백",
    "ops.esc.badgeOperator": "운영자",
    "ops.esc.badgeManager": "관리자",
    "ops.esc.badgeAdmin": "관리자",
    "ops.esc.noSummaryAvailable": "사용 가능한 요약이 없습니다",
    "ops.esc.acceptHandle": "수락 및 처리",
    "ops.esc.viewDetails": "세부 정보 보기",
    "ops.esc.selectOperatorAssign": "배정할 운영자 선택…",
    "ops.esc.noStaffAvailable": "사용 가능한 직원이 없습니다",
    "ops.esc.noPendingEsc": "대기 중인 에스컬레이션이 없습니다",
    "ops.esc.allHandledEfficiently": "모든 대화가 효율적으로 처리되고 있습니다!",
    "ops.esc.noEscAssigned": "나에게 배정된 에스컬레이션이 없습니다",
    "ops.esc.noEscAssignedHelp": "관리자가 배정하면 나에게 배정된 에스컬레이션이 여기에 표시됩니다",
    "ops.esc.messageCustomer": "고객에게 메시지",
    "ops.esc.typeMessageEnter": "고객에게 보낼 메시지를 입력하십시오… (Enter로 전송)",
    "ops.esc.noPendingCallbacks": "대기 중인 콜백이 없습니다",
    "ops.esc.overdue": "기한 초과",
    "ops.esc.due": "기한",
    "ops.esc.claimCallback": "콜백 담당",
    "ops.esc.noResolvedYet": "아직 해결된 에스컬레이션이 없습니다",
    "ops.esc.completedAppearHere": "완료된 에스컬레이션이 여기에 표시됩니다",
    "ops.esc.loadingEscalations": "에스컬레이션 로딩 중...",
    "ops.esc.resolveEscalation": "에스컬레이션 해결",
    "ops.esc.resolveEscDesc": "해결 내용을 기록하십시오. 선택적으로 관리자 검토를 위해 Solution Bank에 제출할 수 있습니다 — 승인된 솔루션은 AI 어시스턴트를 학습시킵니다.",
    "ops.esc.resolutionNotes": "해결 메모 *",
    "ops.esc.submitToSolutionBank": "검토를 위해 해결 내용을 Solution Bank에 제출",
    "ops.esc.approveBeforeAi": "AI가 이 해결 내용을 사용하기 전에 관리자 또는 관리자의 승인이 필요합니다. 승인되지 않은 제출은 AI 채팅이나 AI 음성에서 절대 사용되지 않습니다.",
    "ops.esc.submitForReviewSuffix": " 및 검토 제출",
    "ops.esc.failedLoadEsc": "에스컬레이션을 불러오지 못했습니다",
    "ops.esc.checkConnection": "연결을 확인하고 다시 시도해 주십시오.",
    "ops.esc.noConvLinkedTitle": "연결된 대화 없음",
    "ops.esc.noConvLinkedDesc": "이 에스컬레이션에는 연결된 대화가 없습니다. 메시지를 보낼 수 없습니다.",
    "ops.esc.messageSent": "메시지 전송됨",
    "ops.esc.messageSentPush": "고객은 푸시 알림을 통해 귀하의 메시지를 받게 됩니다.",
    "ops.esc.sendFailed": "전송 실패",
    "ops.esc.failedSendMessage": "메시지 전송에 실패했습니다",
    "ops.esc.noLinkedConvEsc": "이 에스컬레이션에 연결된 대화가 없습니다.",
    "ops.esc.cannotResolveEscId": "에스컬레이션 ID를 확인할 수 없습니다",
    "ops.esc.cannotSelfAssign": "자가 배정할 수 없습니다",
    "ops.esc.cannotSelfAssignDesc": "귀하의 직원 프로필을 찾을 수 없습니다. 관리자에게 이 에스컬레이션 배정을 요청하십시오.",
    "ops.esc.escAccepted": "에스컬레이션 수락됨",
    "ops.esc.statusReceivingAttention": "상태: 처리 중",
    "ops.esc.failedAcceptEsc": "에스컬레이션 수락에 실패했습니다",
    "ops.esc.escResolved": "에스컬레이션 해결됨",
    "ops.esc.resolutionSubmitted": "관리자 검토를 위해 해결 내용이 Solution Bank에 제출되었습니다.",
    "ops.esc.statusResolved": "상태: 해결됨",
    "ops.esc.failedResolveEsc": "에스컬레이션 해결에 실패했습니다",
    "ops.esc.escAssigned": "에스컬레이션 배정됨",
    "ops.esc.failedAssignEsc": "에스컬레이션 배정에 실패했습니다",
    "ops.esc.noEscId": "에스컬레이션 ID 없음",
    "ops.esc.noEscIdDesc": "이 레코드에는 유효한 ID가 없습니다.",
    "ops.ops.manageOperators": "운영자 관리",
    "ops.ops.subtitle": "실시간 모니터링 및 성과 관리",
    "ops.ops.dashboard": "대시보드",
    "ops.ops.realtime": "실시간",
    "ops.ops.historical": "이력",
    "ops.ops.scheduleShifts": "근무 일정 편성",
    "ops.ops.shiftNotAvailable": "근무 일정 편성은 이번 릴리스에서 사용할 수 없습니다.",
    "ops.ops.shiftCreated": "근무 일정이 생성되었습니다",
    "ops.ops.operator": "상담원",
    "ops.ops.certifications": "자격증",
    "ops.ops.languages": "언어",
    "ops.ops.coachingNotes": "코칭 메모",
    "ops.ops.coachingPurpose": "목적",
    "ops.ops.coachingSaved": "코칭 세션이 저장되었습니다",
    "ops.ops.historicalMode": "기록 모드",
    "ops.ops.noActivity": "활동 없음",
    "ops.ops.noCoaching": "코칭 세션 없음",
    "ops.ops.noShifts": "예정된 근무 없음",
    "ops.ops.skillsSaved": "역량이 저장되었습니다",
    "ops.ops.queueSettings": "대기열 설정",
    "ops.ops.queueNotAvailable": "대기열 구성은 이번 릴리스에서 사용할 수 없습니다.",
    "ops.ops.onlineOperators": "온라인 운영자",
    "ops.ops.callsToday": "오늘 통화",
    "ops.ops.ticketsResolved": "해결된 티켓",
    "ops.ops.activeTickets": "활성 티켓",
    "ops.ops.avgAht": "평균 AHT",
    "ops.ops.realtimeModeActive": "실시간 모드 활성 — 에스컬레이션 알림이 여기에 표시됩니다",
    "ops.ops.activeOperators": "활성 운영자",
    "ops.ops.noOperators": "아직 이 비즈니스에 운영자가 없습니다.",
    "ops.ops.loadingMetrics": "운영자 지표 로딩 중…",
    "ops.ops.calls": "통화",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "운영자 선택",
    "ops.ops.chooseOperator": "목록에서 운영자를 선택하여 상세 성과 지표 및 실시간 모니터링을 확인하십시오",
    "ops.ops.kpis": "핵심 성과 지표",
    "ops.ops.avgHandleTime": "평균 처리 시간",
    "ops.ops.firstCallResolution": "최초 통화 해결률",
    "ops.ops.customerSatisfaction": "고객 만족도",
    "ops.ops.callbackCompliance": "콜백 준수율",
    "ops.ops.todaysStats": "오늘의 통계",
    "ops.ops.callsHandled": "처리한 통화",
    "ops.ops.avgHandleTimeShort": "평균 처리 시간",
    "ops.ops.performance": "성과",
    "ops.ops.liveActivity": "실시간 활동",
    "ops.ops.presence": "상태",
    "ops.ops.onCall": "통화 중",
    "ops.ops.currentConversation": "현재 대화",
    "ops.ops.lastActivity": "마지막 활동",
    "ops.ops.skills": "역량",
    "ops.ops.coaching": "코칭",
    "ops.ops.liveActivityNA": "실시간 활동 모니터링은 아직 사용할 수 없습니다",
    "ops.ops.liveActivityNADesc": "실시간 통화 / 활동 피드는 개정판 2(OPEN_REVISION_2)에서 제공됩니다.",
    "ops.ops.skillsCerts": "역량 및 자격증",
    "ops.ops.skillsNA": "역량 및 자격증은 아직 추적되지 않습니다",
    "ops.ops.skillsNADesc": "운영자 역량 / 언어 / 자격증은 개정판 2(OPEN_REVISION_2)에서 제공됩니다.",
    "ops.ops.coachingDev": "코칭 및 개발",
    "ops.ops.coachingNA": "코칭 및 개발 도구는 아직 사용할 수 없습니다 — 개정판 2(OPEN_REVISION_2)에서 제공됩니다.",
    "ops.ops.scheduleCoaching": "코칭 일정 편성",
    "ops.ops.performanceReview": "성과 평가",
    "ops.ops.whisper": "위스퍼",
    "ops.ops.joinCall": "통화 참여",
    "ops.ops.supervisionConnectingNotice": "감독에 연결 중…",
    "ops.ops.whisperActiveNotice": "위스퍼 활성화 — 운영자를 코칭 중입니다.",
    "ops.ops.listeningNotice": "통화를 청취 중입니다.",
    "ops.ops.stopSupervision": "감독 중지",
    "ops.ops.whisperHint": "고객에게 들리지 않게 운영자에게만 말합니다",
    "ops.ops.joinHint": "통화에 참여하여 모든 참가자가 들을 수 있게 합니다",
    "ops.ops.noActiveCall": "운영자에게 활성 통화가 없습니다",
    "ops.ops.featureWhisper": "위스퍼 감독 (M11)",
    "ops.ops.featureBarge": "바지인 / 통화 참여 (M11)",
    "ops.ops.notAvailableYet": "— 아직 사용할 수 없습니다",
    "ops.ops.rev2Saved": "개정판 2(OPEN_REVISION_2)에서 제공됩니다. 저장된 내용이 없습니다.",
    "ops.tm.subtitle": "SLA 관리 및 자동화를 갖춘 옴니채널 티켓팅",
  },
  zh: {
    "ops.common.missingInformation": "信息缺失",
    "ops.common.fillAllRequired": "请填写所有必填字段",
    "ops.common.tryAgain": "重试",
    "ops.common.customer": "客户",
    "ops.common.unassigned": "未分配",
    "ops.common.aiAgent": "AI 客服",
    "ops.common.status": "状态",
    "ops.common.priority": "优先级",
    "ops.common.assignedTo": "分配给",
    "ops.common.pending": "待处理",
    "ops.common.resolved": "已解决",
    "ops.common.resolve": "解决",
    "ops.common.assign": "分配",
    "ops.common.view": "查看",
    "ops.common.inProgress": "处理中",
    "ops.common.you": "您",
    "ops.common.system": "系统",
    "ops.common.agent": "客服",
    "ops.common.cannotCall": "无法呼叫",
    "ops.common.callInitiated": "呼叫已发起",
    "ops.common.callLogged": "呼叫已记录",
    "ops.common.calling": "正在呼叫",
    "ops.common.callRecordedFor": "已记录呼叫，对象为",
    "ops.common.callFailed": "呼叫失败",
    "ops.common.callNow": "立即呼叫",
    "ops.common.startingCall": "正在发起呼叫…",
    "ops.esc.noConvForCallback": "此回拨没有可用的对话",
    "ops.esc.cbDueSoon": "即将到期",
    "ops.esc.cbOverdue": "已逾期",
    "ops.esc.cbScheduled": "已排期",
    "ops.esc.cbCompleted": "已完成",
    "ops.esc.cbCancelled": "已取消",
    "ops.esc.cbReminderTitle": "回拨提醒",
    "ops.esc.cbDueSoonMsg": "回拨即将到期",
    "ops.common.describeResolution": "请描述该问题的解决方式…",
    "ops.common.selectOperator": "选择坐席…",
    "ops.common.nameLabel": "姓名：",
    "ops.common.emailLabel": "邮箱：",
    "ops.staff.subscriptionPlan": "订阅套餐",
    "ops.staff.seatAllocation": "席位分配",
    "ops.staff.inviteStaffMembers": "邀请员工",
    "ops.staff.inviteDescPre": "通过邮箱邀请员工——每人都会收到一封带有您 Brand ID 的品牌化邀请",
    "ops.staff.inviteDescMid": "以及一个用于完成自助注册的链接，地址为",
    "ops.staff.inviteExpire": "邀请将在 7 天后失效。",
    "ops.staff.emailAddresses": "邮箱地址",
    "ops.staff.emailsPlaceholder": "请输入邮箱地址，以逗号、分号或换行分隔：",
    "ops.staff.validEmailsDetected": "检测到 {count} 个有效邮箱",
    "ops.staff.defaultRole": "默认角色",
    "ops.staff.defaultRoleHelp": "所有受邀员工将默认被分配该角色",
    "ops.staff.invitationPreview": "邀请预览",
    "ops.staff.operatorDefault": "坐席（默认）",
    "ops.staff.sendingInvitations": "正在发送邀请…",
    "ops.staff.sendInvitations": "发送 {count} 份邀请",
    "ops.staff.brandId": "Brand ID：",
    "ops.staff.teamMembersCount": "{count} 名团队成员",
    "ops.staff.totalStaff": "员工总数",
    "ops.staff.administrators": "管理员",
    "ops.staff.operators": "坐席",
    "ops.staff.otherRoles": "其他角色",
    "ops.staff.teamMembers": "团队成员",
    "ops.staff.membersCount": "{count} 名成员",
    "ops.staff.noTeamMembers": "暂无团队成员",
    "ops.staff.noTeamMembersHelp": "邀请员工加入您的业务团队",
    "ops.staff.inviteFirst": "邀请第一位员工",
    "ops.staff.changeRole": "变更角色",
    "ops.staff.removeStaff": "移除员工",
    "ops.staff.regInstructions": "员工注册说明",
    "ops.staff.forNewStaff": "对于新员工：",
    "ops.staff.shareBrandId": "分享您的 Brand ID：",
    "ops.staff.directToReg": "引导他们前往员工注册页面",
    "ops.staff.assignedOperatorDefault": "他们将默认被分配为“坐席”角色",
    "ops.staff.updateRoleDropdown": "您可以使用上方的下拉菜单更新他们的角色",
    "ops.staff.registrationLink": "注册链接：",
    "ops.staff.changeRoleDesc": "更新 {name} 的角色。",
    "ops.staff.thisStaffMember": "该员工",
    "ops.staff.saving": "正在保存…",
    "ops.staff.saveRole": "保存角色",
    "ops.staff.removeStaffMember": "移除员工",
    "ops.staff.removeWarning": "此操作将立即撤销该员工的所有业务访问权限。",
    "ops.staff.securityImpact": "安全影响：",
    "ops.staff.impact1": "将立即失去所有业务访问权限",
    "ops.staff.impact2a": "其员工账户将被",
    "ops.staff.impact2b": "停用",
    "ops.staff.impact2c": "并且其手机将从本业务中释放",
    "ops.staff.impact3": "所有先前的业务对话将被保护并变为不可访问",
    "ops.staff.impact4": "他们将无法访问任何员工资料或业务数据",
    "ops.staff.staffDetails": "员工详情：",
    "ops.staff.currentRole": "当前角色：",
    "ops.staff.joinDate": "加入日期：",
    "ops.staff.noteLabel": "备注：",
    "ops.staff.removeNote": "此操作无法撤销。如果您日后想重新添加此人，需要重新发送邀请并分配角色。",
    "ops.staff.removeRevoke": "移除并撤销访问权限",
    "ops.staff.descAdmin": "对所有功能和员工管理拥有完整访问权限",
    "ops.staff.descOperator": "客户服务、工单管理、沟通",
    "ops.staff.descManager": "团队监督、报表、SolutionBank 管理",
    "ops.staff.descAnalyst": "数据分析、报表、绩效指标",
    "ops.staff.descDirector": "战略规划、高层分析",
    "ops.staff.descExecutive": "业务监督、管理层仪表盘",
    "ops.staff.descIt": "技术管理、系统配置",
    "ops.staff.enterOneEmail": "请至少输入一个邮箱地址",
    "ops.staff.invalidEmailFormat": "邮箱格式无效",
    "ops.staff.enterValidEmails": "请输入有效的邮箱地址",
    "ops.staff.invitationsSent": "邀请已发送",
    "ops.staff.invitesSentDesc": "已成功发送 {sent}/{total} 份邀请邮件。",
    "ops.staff.invitesFailedSuffix": " {failed} 份失败——请检查地址。",
    "ops.staff.noInvitationsSent": "未发送任何邀请",
    "ops.staff.allInvitesFailed": "所有邀请均发送失败。",
    "ops.staff.failedToSendInvitations": "邀请发送失败",
    "ops.staff.roleNotAvailable": "您的套餐不支持该角色",
    "ops.staff.roleNotAvailableDesc": "{role} 需要更高的订阅等级。请升级以使用该角色。",
    "ops.staff.roleUpdated": "角色已更新",
    "ops.staff.roleUpdatedDesc": "员工角色已更新为 {role}",
    "ops.staff.roleUpdateFailed": "角色更新失败",
    "ops.staff.roleUpdateFailedDesc": "无法更新角色。请重试。",
    "ops.staff.accessRevoked": "员工访问权限已撤销",
    "ops.staff.accessRevokedDesc": "{name} 已从名册中移除",
    "ops.staff.removalFailed": "移除失败",
    "ops.staff.removalFailedDesc": "无法移除员工。请重试。",
    "ops.tickets.loadingBusinessData": "正在加载业务数据",
    "ops.tickets.loadingBusinessInfo": "正在加载您的业务信息，请稍候。",
    "ops.tickets.createNewTicket": "创建新工单",
    "ops.tickets.createTicketDesc": "为客户创建一张新的支持工单",
    "ops.tickets.titleLabel": "标题 *",
    "ops.tickets.titlePlaceholder": "输入工单标题",
    "ops.tickets.customerLabel": "客户 *",
    "ops.tickets.customerPlaceholder": "客户姓名或邮箱",
    "ops.tickets.category": "类别",
    "ops.tickets.selectCategory": "选择类别",
    "ops.tickets.catTechnical": "技术支持",
    "ops.tickets.catBilling": "账单",
    "ops.tickets.catGeneral": "一般咨询",
    "ops.tickets.catFeature": "功能请求",
    "ops.tickets.catBug": "缺陷报告",
    "ops.tickets.selectPriority": "选择优先级",
    "ops.tickets.prioLow": "低",
    "ops.tickets.prioMedium": "中",
    "ops.tickets.prioHigh": "高",
    "ops.tickets.prioUrgent": "紧急",
    "ops.tickets.prioCritical": "严重",
    "ops.tickets.descriptionLabel": "描述 *",
    "ops.tickets.descriptionPlaceholder": "描述问题或请求",
    "ops.tickets.createTicket": "创建工单",
    "ops.tickets.filterTickets": "筛选工单",
    "ops.tickets.filterTicketsDesc": "应用筛选条件以查找特定工单",
    "ops.tickets.selectStatus": "选择状态",
    "ops.tickets.allStatus": "全部状态",
    "ops.tickets.statusOpen": "待处理",
    "ops.tickets.statusInProgress": "处理中",
    "ops.tickets.statusResolved": "已解决",
    "ops.tickets.statusClosed": "已关闭",
    "ops.tickets.allPriorities": "全部优先级",
    "ops.tickets.applyFilters": "应用筛选",
    "ops.tickets.respondToTicket": "回复工单",
    "ops.tickets.respondDesc": "向 {customer} 发送回复",
    "ops.tickets.theCustomer": "客户",
    "ops.tickets.responseMessage": "回复消息",
    "ops.tickets.responsePlaceholder": "在此输入您的回复…",
    "ops.tickets.sendResponse": "发送回复",
    "ops.tickets.escalateTicket": "升级工单",
    "ops.tickets.escalateDesc": "将工单 #{id} 升级至高级支持",
    "ops.tickets.escalationReason": "升级原因",
    "ops.tickets.escalationReasonPlaceholder": "说明该工单为何需要升级…",
    "ops.tickets.searchTickets": "搜索工单…",
    "ops.tickets.tabAll": "全部",
    "ops.tickets.tabActive": "进行中",
    "ops.tickets.tabPending": "待处理",
    "ops.tickets.tabResolved": "已解决",
    "ops.tickets.showingMyQueue": "显示我的队列",
    "ops.tickets.myQueue": "我的队列",
    "ops.tickets.loadingTickets": "正在加载工单…",
    "ops.tickets.noTicketsFound": "未找到工单",
    "ops.tickets.adjustSearch": "请尝试调整您的搜索或筛选条件",
    "ops.tickets.newTicketsAppear": "新工单将在此显示",
    "ops.tickets.phone": "电话",
    "ops.tickets.assignedBy": "分配人",
    "ops.tickets.created": "创建时间：",
    "ops.tickets.updated": "更新时间：",
    "ops.tickets.acceptedBy": "受理人：",
    "ops.tickets.resolvedBy": "解决人：",
    "ops.tickets.reassignedBy": "重新分配人：",
    "ops.tickets.assignedAt": "分配时间：",
    "ops.tickets.loadingConversation": "正在加载对话…",
    "ops.tickets.noMessages": "暂无消息",
    "ops.tickets.noConvHistory": "未找到该工单的对话历史。",
    "ops.tickets.selectTicket": "选择一张工单",
    "ops.tickets.clickTicketLoad": "点击一张工单以加载其对话历史。",
    "ops.tickets.respond": "回复",
    "ops.tickets.escalate": "升级",
    "ops.tickets.markResolved": "标记为已解决",
    "ops.tickets.accept": "受理",
    "ops.tickets.reassign": "重新分配",
    "ops.tickets.deleteGuest": "删除访客",
    "ops.tickets.chooseTicketRespond": "从列表中选择一张工单以查看详情并回复",
    "ops.tickets.reassignTicket": "重新分配工单",
    "ops.tickets.reassignDesc": "{id} —— 将此工单转交给另一名在线坐席。",
    "ops.tickets.reassignTo": "重新分配给",
    "ops.tickets.reasonOptional": "原因（可选）",
    "ops.tickets.reassignReasonPlaceholder": "您为何要重新分配此工单？",
    "ops.tickets.assignTicket": "分配工单",
    "ops.tickets.assignDesc": "{id} —— 选择一名坐席以分配此工单。",
    "ops.tickets.assignToLabel": "分配给",
    "ops.tickets.noOperatorsTenant": "此租户中未找到坐席",
    "ops.tickets.noTicketId": "无工单 ID",
    "ops.tickets.noTicketIdCreate": "此对话没有持久化的工单。请先通过“新建工单”创建工单。",
    "ops.tickets.noTicketAccept": "无法受理——此对话未关联持久化工单。",
    "ops.tickets.noTicketDelete": "无法删除——此对话未关联持久化工单。",
    "ops.tickets.noTicketLinked": "此对话未关联持久化工单。",
    "ops.tickets.selectAnOperator": "选择一名坐席",
    "ops.tickets.chooseStaffAssign": "选择一名员工以分配此工单。",
    "ops.tickets.ticketAssigned": "工单已分配",
    "ops.tickets.ticketAssignedDesc": "工单已分配。",
    "ops.tickets.assignFailed": "分配失败",
    "ops.tickets.ticketAccepted": "工单已受理",
    "ops.tickets.ticketAcceptedDesc": "状态已更新为处理中。",
    "ops.tickets.acceptFailed": "受理失败",
    "ops.tickets.deleteConfirm": "删除无效的访客工单 {tid}？关联的对话历史将被保留。",
    "ops.tickets.ticketDeleted": "工单已删除",
    "ops.tickets.ticketDeletedDesc": "工单 {tid} 已移除。",
    "ops.tickets.deleteFailed": "删除失败",
    "ops.tickets.selectOperatorTitle": "选择坐席",
    "ops.tickets.chooseOperatorReassign": "选择一名坐席以重新分配此工单。",
    "ops.tickets.ticketReassigned": "工单已重新分配",
    "ops.tickets.ticketReassignedDesc": "工单已重新分配。",
    "ops.tickets.reassignFailed": "重新分配失败",
    "ops.tickets.ticketCreated": "工单已创建",
    "ops.tickets.ticketCreatedDesc": "支持工单创建成功",
    "ops.tickets.failedCreate": "创建工单失败",
    "ops.tickets.emptyMessage": "消息为空",
    "ops.tickets.enterResponse": "请输入回复消息",
    "ops.tickets.responseSent": "回复已发送",
    "ops.tickets.messageSentSuccess": "消息发送成功",
    "ops.tickets.failedSendResponse": "回复发送失败",
    "ops.tickets.reasonRequired": "需要填写原因",
    "ops.tickets.provideEscReason": "请提供升级原因",
    "ops.tickets.ticketEscalated": "工单已升级",
    "ops.tickets.ticketEscalatedDesc": "工单已升级至高级支持",
    "ops.tickets.failedEscalate": "工单升级失败",
    "ops.tickets.ticketResolved": "工单已解决",
    "ops.tickets.ticketResolvedDesc": "工单已标记为已解决",
    "ops.tickets.failedResolve": "解决工单失败",
    "ops.tickets.failedLoadTickets": "加载工单失败。请重试。",
    "ops.tickets.noConvLinked": "此工单未关联对话。",
    "ops.tickets.emailResolved": "邮箱已解析",
    "ops.tickets.composingTo": "正在撰写发往 {email} 的消息",
    "ops.esc.pendingBadge": "{count} 项待处理",
    "ops.esc.escalationDetail": "升级详情",
    "ops.esc.intent": "意图",
    "ops.esc.escalationReason": "升级原因",
    "ops.esc.contextSummary": "上下文摘要",
    "ops.esc.aiContextSummary": "AI 上下文摘要",
    "ops.esc.noContextSummary": "无可用的上下文摘要。",
    "ops.esc.convTicketId": "对话 / 工单 ID",
    "ops.esc.notAvailable": "不可用",
    "ops.esc.escalationId": "升级 ID",
    "ops.esc.callbackDue": "回访截止时间",
    "ops.esc.voiceTranscript": "语音转录",
    "ops.esc.loadingTranscript": "正在加载转录…",
    "ops.esc.noTranscript": "此会话没有可用的转录。",
    "ops.esc.call": "呼叫",
    "ops.esc.callHint": "发起 Twilio 呼叫并在对话中记录呼叫事件",
    "ops.esc.conversationThread": "对话会话",
    "ops.esc.loadingMessages": "正在加载消息…",
    "ops.esc.noMessagesYet": "暂无消息。在下方发送第一条消息。",
    "ops.esc.typeMessageCustomer": "输入发送给客户的消息…",
    "ops.esc.assignedToMe": "分配给我的",
    "ops.esc.callbacks": "回访",
    "ops.esc.badgeOperator": "坐席",
    "ops.esc.badgeManager": "经理",
    "ops.esc.badgeAdmin": "管理员",
    "ops.esc.noSummaryAvailable": "无可用摘要",
    "ops.esc.acceptHandle": "受理并处理",
    "ops.esc.viewDetails": "查看详情",
    "ops.esc.selectOperatorAssign": "选择要分配的坐席…",
    "ops.esc.noStaffAvailable": "无可用员工",
    "ops.esc.noPendingEsc": "无待处理的升级",
    "ops.esc.allHandledEfficiently": "所有对话都在高效处理中！",
    "ops.esc.noEscAssigned": "没有分配给您的升级",
    "ops.esc.noEscAssignedHelp": "管理员分配后，分配给您的升级将在此显示",
    "ops.esc.messageCustomer": "向客户发消息",
    "ops.esc.typeMessageEnter": "输入发送给客户的消息…（按 Enter 发送）",
    "ops.esc.noPendingCallbacks": "无待处理的回访",
    "ops.esc.overdue": "已逾期",
    "ops.esc.due": "截止",
    "ops.esc.claimCallback": "认领回访",
    "ops.esc.noResolvedYet": "暂无已解决的升级",
    "ops.esc.completedAppearHere": "已完成的升级将在此显示",
    "ops.esc.loadingEscalations": "正在加载升级…",
    "ops.esc.resolveEscalation": "解决升级",
    "ops.esc.resolveEscDesc": "记录解决方案。可选择提交至 Solution Bank 供经理审核——经批准的方案将用于训练 AI 助手。",
    "ops.esc.resolutionNotes": "解决备注 *",
    "ops.esc.submitToSolutionBank": "将解决方案提交至 Solution Bank 供审核",
    "ops.esc.approveBeforeAi": "经理或管理员必须先批准，AI 才能使用该解决方案。未经批准的提交绝不会被 AI Chat 或 AI Voice 使用。",
    "ops.esc.submitForReviewSuffix": " 并提交审核",
    "ops.esc.failedLoadEsc": "加载升级失败",
    "ops.esc.checkConnection": "请检查您的网络连接并重试。",
    "ops.esc.noConvLinkedTitle": "未关联对话",
    "ops.esc.noConvLinkedDesc": "此升级没有关联的对话。无法发送消息。",
    "ops.esc.messageSent": "消息已发送",
    "ops.esc.messageSentPush": "客户将通过推送通知收到您的消息。",
    "ops.esc.sendFailed": "发送失败",
    "ops.esc.failedSendMessage": "消息发送失败",
    "ops.esc.noLinkedConvEsc": "此升级没有关联的对话。",
    "ops.esc.cannotResolveEscId": "无法解析升级 ID",
    "ops.esc.cannotSelfAssign": "无法自行分配",
    "ops.esc.cannotSelfAssignDesc": "未能找到您的员工资料。请让管理员分配此升级。",
    "ops.esc.escAccepted": "升级已受理",
    "ops.esc.statusReceivingAttention": "状态：正在处理",
    "ops.esc.failedAcceptEsc": "受理升级失败",
    "ops.esc.escResolved": "升级已解决",
    "ops.esc.resolutionSubmitted": "解决方案已提交至 Solution Bank 供经理审核。",
    "ops.esc.statusResolved": "状态：已解决",
    "ops.esc.failedResolveEsc": "解决升级失败",
    "ops.esc.escAssigned": "升级已分配",
    "ops.esc.failedAssignEsc": "分配升级失败",
    "ops.esc.noEscId": "无升级 ID",
    "ops.esc.noEscIdDesc": "此记录没有有效的 ID。",
    "ops.ops.manageOperators": "管理坐席",
    "ops.ops.subtitle": "实时监控与绩效管理",
    "ops.ops.dashboard": "仪表盘",
    "ops.ops.realtime": "实时",
    "ops.ops.historical": "历史",
    "ops.ops.scheduleShifts": "排班",
    "ops.ops.shiftNotAvailable": "此版本暂不支持排班功能。",
    "ops.ops.shiftCreated": "班次已创建",
    "ops.ops.operator": "话务员",
    "ops.ops.certifications": "认证",
    "ops.ops.languages": "语言",
    "ops.ops.coachingNotes": "辅导记录",
    "ops.ops.coachingPurpose": "目的",
    "ops.ops.coachingSaved": "辅导记录已保存",
    "ops.ops.historicalMode": "历史模式",
    "ops.ops.noActivity": "暂无活动",
    "ops.ops.noCoaching": "暂无辅导记录",
    "ops.ops.noShifts": "暂无排班",
    "ops.ops.skillsSaved": "技能已保存",
    "ops.ops.queueSettings": "队列设置",
    "ops.ops.queueNotAvailable": "此版本暂不支持队列配置。",
    "ops.ops.onlineOperators": "在线坐席",
    "ops.ops.callsToday": "今日呼叫",
    "ops.ops.ticketsResolved": "已解决工单",
    "ops.ops.activeTickets": "进行中工单",
    "ops.ops.avgAht": "平均 AHT",
    "ops.ops.realtimeModeActive": "实时模式已启用——升级提醒将在此显示",
    "ops.ops.activeOperators": "活跃坐席",
    "ops.ops.noOperators": "此业务尚无坐席。",
    "ops.ops.loadingMetrics": "正在加载坐席指标…",
    "ops.ops.calls": "呼叫",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "选择一名坐席",
    "ops.ops.chooseOperator": "从列表中选择一名坐席，以查看详细绩效指标和实时监控",
    "ops.ops.kpis": "关键绩效指标",
    "ops.ops.avgHandleTime": "平均处理时长",
    "ops.ops.firstCallResolution": "首次呼叫解决率",
    "ops.ops.customerSatisfaction": "客户满意度",
    "ops.ops.callbackCompliance": "回访达成率",
    "ops.ops.todaysStats": "今日统计",
    "ops.ops.callsHandled": "已处理呼叫",
    "ops.ops.avgHandleTimeShort": "平均处理时长",
    "ops.ops.performance": "绩效",
    "ops.ops.liveActivity": "实时活动",
    "ops.ops.presence": "在线状态",
    "ops.ops.onCall": "通话中",
    "ops.ops.currentConversation": "当前对话",
    "ops.ops.lastActivity": "最近活动",
    "ops.ops.skills": "技能",
    "ops.ops.coaching": "辅导",
    "ops.ops.liveActivityNA": "实时活动监控尚未可用",
    "ops.ops.liveActivityNADesc": "实时呼叫 / 活动动态将在 Revision 2（OPEN_REVISION_2）中推出。",
    "ops.ops.skillsCerts": "技能与认证",
    "ops.ops.skillsNA": "尚未跟踪技能与认证",
    "ops.ops.skillsNADesc": "坐席技能 / 语言 / 认证将在 Revision 2（OPEN_REVISION_2）中推出。",
    "ops.ops.coachingDev": "辅导与发展",
    "ops.ops.coachingNA": "辅导与发展工具尚未可用——它们将在 Revision 2（OPEN_REVISION_2）中推出。",
    "ops.ops.scheduleCoaching": "安排辅导",
    "ops.ops.performanceReview": "绩效评估",
    "ops.ops.whisper": "耳语",
    "ops.ops.joinCall": "加入呼叫",
    "ops.ops.supervisionConnectingNotice": "正在连接监督…",
    "ops.ops.whisperActiveNotice": "耳语已开启 — 正在指导坐席。",
    "ops.ops.listeningNotice": "正在监听通话。",
    "ops.ops.stopSupervision": "停止监督",
    "ops.ops.whisperHint": "私下与坐席交谈，客户不会听到",
    "ops.ops.joinHint": "加入通话，让所有参与者都能听到您",
    "ops.ops.noActiveCall": "坐席没有正在进行的通话",
    "ops.ops.featureWhisper": "耳语监督（M11）",
    "ops.ops.featureBarge": "插话 / 加入呼叫（M11）",
    "ops.ops.notAvailableYet": "—— 尚未可用",
    "ops.ops.rev2Saved": "将在 Revision 2（OPEN_REVISION_2）中推出。未保存任何内容。",
    "ops.tm.subtitle": "全渠道工单，支持 SLA 管理与自动化",
  },
  ar: {
    "ops.common.missingInformation": "معلومات ناقصة",
    "ops.common.fillAllRequired": "يرجى تعبئة جميع الحقول المطلوبة",
    "ops.common.tryAgain": "حاول مرة أخرى",
    "ops.common.customer": "العميل",
    "ops.common.unassigned": "غير مُسنَد",
    "ops.common.aiAgent": "وكيل AI",
    "ops.common.status": "الحالة",
    "ops.common.priority": "الأولوية",
    "ops.common.assignedTo": "مُسنَد إلى",
    "ops.common.pending": "قيد الانتظار",
    "ops.common.resolved": "تم الحل",
    "ops.common.resolve": "حل",
    "ops.common.assign": "إسناد",
    "ops.common.view": "عرض",
    "ops.common.inProgress": "قيد المعالجة",
    "ops.common.you": "أنت",
    "ops.common.system": "النظام",
    "ops.common.agent": "الوكيل",
    "ops.common.cannotCall": "تعذّر الاتصال",
    "ops.common.callInitiated": "تم بدء الاتصال",
    "ops.common.callLogged": "تم تسجيل الاتصال",
    "ops.common.calling": "جارٍ الاتصال",
    "ops.common.callRecordedFor": "تم تسجيل الاتصال لـ",
    "ops.common.callFailed": "فشل الاتصال",
    "ops.common.callNow": "اتصل الآن",
    "ops.common.startingCall": "جارٍ بدء الاتصال…",
    "ops.esc.noConvForCallback": "لا توجد محادثة متاحة لإعادة الاتصال هذه",
    "ops.esc.cbDueSoon": "قريباً",
    "ops.esc.cbOverdue": "متأخرة",
    "ops.esc.cbScheduled": "مجدولة",
    "ops.esc.cbCompleted": "مكتملة",
    "ops.esc.cbCancelled": "ملغاة",
    "ops.esc.cbReminderTitle": "تذكير معاودة الاتصال",
    "ops.esc.cbDueSoonMsg": "معاودة الاتصال قريباً",
    "ops.common.describeResolution": "صف كيف تم حل هذه المشكلة...",
    "ops.common.selectOperator": "اختر المشغّل…",
    "ops.common.nameLabel": "الاسم:",
    "ops.common.emailLabel": "البريد الإلكتروني:",
    "ops.staff.subscriptionPlan": "خطة الاشتراك",
    "ops.staff.seatAllocation": "تخصيص المقاعد",
    "ops.staff.inviteStaffMembers": "دعوة أعضاء الفريق",
    "ops.staff.inviteDescPre": "ادعُ أعضاء الفريق عبر البريد الإلكتروني — يتلقّى كل شخص دعوة تحمل هويتك مع Brand ID الخاص بك",
    "ops.staff.inviteDescMid": "ورابط لإكمال التسجيل الذاتي على",
    "ops.staff.inviteExpire": "تنتهي صلاحية الدعوات بعد 7 أيام.",
    "ops.staff.emailAddresses": "عناوين البريد الإلكتروني",
    "ops.staff.emailsPlaceholder": "أدخل عناوين البريد الإلكتروني مفصولة بفواصل أو فواصل منقوطة أو أسطر جديدة:",
    "ops.staff.validEmailsDetected": "تم اكتشاف {count} عنوان بريد إلكتروني صالح",
    "ops.staff.defaultRole": "الدور الافتراضي",
    "ops.staff.defaultRoleHelp": "سيتم إسناد هذا الدور افتراضيًا لجميع الأعضاء المدعوّين",
    "ops.staff.invitationPreview": "معاينة الدعوة",
    "ops.staff.operatorDefault": "مشغّل (افتراضي)",
    "ops.staff.sendingInvitations": "جارٍ إرسال الدعوات…",
    "ops.staff.sendInvitations": "إرسال {count} دعوة",
    "ops.staff.brandId": "Brand ID:",
    "ops.staff.teamMembersCount": "{count} من أعضاء الفريق",
    "ops.staff.totalStaff": "إجمالي الموظفين",
    "ops.staff.administrators": "المسؤولون",
    "ops.staff.operators": "المشغّلون",
    "ops.staff.otherRoles": "أدوار أخرى",
    "ops.staff.teamMembers": "أعضاء الفريق",
    "ops.staff.membersCount": "{count} عضو",
    "ops.staff.noTeamMembers": "لا يوجد أعضاء في الفريق",
    "ops.staff.noTeamMembersHelp": "ادعُ أعضاء الفريق للانضمام إلى فريق عملك",
    "ops.staff.inviteFirst": "دعوة أول عضو في الفريق",
    "ops.staff.changeRole": "تغيير الدور",
    "ops.staff.removeStaff": "إزالة الموظف",
    "ops.staff.regInstructions": "تعليمات تسجيل الموظفين",
    "ops.staff.forNewStaff": "لأعضاء الفريق الجدد:",
    "ops.staff.shareBrandId": "شارك Brand ID الخاص بك:",
    "ops.staff.directToReg": "وجّههم إلى صفحة تسجيل الموظفين",
    "ops.staff.assignedOperatorDefault": "سيتم إسناد دور \"مشغّل\" إليهم افتراضيًا",
    "ops.staff.updateRoleDropdown": "يمكنك تحديث دورهم باستخدام القائمة المنسدلة أعلاه",
    "ops.staff.registrationLink": "رابط التسجيل:",
    "ops.staff.changeRoleDesc": "تحديث دور {name}.",
    "ops.staff.thisStaffMember": "عضو الفريق هذا",
    "ops.staff.saving": "جارٍ الحفظ…",
    "ops.staff.saveRole": "حفظ الدور",
    "ops.staff.removeStaffMember": "إزالة عضو الفريق",
    "ops.staff.removeWarning": "سيؤدي هذا فورًا إلى إلغاء جميع صلاحيات الوصول إلى العمل لعضو الفريق هذا.",
    "ops.staff.securityImpact": "الأثر الأمني:",
    "ops.staff.impact1": "سيفقد جميع صلاحيات الوصول إلى العمل فورًا",
    "ops.staff.impact2a": "سيتم",
    "ops.staff.impact2b": "تعطيل",
    "ops.staff.impact2c": "حساب الموظف الخاص به وتحرير هاتفه من هذا العمل",
    "ops.staff.impact3": "سيتم تأمين جميع المحادثات السابقة الخاصة بالعمل وتصبح غير قابلة للوصول",
    "ops.staff.impact4": "لن يتمكن من الوصول إلى أي ملفات تعريف للموظفين أو بيانات العمل",
    "ops.staff.staffDetails": "تفاصيل الموظف:",
    "ops.staff.currentRole": "الدور الحالي:",
    "ops.staff.joinDate": "تاريخ الانضمام:",
    "ops.staff.noteLabel": "ملاحظة:",
    "ops.staff.removeNote": "لا يمكن التراجع عن هذا الإجراء. إذا رغبت في إعادة إضافة هذا الشخص لاحقًا، فسيحتاج إلى دعوة جديدة وإسناد دور جديد.",
    "ops.staff.removeRevoke": "إزالة وإلغاء الوصول",
    "ops.staff.descAdmin": "وصول كامل إلى جميع الميزات وإدارة الموظفين",
    "ops.staff.descOperator": "خدمة العملاء وإدارة التذاكر والاتصالات",
    "ops.staff.descManager": "الإشراف على الفريق وإعداد التقارير وإدارة Solution Bank",
    "ops.staff.descAnalyst": "تحليل البيانات وإعداد التقارير ومقاييس الأداء",
    "ops.staff.descDirector": "التخطيط الاستراتيجي والتحليلات عالية المستوى",
    "ops.staff.descExecutive": "الإشراف على العمل ولوحات المعلومات التنفيذية",
    "ops.staff.descIt": "الإدارة التقنية وتهيئة النظام",
    "ops.staff.enterOneEmail": "يرجى إدخال عنوان بريد إلكتروني واحد على الأقل",
    "ops.staff.invalidEmailFormat": "تنسيق بريد إلكتروني غير صالح",
    "ops.staff.enterValidEmails": "يرجى إدخال عناوين بريد إلكتروني صالحة",
    "ops.staff.invitationsSent": "تم إرسال الدعوات",
    "ops.staff.invitesSentDesc": "تم إرسال {sent} من أصل {total} رسالة دعوة بنجاح.",
    "ops.staff.invitesFailedSuffix": " فشل {failed} — تحقق من العناوين.",
    "ops.staff.noInvitationsSent": "لم يتم إرسال أي دعوات",
    "ops.staff.allInvitesFailed": "فشلت جميع الدعوات.",
    "ops.staff.failedToSendInvitations": "فشل إرسال الدعوات",
    "ops.staff.roleNotAvailable": "الدور غير متاح في خطتك",
    "ops.staff.roleNotAvailableDesc": "يتطلب {role} مستوى اشتراك أعلى. قم بالترقية للوصول إلى هذا الدور.",
    "ops.staff.roleUpdated": "تم تحديث الدور",
    "ops.staff.roleUpdatedDesc": "تم تحديث دور عضو الفريق إلى {role}",
    "ops.staff.roleUpdateFailed": "فشل تحديث الدور",
    "ops.staff.roleUpdateFailedDesc": "تعذّر تحديث الدور. يرجى المحاولة مرة أخرى.",
    "ops.staff.accessRevoked": "تم إلغاء وصول الموظف",
    "ops.staff.accessRevokedDesc": "تمت إزالة {name} من القائمة",
    "ops.staff.removalFailed": "فشلت الإزالة",
    "ops.staff.removalFailedDesc": "تعذّرت إزالة عضو الفريق. يرجى المحاولة مرة أخرى.",
    "ops.tickets.loadingBusinessData": "جارٍ تحميل بيانات العمل",
    "ops.tickets.loadingBusinessInfo": "يرجى الانتظار بينما نقوم بتحميل معلومات عملك.",
    "ops.tickets.createNewTicket": "إنشاء تذكرة جديدة",
    "ops.tickets.createTicketDesc": "إنشاء تذكرة دعم جديدة لعميل",
    "ops.tickets.titleLabel": "العنوان *",
    "ops.tickets.titlePlaceholder": "أدخل عنوان التذكرة",
    "ops.tickets.customerLabel": "العميل *",
    "ops.tickets.customerPlaceholder": "اسم العميل أو بريده الإلكتروني",
    "ops.tickets.category": "الفئة",
    "ops.tickets.selectCategory": "اختر الفئة",
    "ops.tickets.catTechnical": "الدعم الفني",
    "ops.tickets.catBilling": "الفوترة",
    "ops.tickets.catGeneral": "استفسار عام",
    "ops.tickets.catFeature": "طلب ميزة",
    "ops.tickets.catBug": "الإبلاغ عن خلل",
    "ops.tickets.selectPriority": "اختر الأولوية",
    "ops.tickets.prioLow": "منخفضة",
    "ops.tickets.prioMedium": "متوسطة",
    "ops.tickets.prioHigh": "عالية",
    "ops.tickets.prioUrgent": "عاجلة",
    "ops.tickets.prioCritical": "حرجة",
    "ops.tickets.descriptionLabel": "الوصف *",
    "ops.tickets.descriptionPlaceholder": "صف المشكلة أو الطلب",
    "ops.tickets.createTicket": "إنشاء التذكرة",
    "ops.tickets.filterTickets": "تصفية التذاكر",
    "ops.tickets.filterTicketsDesc": "طبّق عوامل التصفية للعثور على تذاكر محددة",
    "ops.tickets.selectStatus": "اختر الحالة",
    "ops.tickets.allStatus": "جميع الحالات",
    "ops.tickets.statusOpen": "مفتوحة",
    "ops.tickets.statusInProgress": "قيد المعالجة",
    "ops.tickets.statusResolved": "تم الحل",
    "ops.tickets.statusClosed": "مغلقة",
    "ops.tickets.allPriorities": "جميع الأولويات",
    "ops.tickets.applyFilters": "تطبيق عوامل التصفية",
    "ops.tickets.respondToTicket": "الرد على التذكرة",
    "ops.tickets.respondDesc": "إرسال رد إلى {customer}",
    "ops.tickets.theCustomer": "العميل",
    "ops.tickets.responseMessage": "رسالة الرد",
    "ops.tickets.responsePlaceholder": "اكتب ردك هنا...",
    "ops.tickets.sendResponse": "إرسال الرد",
    "ops.tickets.escalateTicket": "تصعيد التذكرة",
    "ops.tickets.escalateDesc": "تصعيد التذكرة رقم {id} إلى الدعم المتقدّم",
    "ops.tickets.escalationReason": "سبب التصعيد",
    "ops.tickets.escalationReasonPlaceholder": "اشرح سبب حاجة هذه التذكرة إلى التصعيد...",
    "ops.tickets.searchTickets": "البحث في التذاكر...",
    "ops.tickets.tabAll": "الكل",
    "ops.tickets.tabActive": "نشطة",
    "ops.tickets.tabPending": "قيد الانتظار",
    "ops.tickets.tabResolved": "تم الحل",
    "ops.tickets.showingMyQueue": "عرض قائمتي",
    "ops.tickets.myQueue": "قائمتي",
    "ops.tickets.loadingTickets": "جارٍ تحميل التذاكر...",
    "ops.tickets.noTicketsFound": "لم يتم العثور على تذاكر",
    "ops.tickets.adjustSearch": "حاول تعديل بحثك أو عوامل التصفية",
    "ops.tickets.newTicketsAppear": "ستظهر التذاكر الجديدة هنا",
    "ops.tickets.phone": "الهاتف",
    "ops.tickets.assignedBy": "أُسنِدت بواسطة",
    "ops.tickets.created": "تاريخ الإنشاء:",
    "ops.tickets.updated": "تاريخ التحديث:",
    "ops.tickets.acceptedBy": "قُبِلت بواسطة:",
    "ops.tickets.resolvedBy": "حُلّت بواسطة:",
    "ops.tickets.reassignedBy": "أُعيد إسنادها بواسطة:",
    "ops.tickets.assignedAt": "تاريخ الإسناد:",
    "ops.tickets.loadingConversation": "جارٍ تحميل المحادثة...",
    "ops.tickets.noMessages": "لا توجد رسائل",
    "ops.tickets.noConvHistory": "لم يتم العثور على سجل محادثة لهذه التذكرة.",
    "ops.tickets.selectTicket": "اختر تذكرة",
    "ops.tickets.clickTicketLoad": "انقر على تذكرة لتحميل سجل محادثتها.",
    "ops.tickets.respond": "الرد",
    "ops.tickets.escalate": "تصعيد",
    "ops.tickets.markResolved": "وضع علامة كمحلولة",
    "ops.tickets.accept": "قبول",
    "ops.tickets.reassign": "إعادة إسناد",
    "ops.tickets.deleteGuest": "حذف الضيف",
    "ops.tickets.chooseTicketRespond": "اختر تذكرة من القائمة لعرض التفاصيل والرد",
    "ops.tickets.reassignTicket": "إعادة إسناد التذكرة",
    "ops.tickets.reassignDesc": "{id} — انقل هذه التذكرة إلى مشغّل نشط آخر.",
    "ops.tickets.reassignTo": "إعادة الإسناد إلى",
    "ops.tickets.reasonOptional": "السبب (اختياري)",
    "ops.tickets.reassignReasonPlaceholder": "لماذا تعيد إسناد هذه التذكرة؟",
    "ops.tickets.assignTicket": "إسناد التذكرة",
    "ops.tickets.assignDesc": "{id} — اختر مشغّلاً لإسناد هذه التذكرة إليه.",
    "ops.tickets.assignToLabel": "إسناد إلى",
    "ops.tickets.noOperatorsTenant": "لم يتم العثور على مشغّلين في هذا المستأجر",
    "ops.tickets.noTicketId": "لا يوجد معرّف تذكرة",
    "ops.tickets.noTicketIdCreate": "لا تحتوي هذه المحادثة على تذكرة محفوظة. أنشئ تذكرة أولاً عبر تذكرة جديدة.",
    "ops.tickets.noTicketAccept": "تعذّر القبول — لا توجد تذكرة محفوظة مرتبطة بهذه المحادثة.",
    "ops.tickets.noTicketDelete": "تعذّر الحذف — لا توجد تذكرة محفوظة مرتبطة بهذه المحادثة.",
    "ops.tickets.noTicketLinked": "لا توجد تذكرة محفوظة مرتبطة بهذه المحادثة.",
    "ops.tickets.selectAnOperator": "اختر مشغّلاً",
    "ops.tickets.chooseStaffAssign": "اختر عضو فريق لإسناد هذه التذكرة إليه.",
    "ops.tickets.ticketAssigned": "تم إسناد التذكرة",
    "ops.tickets.ticketAssignedDesc": "تم إسناد التذكرة.",
    "ops.tickets.assignFailed": "فشل الإسناد",
    "ops.tickets.ticketAccepted": "تم قبول التذكرة",
    "ops.tickets.ticketAcceptedDesc": "تم تحديث الحالة إلى قيد المعالجة.",
    "ops.tickets.acceptFailed": "فشل القبول",
    "ops.tickets.deleteConfirm": "حذف تذكرة الضيف غير الصالحة {tid}؟ يتم الاحتفاظ بسجل المحادثة المرتبط.",
    "ops.tickets.ticketDeleted": "تم حذف التذكرة",
    "ops.tickets.ticketDeletedDesc": "تمت إزالة التذكرة {tid}.",
    "ops.tickets.deleteFailed": "فشل الحذف",
    "ops.tickets.selectOperatorTitle": "اختر المشغّل",
    "ops.tickets.chooseOperatorReassign": "اختر مشغّلاً لإعادة إسناد هذه التذكرة إليه.",
    "ops.tickets.ticketReassigned": "تمت إعادة إسناد التذكرة",
    "ops.tickets.ticketReassignedDesc": "تمت إعادة إسناد التذكرة.",
    "ops.tickets.reassignFailed": "فشلت إعادة الإسناد",
    "ops.tickets.ticketCreated": "تم إنشاء التذكرة",
    "ops.tickets.ticketCreatedDesc": "تم إنشاء تذكرة الدعم بنجاح",
    "ops.tickets.failedCreate": "فشل إنشاء التذكرة",
    "ops.tickets.emptyMessage": "رسالة فارغة",
    "ops.tickets.enterResponse": "يرجى إدخال رسالة رد",
    "ops.tickets.responseSent": "تم إرسال الرد",
    "ops.tickets.messageSentSuccess": "تم إرسال الرسالة بنجاح",
    "ops.tickets.failedSendResponse": "فشل إرسال الرد",
    "ops.tickets.reasonRequired": "السبب مطلوب",
    "ops.tickets.provideEscReason": "يرجى تقديم سبب للتصعيد",
    "ops.tickets.ticketEscalated": "تم تصعيد التذكرة",
    "ops.tickets.ticketEscalatedDesc": "تم تصعيد التذكرة إلى الدعم المتقدّم",
    "ops.tickets.failedEscalate": "فشل تصعيد التذكرة",
    "ops.tickets.ticketResolved": "تم حل التذكرة",
    "ops.tickets.ticketResolvedDesc": "تم وضع علامة على التذكرة كمحلولة",
    "ops.tickets.failedResolve": "فشل حل التذكرة",
    "ops.tickets.failedLoadTickets": "فشل تحميل التذاكر. يرجى المحاولة مرة أخرى.",
    "ops.tickets.noConvLinked": "لا توجد محادثة مرتبطة بهذه التذكرة.",
    "ops.tickets.emailResolved": "تم تحديد البريد الإلكتروني",
    "ops.tickets.composingTo": "جارٍ كتابة رسالة إلى {email}",
    "ops.esc.pendingBadge": "{count} قيد الانتظار",
    "ops.esc.escalationDetail": "تفاصيل التصعيد",
    "ops.esc.intent": "النية",
    "ops.esc.escalationReason": "سبب التصعيد",
    "ops.esc.contextSummary": "ملخص السياق",
    "ops.esc.aiContextSummary": "ملخص سياق AI",
    "ops.esc.noContextSummary": "لا يتوفر ملخص للسياق.",
    "ops.esc.convTicketId": "معرّف المحادثة / التذكرة",
    "ops.esc.notAvailable": "غير متاح",
    "ops.esc.escalationId": "معرّف التصعيد",
    "ops.esc.callbackDue": "موعد معاودة الاتصال",
    "ops.esc.voiceTranscript": "نص المكالمة الصوتية",
    "ops.esc.loadingTranscript": "جارٍ تحميل النص…",
    "ops.esc.noTranscript": "لا يتوفر نص لهذه الجلسة.",
    "ops.esc.call": "اتصال",
    "ops.esc.callHint": "يبدأ مكالمة Twilio ويسجّل حدث المكالمة في المحادثة",
    "ops.esc.conversationThread": "سلسلة المحادثة",
    "ops.esc.loadingMessages": "جارٍ تحميل الرسائل…",
    "ops.esc.noMessagesYet": "لا توجد رسائل بعد. أرسل الرسالة الأولى أدناه.",
    "ops.esc.typeMessageCustomer": "اكتب رسالة إلى العميل…",
    "ops.esc.assignedToMe": "مُسنَد إليّ",
    "ops.esc.callbacks": "معاودات الاتصال",
    "ops.esc.badgeOperator": "مشغّل",
    "ops.esc.badgeManager": "مدير",
    "ops.esc.badgeAdmin": "مسؤول",
    "ops.esc.noSummaryAvailable": "لا يتوفر ملخص",
    "ops.esc.acceptHandle": "قبول ومعالجة",
    "ops.esc.viewDetails": "عرض التفاصيل",
    "ops.esc.selectOperatorAssign": "اختر مشغّلاً للإسناد…",
    "ops.esc.noStaffAvailable": "لا يوجد موظفون متاحون",
    "ops.esc.noPendingEsc": "لا توجد تصعيدات قيد الانتظار",
    "ops.esc.allHandledEfficiently": "تتم معالجة جميع المحادثات بكفاءة!",
    "ops.esc.noEscAssigned": "لا توجد تصعيدات مُسنَدة إليك",
    "ops.esc.noEscAssignedHelp": "ستظهر التصعيدات المُسنَدة إليك هنا بمجرد أن يقوم المسؤول بإسنادها",
    "ops.esc.messageCustomer": "مراسلة العميل",
    "ops.esc.typeMessageEnter": "اكتب رسالة إلى العميل… (اضغط Enter للإرسال)",
    "ops.esc.noPendingCallbacks": "لا توجد معاودات اتصال قيد الانتظار",
    "ops.esc.overdue": "متأخرة",
    "ops.esc.due": "المستحقة",
    "ops.esc.claimCallback": "المطالبة بمعاودة الاتصال",
    "ops.esc.noResolvedYet": "لا توجد تصعيدات محلولة بعد",
    "ops.esc.completedAppearHere": "ستظهر التصعيدات المكتملة هنا",
    "ops.esc.loadingEscalations": "جارٍ تحميل التصعيدات...",
    "ops.esc.resolveEscalation": "حل التصعيد",
    "ops.esc.resolveEscDesc": "وثّق الحل. يمكنك اختياريًا إرساله إلى Solution Bank لمراجعة المدير — الحلول المعتمدة تدرّب مساعد AI.",
    "ops.esc.resolutionNotes": "ملاحظات الحل *",
    "ops.esc.submitToSolutionBank": "إرسال الحل إلى Solution Bank للمراجعة",
    "ops.esc.approveBeforeAi": "يجب أن يوافق مدير أو مسؤول قبل أن يتمكن AI من استخدام هذا الحل. لا تُستخدم الإرساليات غير المعتمدة أبدًا في AI Chat أو AI Voice.",
    "ops.esc.submitForReviewSuffix": " وإرسال للمراجعة",
    "ops.esc.failedLoadEsc": "فشل تحميل التصعيدات",
    "ops.esc.checkConnection": "تحقق من اتصالك وحاول مرة أخرى.",
    "ops.esc.noConvLinkedTitle": "لا توجد محادثة مرتبطة",
    "ops.esc.noConvLinkedDesc": "لا يحتوي هذا التصعيد على محادثة مرتبطة. تعذّر إرسال الرسالة.",
    "ops.esc.messageSent": "تم إرسال الرسالة",
    "ops.esc.messageSentPush": "سيتلقّى العميل رسالتك عبر إشعار فوري.",
    "ops.esc.sendFailed": "فشل الإرسال",
    "ops.esc.failedSendMessage": "فشل إرسال الرسالة",
    "ops.esc.noLinkedConvEsc": "لا توجد محادثة مرتبطة بهذا التصعيد.",
    "ops.esc.cannotResolveEscId": "تعذّر تحديد معرّف التصعيد",
    "ops.esc.cannotSelfAssign": "تعذّر الإسناد الذاتي",
    "ops.esc.cannotSelfAssignDesc": "تعذّر العثور على ملفك التعريفي كموظف. اطلب من مسؤول إسناد هذا التصعيد.",
    "ops.esc.escAccepted": "تم قبول التصعيد",
    "ops.esc.statusReceivingAttention": "الحالة: قيد المعالجة",
    "ops.esc.failedAcceptEsc": "فشل قبول التصعيد",
    "ops.esc.escResolved": "تم حل التصعيد",
    "ops.esc.resolutionSubmitted": "تم إرسال الحل إلى Solution Bank لمراجعة المدير.",
    "ops.esc.statusResolved": "الحالة: تم الحل",
    "ops.esc.failedResolveEsc": "فشل حل التصعيد",
    "ops.esc.escAssigned": "تم إسناد التصعيد",
    "ops.esc.failedAssignEsc": "فشل إسناد التصعيد",
    "ops.esc.noEscId": "لا يوجد معرّف تصعيد",
    "ops.esc.noEscIdDesc": "لا يحتوي هذا السجل على معرّف صالح.",
    "ops.ops.manageOperators": "إدارة المشغّلين",
    "ops.ops.subtitle": "المراقبة في الوقت الفعلي وإدارة الأداء",
    "ops.ops.dashboard": "لوحة المعلومات",
    "ops.ops.realtime": "الوقت الفعلي",
    "ops.ops.historical": "السجل التاريخي",
    "ops.ops.scheduleShifts": "جدولة المناوبات",
    "ops.ops.shiftNotAvailable": "جدولة المناوبات غير متاحة في هذا الإصدار.",
    "ops.ops.shiftCreated": "تم إنشاء الوردية",
    "ops.ops.operator": "المشغّل",
    "ops.ops.certifications": "الشهادات",
    "ops.ops.languages": "اللغات",
    "ops.ops.coachingNotes": "ملاحظات التدريب",
    "ops.ops.coachingPurpose": "الغرض",
    "ops.ops.coachingSaved": "تم حفظ جلسة التدريب",
    "ops.ops.historicalMode": "الوضع التاريخي",
    "ops.ops.noActivity": "لا يوجد نشاط",
    "ops.ops.noCoaching": "لا توجد جلسات تدريب",
    "ops.ops.noShifts": "لا توجد ورديات مجدولة",
    "ops.ops.skillsSaved": "تم حفظ المهارات",
    "ops.ops.queueSettings": "إعدادات قائمة الانتظار",
    "ops.ops.queueNotAvailable": "تهيئة قائمة الانتظار غير متاحة في هذا الإصدار.",
    "ops.ops.onlineOperators": "المشغّلون المتصلون",
    "ops.ops.callsToday": "المكالمات اليوم",
    "ops.ops.ticketsResolved": "التذاكر المحلولة",
    "ops.ops.activeTickets": "التذاكر النشطة",
    "ops.ops.avgAht": "متوسط AHT",
    "ops.ops.realtimeModeActive": "وضع الوقت الفعلي نشط — ستظهر تنبيهات التصعيد هنا",
    "ops.ops.activeOperators": "المشغّلون النشطون",
    "ops.ops.noOperators": "لا يوجد مشغّلون في هذا العمل بعد.",
    "ops.ops.loadingMetrics": "جارٍ تحميل مقاييس المشغّل…",
    "ops.ops.calls": "المكالمات",
    "ops.ops.fcr": "FCR",
    "ops.ops.selectAnOperator": "اختر مشغّلاً",
    "ops.ops.chooseOperator": "اختر مشغّلاً من القائمة لعرض مقاييس الأداء التفصيلية والمراقبة في الوقت الفعلي",
    "ops.ops.kpis": "مؤشرات الأداء الرئيسية",
    "ops.ops.avgHandleTime": "متوسط وقت المعالجة",
    "ops.ops.firstCallResolution": "الحل من أول مكالمة",
    "ops.ops.customerSatisfaction": "رضا العملاء",
    "ops.ops.callbackCompliance": "الالتزام بمعاودة الاتصال",
    "ops.ops.todaysStats": "إحصائيات اليوم",
    "ops.ops.callsHandled": "المكالمات المُعالَجة",
    "ops.ops.avgHandleTimeShort": "متوسط وقت المعالجة",
    "ops.ops.performance": "الأداء",
    "ops.ops.liveActivity": "النشاط المباشر",
    "ops.ops.presence": "الحضور",
    "ops.ops.onCall": "في مكالمة",
    "ops.ops.currentConversation": "المحادثة الحالية",
    "ops.ops.lastActivity": "آخر نشاط",
    "ops.ops.skills": "المهارات",
    "ops.ops.coaching": "التدريب",
    "ops.ops.liveActivityNA": "مراقبة النشاط المباشر غير متاحة بعد",
    "ops.ops.liveActivityNADesc": "يصل بث المكالمات / النشاط في الوقت الفعلي في الإصدار 2 (OPEN_REVISION_2).",
    "ops.ops.skillsCerts": "المهارات والشهادات",
    "ops.ops.skillsNA": "لا يتم تتبّع المهارات والشهادات بعد",
    "ops.ops.skillsNADesc": "تصل مهارات / لغات / شهادات المشغّل في الإصدار 2 (OPEN_REVISION_2).",
    "ops.ops.coachingDev": "التدريب والتطوير",
    "ops.ops.coachingNA": "أدوات التدريب والتطوير غير متاحة بعد — تصل في الإصدار 2 (OPEN_REVISION_2).",
    "ops.ops.scheduleCoaching": "جدولة التدريب",
    "ops.ops.performanceReview": "مراجعة الأداء",
    "ops.ops.whisper": "الهمس",
    "ops.ops.joinCall": "الانضمام إلى المكالمة",
    "ops.ops.supervisionConnectingNotice": "جارٍ الاتصال بالإشراف…",
    "ops.ops.whisperActiveNotice": "الهمس نشط — توجيه المشغّل.",
    "ops.ops.listeningNotice": "الاستماع إلى المكالمة.",
    "ops.ops.stopSupervision": "إيقاف الإشراف",
    "ops.ops.whisperHint": "تحدّث مع المشغّل بشكل خاص دون أن يسمعك العميل",
    "ops.ops.joinHint": "انضم إلى المكالمة حتى يتمكن جميع المشاركين من سماعك",
    "ops.ops.noActiveCall": "لا توجد مكالمة نشطة لدى المشغّل",
    "ops.ops.featureWhisper": "الإشراف بالهمس (M11)",
    "ops.ops.featureBarge": "المقاطعة / الانضمام إلى المكالمة (M11)",
    "ops.ops.notAvailableYet": "— غير متاح بعد",
    "ops.ops.rev2Saved": "يصل في الإصدار 2 (OPEN_REVISION_2). لم يتم حفظ أي شيء.",
    "ops.tm.subtitle": "نظام تذاكر متعدد القنوات مع إدارة SLA والأتمتة",
  },
};

export default opsTranslations;
